webpackJsonp([1],{

/***/ "+bwR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");





var Auth = {

    endpoint: 'Users',

    login: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(credentials) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api._post(this.endpoint, credentials);

                        case 2:
                            return _context.abrupt('return', _context.sent);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function login(_x) {
            return _ref.apply(this, arguments);
        }

        return login;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = (Auth);

/***/ }),

/***/ "/FOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"fluid":""}},[_c('b-modal',{attrs:{"id":"deleteNews","title":"DELETE NEW"},on:{"ok":_vm.DeleteNews}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("Do you want to delete this New ?")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/MEH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "07LI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"fluid":""}},[_c('b-modal',{attrs:{"scrollable":"","id":"createRss","size":"xl","title":"Create RSS Source"},on:{"cancel":_vm.resetFields,"ok":_vm.createUrlSouce}},[(_vm.isSimple)?_c('div',{staticClass:"isSimple"},[_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Reference:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the reference source"},model:{value:(_vm.SourceRss.c_u_ReferenceSource),callback:function ($$v) {_vm.$set(_vm.SourceRss, "c_u_ReferenceSource", $$v)},expression:"SourceRss.c_u_ReferenceSource"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Status:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.statusOptions},model:{value:(_vm.SourceRss.c_u_Status),callback:function ($$v) {_vm.$set(_vm.SourceRss, "c_u_Status", $$v)},expression:"SourceRss.c_u_Status"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Regularity:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.regularityOptions},model:{value:(_vm.SourceRss.c_u_Regularity),callback:function ($$v) {_vm.$set(_vm.SourceRss, "c_u_Regularity", $$v)},expression:"SourceRss.c_u_Regularity"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.clicked),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Url:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the url"},model:{value:(_vm.urlArray[item - 1].url),callback:function ($$v) {_vm.$set(_vm.urlArray[item - 1], "url", $$v)},expression:"urlArray[item - 1].url"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Priority:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.urlArray[item - 1].priority),callback:function ($$v) {_vm.$set(_vm.urlArray[item - 1], "priority", $$v)},expression:"urlArray[item - 1].priority"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other url'),expression:"'Add other url'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addUrlDiv(_vm.clicked)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Query XPATH:")])]),_vm._v(" "),_c('b-col',[_c('b-form-textarea',{attrs:{"id":"textarea","placeholder":"Enter the query...","rows":"3"},model:{value:(_vm.urlParameters1),callback:function ($$v) {_vm.urlParameters1=$$v},expression:"urlParameters1"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11 text-center"}},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-rss-2",modifiers:{"modal-rss-2":true}}],attrs:{"variant":"outline-primary","size":"sm"}},[_vm._v("News Configuration")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isSimple == false)?_c('div',{staticClass:"isSimple"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',[_c('b-form-textarea',{attrs:{"id":"textarea-large","rows":"12","size":"sm"},model:{value:(_vm.advancedXML),callback:function ($$v) {_vm.advancedXML=$$v},expression:"advancedXML"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"advance",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.advancedMode(_vm.isSimple)}}},[_vm._v("Advanced Mode")])],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-rss-2","size":"lg","title":"News Configuration"},on:{"cancel":_vm.resetFields,"ok":_vm.createXml2}},[(_vm.isSimple2)?_c('div',{staticClass:"isSimple2"},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Title")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivTitle),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.titleArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.titleArray[item - 1], "query", $$v)},expression:"titleArray[item - 1].query"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.titleArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.titleArray[item - 1], "confidenceLevel", $$v)},expression:"titleArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other Query'),expression:"'Add other Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addTitleDiv(_vm.addDivTitle)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Resume")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivResume),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.resumeArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.resumeArray[item - 1], "query", $$v)},expression:"resumeArray[item - 1].query"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.resumeArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.resumeArray[item - 1], "confidenceLevel", $$v)},expression:"resumeArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other Query'),expression:"'Add other Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addResumeDiv(_vm.addDivResume)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Image")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivImage),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.imageArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "query", $$v)},expression:"imageArray[item - 1].query"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.imageArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "confidenceLevel", $$v)},expression:"imageArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other Query'),expression:"'Add other Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addImageDiv(_vm.addDivImage)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Text")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivText),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.textArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.textArray[item - 1], "query", $$v)},expression:"textArray[item - 1].query"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.confidenceOptions},model:{value:(_vm.textArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.textArray[item - 1], "confidenceLevel", $$v)},expression:"textArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other Query'),expression:"'Add other Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addTextDiv(_vm.addDivText)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Remove")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivRemove),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Reference :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.removeOptions},model:{value:(_vm.removeArray[item - 1].reference),callback:function ($$v) {_vm.$set(_vm.removeArray[item - 1], "reference", $$v)},expression:"removeArray[item - 1].reference"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.removeArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.removeArray[item - 1], "query", $$v)},expression:"removeArray[item - 1].query"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other Query'),expression:"'Add other Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addRemoveDiv(_vm.addDivRemove)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isSimple2 == false)?_c('div',{staticClass:"isSimple2"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',[_c('b-form-textarea',{attrs:{"id":"textarea-large","rows":"12","size":"sm"},model:{value:(_vm.advancedXML2),callback:function ($$v) {_vm.advancedXML2=$$v},expression:"advancedXML2"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"advance2",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.advancedMode2(_vm.isSimple2)}}},[_vm._v("Advanced Mode")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Z+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsEdit_vue__ = __webpack_require__("qiya");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a7ae35c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsEdit_vue__ = __webpack_require__("miIm");
function injectStyle (ssrContext) {
  __webpack_require__("LzW6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a7ae35c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a7ae35c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1HPF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




var Data = {

   endpoint: '',

   find: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
               switch (_context.prev = _context.next) {
                  case 0:
                     _context.next = 2;
                     return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api._get(this.endpoint);

                  case 2:
                     return _context.abrupt('return', _context.sent);

                  case 3:
                  case 'end':
                     return _context.stop();
               }
            }
         }, _callee, this);
      }));

      function find() {
         return _ref.apply(this, arguments);
      }

      return find;
   }(),

   findOneById: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
               switch (_context2.prev = _context2.next) {
                  case 0:
                     _context2.next = 2;
                     return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api._get(this.endpoint + '/' + id);

                  case 2:
                     return _context2.abrupt('return', _context2.sent);

                  case 3:
                  case 'end':
                     return _context2.stop();
               }
            }
         }, _callee2, this);
      }));

      function findOneById(_x) {
         return _ref2.apply(this, arguments);
      }

      return findOneById;
   }(),

   create: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(payload) {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
               switch (_context3.prev = _context3.next) {
                  case 0:
                     _context3.next = 2;
                     return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api._post(this.endpoint, payload);

                  case 2:
                     return _context3.abrupt('return', _context3.sent);

                  case 3:
                  case 'end':
                     return _context3.stop();
               }
            }
         }, _callee3, this);
      }));

      function create(_x2) {
         return _ref3.apply(this, arguments);
      }

      return create;
   }(),

   create2: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(payload) {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
               switch (_context4.prev = _context4.next) {
                  case 0:
                     _context4.next = 2;
                     return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api._post2(this.endpoint, payload);

                  case 2:
                     return _context4.abrupt('return', _context4.sent);

                  case 3:
                  case 'end':
                     return _context4.stop();
               }
            }
         }, _callee4, this);
      }));

      function create2(_x3) {
         return _ref4.apply(this, arguments);
      }

      return create2;
   }(),

   destroyById: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
               switch (_context5.prev = _context5.next) {
                  case 0:
                     _context5.next = 2;
                     return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api._delete(this.endpoint + '/' + id);

                  case 2:
                     return _context5.abrupt('return', _context5.sent);

                  case 3:
                  case 'end':
                     return _context5.stop();
               }
            }
         }, _callee5, this);
      }));

      function destroyById(_x4) {
         return _ref5.apply(this, arguments);
      }

      return destroyById;
   }(),

   updatedById: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id, payload) {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
               switch (_context6.prev = _context6.next) {
                  case 0:
                     _context6.next = 2;
                     return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api._patch(this.endpoint + '/' + id, payload);

                  case 2:
                     return _context6.abrupt('return', _context6.sent);

                  case 3:
                  case 'end':
                     return _context6.stop();
               }
            }
         }, _callee6, this);
      }));

      function updatedById(_x5, _x6) {
         return _ref6.apply(this, arguments);
      }

      return updatedById;
   }(),

   update: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(payload) {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
               switch (_context7.prev = _context7.next) {
                  case 0:
                     _context7.next = 2;
                     return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api._patch('' + this.endpoint, payload);

                  case 2:
                     return _context7.abrupt('return', _context7.sent);

                  case 3:
                  case 'end':
                     return _context7.stop();
               }
            }
         }, _callee7, this);
      }));

      function update(_x7) {
         return _ref7.apply(this, arguments);
      }

      return update;
   }(),

   uploadImageById: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(id, payload) {
         return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
            while (1) {
               switch (_context8.prev = _context8.next) {
                  case 0:
                     _context8.next = 2;
                     return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$api.uploadImage(this.endpoint + '/' + id, payload);

                  case 2:
                     return _context8.abrupt('return', _context8.sent);

                  case 3:
                  case 'end':
                     return _context8.stop();
               }
            }
         }, _callee8, this);
      }));

      function uploadImageById(_x8, _x9) {
         return _ref8.apply(this, arguments);
      }

      return uploadImageById;
   }()
};

/* harmony default export */ __webpack_exports__["a"] = (Data);

/***/ }),

/***/ "1nRB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3qhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsEdition container-fluid"},[_c('div',{staticClass:"newsEditionFirst"},[_c('b-row',{staticClass:"sections"},[_c('b-col',{staticStyle:{"height":"100vh"},attrs:{"sm":"2"}},[_c('b-col',{staticStyle:{"margin-bottom":"45px"}},[_c('img',{attrs:{"src":__webpack_require__("7Otq")}})]),_vm._v(" "),_c('b-col',{staticClass:"section1Title"},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"4"}},[_vm._v("Fontes")]),_vm._v(" "),_c('b-col',{staticClass:"createDiv",attrs:{"sm":"8"}},[_c('b-button',{staticClass:"createBtn createBtnFonte",on:{"click":function($event){return _vm.showData()}}},[_vm._v("Atualizar SRC")])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section1"},[_c('b-form-checkbox',{staticStyle:{"margin-bottom":"20px"},attrs:{"value":"1","unchecked-value":"0"},model:{value:(_vm.isFiltered),callback:function ($$v) {_vm.isFiltered=$$v},expression:"isFiltered"}},[_vm._v("Mostrar fontes com noticias por editar")]),_vm._v(" "),_c('b-col',{staticClass:"contentOfSection1"},_vm._l((_vm.filteredSourceArray),function(source,index){return _c('b-row',{key:source.c_id},[_c('b-col',{attrs:{"sm":"10"}},[_c('p',{staticClass:"section1Name",on:{"click":function($event){return _vm.clickedEvent(index, source.c_u_ReferenceSource)}}},[_vm._v("\n                  "+_vm._s(source.c_u_ReferenceSource)+"\n                  "),_c('span',[_vm._v("["+_vm._s(_vm.newsForLength[source.c_id].totalOfNumber)+"]")])])]),_vm._v(" "),(source.c_u_Status == 1)?_c('b-row',{attrs:{"sm":"1"}},[(_vm.newsForLength[source.c_id].isTrue)?_c('fa',{staticStyle:{"color":"#d1d6a3","margin-right":"4px"},attrs:{"icon":['fas', 'clipboard-check'],"size":"1x"}}):_vm._e(),_vm._v(" "),(source.c_u_PublishType == 2)?_c('fa',{staticStyle:{"color":"rgb(24, 65, 77)","margin-right":"4px"},attrs:{"icon":['fab', 'adn'],"size":"1x"}}):_vm._e(),_vm._v(" "),_c('fa',{staticStyle:{"color":"green"},attrs:{"icon":['fas', 'check-circle'],"size":"1x"}})],1):_vm._e(),_vm._v(" "),(source.c_u_Status == -1)?_c('b-col',{attrs:{"sm":"1"}},[_c('fa',{staticStyle:{"color":"red"},attrs:{"icon":['fas', 'times-circle'],"size":"1x"}})],1):_vm._e()],1)}),1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"everySection",staticStyle:{"height":"100%"},attrs:{"sm":"10"}},[_c('b-row',{staticClass:"navBar"},[_c('b-col',{staticClass:"text-center navbar1",on:{"click":function($event){return _vm.$router.push({ name: 'Home' })}}},[_c('a',[_vm._v("Dashboard")])]),_vm._v(" "),_c('b-col',{staticClass:"navbar2",on:{"click":function($event){return _vm.$router.push({ name: 'NewsEdition' })}}},[_c('a',[_vm._v("Noticias")])]),_vm._v(" "),_c('b-col',{staticClass:"navbar3"},[_c('div',{staticClass:"dropdown"},[_c('span',[_vm._v("Configurações")]),_vm._v(" "),_c('div',{staticClass:"dropdown-content"},[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'SourceMain' })}}},[_vm._v("Fonte")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'ThemeWords' })}}},[_vm._v("Theme Words")])])])]),_vm._v(" "),_c('b-col',{staticClass:"navbar4",on:{"click":function($event){return _vm.$router.push({ name: 'OperationLog' })}}},[_c('a',[_vm._v("Relatorio Logs/Erros")])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"resize",rawName:"v-resize"}],staticClass:"sectionsFilters",attrs:{"id":"filtersHeightSize"},on:{"resize":_vm.onResize}},[_c('b-col',[_c('b-row',[_c('div',{staticClass:"filters"},[_c('p',[_vm._v("Filtros")])]),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Fonte")])]),_vm._v(" "),_c('b-col',[_c('v-select',{attrs:{"multiple":"","options":_vm.optionsFilterSource,"label":"item","reduce":function (item) { return item.code; }},model:{value:(_vm.selectedFilterSource),callback:function ($$v) {_vm.selectedFilterSource=$$v},expression:"selectedFilterSource"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Tipo")])]),_vm._v(" "),_c('b-col',[_c('v-select',{attrs:{"options":_vm.optionsTypeNews,"label":"type","reduce":function (type) { return type.code; }},model:{value:(_vm.selectedFilterType),callback:function ($$v) {_vm.selectedFilterType=$$v},expression:"selectedFilterType"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Tematica")])]),_vm._v(" "),_c('b-col',[_c('v-select',{attrs:{"options":_vm.optionsFilterTheme,"id":"themeDropDown","label":"theme","reduce":function (theme) { return theme.code; }},model:{value:(_vm.selectedFilterTheme),callback:function ($$v) {_vm.selectedFilterTheme=$$v},expression:"selectedFilterTheme"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Data de inicio")]),_vm._v(" "),_c('b-form-input',{staticStyle:{"height":"34.65px"},attrs:{"type":"date","size":"sm"},model:{value:(_vm.filtersDates.startDate),callback:function ($$v) {_vm.$set(_vm.filtersDates, "startDate", $$v)},expression:"filtersDates.startDate"}})],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Data de fim")]),_vm._v(" "),_c('b-form-input',{staticStyle:{"height":"34.65px"},attrs:{"type":"date","size":"sm"},model:{value:(_vm.filtersDates.endDate),callback:function ($$v) {_vm.$set(_vm.filtersDates, "endDate", $$v)},expression:"filtersDates.endDate"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0px 2px"},attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Estado")])]),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('v-select',{attrs:{"options":_vm.optionsStatus,"label":"status","reduce":function (status) { return status.code; }},model:{value:(_vm.selectedFilterStatus),callback:function ($$v) {_vm.selectedFilterStatus=$$v},expression:"selectedFilterStatus"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Utilizador")])]),_vm._v(" "),_c('b-col',[_c('v-select',{attrs:{"options":_vm.filtersUsers,"id":"usersDropDown","label":"name","reduce":function (name) { return name.id; }},model:{value:(_vm.selectedFilterUsers),callback:function ($$v) {_vm.selectedFilterUsers=$$v},expression:"selectedFilterUsers"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"textBtn",staticStyle:{"padding":"0px 2px"}},[_c('b-col',{staticStyle:{"padding":"0px 2px"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Texto")]),_vm._v(" "),_c('b-form-input',{staticStyle:{"width":"140px","height":"34.65px"},attrs:{"size":"sm"},model:{value:(_vm.filteredText),callback:function ($$v) {_vm.filteredText=$$v},expression:"filteredText"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"btnClear",attrs:{"sm":"1"}},[_c('b-button',{staticClass:"btnFilters",staticStyle:{"background-color":"white","color":"black"},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("Limpar")])],1),_vm._v(" "),_c('b-col',{staticClass:"btnSearch",staticStyle:{"margin-right":"25px","padding":"0px"},attrs:{"sm":"1"}},[_c('b-button',{staticClass:"btnFilters",staticStyle:{"background-color":"#428bac"},on:{"click":function($event){return _vm.filterData()}}},[_vm._v("Pesquisar")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"ifLowWidth",staticStyle:{"display":"none"}},[_c('b-col',{staticClass:"d-flex justify-content-end",staticStyle:{"margin-right":"10px"}},[_c('b-button',{staticClass:"btnFilters",staticStyle:{"background-color":"white","color":"black"},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("Limpar")])],1),_vm._v(" "),_c('b-col',{staticClass:"d-flex justify-content-end",staticStyle:{"margin-right":"25px","padding":"0px"},attrs:{"sm":"1"}},[_c('b-button',{staticClass:"btnFilters",staticStyle:{"background-color":"#428bac"},on:{"click":function($event){return _vm.filterData()}}},[_vm._v("Pesquisar")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"newsCreationContainer"},[_c('b-row',{staticStyle:{"height":"100%","width":"100%"}},[_c('b-col',{staticClass:"section5Div",attrs:{"sm":"9"}},[_c('b-col',{staticStyle:{"display":"inline"}},[_c('b-col',{staticClass:"section1Title"},[_c('p',[_vm._v("Criação de Noticia")])]),_vm._v(" "),_c('b-col',{staticClass:"section5"},[_c('b-col',[_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Fonte")]),_vm._v(" "),_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsSourceForCreate,"label":"item","reduce":function (item) { return item.code; }},model:{value:(_vm.sourceOfCreatedNew),callback:function ($$v) {_vm.sourceOfCreatedNew=$$v},expression:"sourceOfCreatedNew"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Tipo de Noticia")]),_vm._v(" "),_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsNewsOriginType,"label":"item","reduce":function (item) { return item.code; }},model:{value:(_vm.createdNew.c_u_NewsOriginType),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_u_NewsOriginType", $$v)},expression:"createdNew.c_u_NewsOriginType"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Programa")]),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.createdNew.c_u_News_MMS_ProgramName),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_u_News_MMS_ProgramName", $$v)},expression:"createdNew.c_u_News_MMS_ProgramName"}})],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Titulo")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea","rows":"3","max-rows":"6"},model:{value:(_vm.createdNew.c_u_Title),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_u_Title", $$v)},expression:"createdNew.c_u_Title"}})],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Data/Hora")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm._newsDate),callback:function ($$v) {_vm._newsDate=$$v},expression:"_newsDate"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"type":"time"},model:{value:(_vm._newsTime),callback:function ($$v) {_vm._newsTime=$$v},expression:"_newsTime"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Resumo")]),_vm._v(" "),_c('editor',{attrs:{"id":"taNewSummary","apiKey":"l34w175sigd9rnbvl4lt1mnv5hnzy81uatlgilxlwdukn8rl","licenseKey":"gpl","init":{
                          height: 250,
                          menubar: true,
                          entity_encoding: 'raw',
                          toolbar1:
                            'styleselect | bold italic | alignleft aligncenter alignright alignjustify',
                        }},model:{value:(_vm.createdNew.c_u_Summary),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_u_Summary", $$v)},expression:"createdNew.c_u_Summary"}})],1),_vm._v(" "),(!_vm.isNotCreatedNew)?_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Imagem")]),_vm._v(" "),_c('b-col',{staticClass:"section3Image"},[_c('b-row',{staticClass:"section3ImageMargin"},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',[_c('img',{staticStyle:{"width":"200px","height":"200px"},attrs:{"id":"output"}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"imageBtnStyle"},[_c('fa',{staticClass:"label",staticStyle:{"cursor":"pointer"},attrs:{"icon":['fa', 'search-plus'],"size":"lg"},on:{"click":_vm.openEnLargeImg}})],1),_vm._v(" "),_c('b-col',{staticClass:"imageBtnStyle"},[_c('fa',{staticClass:"label",staticStyle:{"cursor":"pointer"},attrs:{"icon":['fa', 'times'],"size":"lg"},on:{"click":_vm.deleteImg}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-col',{staticClass:"uploadBtn"},[_c('fa',{staticClass:"label",attrs:{"icon":['fas', 'plus'],"size":"lg"}}),_vm._v(" "),_c('input',{attrs:{"id":"files","name":"files","type":"file"},on:{"change":function($event){return _vm.uploadFiles('files', _vm.newsArray.c_id)}}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"myModal"}},[_c('span',{staticClass:"close"},[_vm._v("×")]),_vm._v(" "),_c('img',{staticClass:"modal-content",attrs:{"id":"img01"}}),_vm._v(" "),_c('div',{attrs:{"id":"caption"}})]),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Media "),_c('small',[_vm._v("(mp3, mp4)")])]),_vm._v(" "),_c('b-col',{staticClass:"section3Image"},[_c('b-row',{staticClass:"section3ImageMargin"},[_c('b-col',{attrs:{"sm":"6","id":"fileVideoAudio1"}},[_c('input',{attrs:{"id":"filesMedia1","name":"filesMedia1","type":"file","accept":".mp3,.mp4"},on:{"change":function($event){return _vm.uploadFilesMedia('filesMedia1', _vm.newsArray.c_id)},"click":function($event){$event.target.value=''}}})])],1)],1)],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Conteúdo")]),_vm._v(" "),_c('editor',{attrs:{"id":"taNewContent","apiKey":"l34w175sigd9rnbvl4lt1mnv5hnzy81uatlgilxlwdukn8rl","licenseKey":"gpl","init":this.configTinyMce},model:{value:(_vm.contentOfCreatedNew),callback:function ($$v) {_vm.contentOfCreatedNew=$$v},expression:"contentOfCreatedNew"}}),_vm._v(" "),_c('b-button',{staticStyle:{"background-color":"rgb(44, 99, 112)","margin-top":"5px"},on:{"click":function($event){return _vm.findThematics()}}},[_vm._v("Reconhecer temáticas no texto")]),_vm._v(" "),_c('div',{staticClass:"hidden",attrs:{"id":"imageUpload"}})],1),_vm._v(" "),(!_vm.isNotCreatedNew)?_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Temáticas")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"},on:{"drop":_vm.drop,"dragover":_vm.allowDrop}},[(_vm.selectedThematics.length == 0)?_c('b-row',{staticClass:"d-flex justify-content-center"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n                            Não existem temáticas associadas\n                          ")])]):_vm._e(),_vm._v(" "),(_vm.selectedThematics.length > 0)?_c('b-row',{staticClass:"thematics"},_vm._l((_vm.selectedThematics),function(item,index){return _c('p',{key:index,staticClass:"thematic",attrs:{"data-id":("" + (item.id))}},[_vm._v("\n                            "+_vm._s(item.wordName)+"\n                            "),_c('span',{staticStyle:{"text-align":"right"}},[_c('fa',{staticClass:"thematicRemove",staticStyle:{"color":"black","cursor":"pointer"},attrs:{"icon":['fas', 'times'],"size":"sm"},on:{"click":function($event){return _vm.deleteThematic(index, _vm.newsArray.c_id)}}})],1)])}),0):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('h6',{staticClass:"section3Title"},[_vm._v("FAV")]),_vm._v(" "),_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsFavView,"append-to-body":"","calculate-position":_vm.withPopper,"label":"id","reduce":function (fav) { return fav.id; }},model:{value:(_vm.createdNew.c_u_NewsidxFav),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_u_NewsidxFav", $$v)},expression:"createdNew.c_u_NewsidxFav"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('h6',{staticClass:"section3Title"},[_vm._v("AVE")]),_vm._v(" "),_c('v-select',{attrs:{"id":"AVEdropDown","append-to-body":"","calculate-position":_vm.withPopper,"options":_vm.optionsAve,"label":"newAve","reduce":function (newAve) { return newAve.id; }},model:{value:(_vm.createdNew.c_u_NewsAVE),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_u_NewsAVE", $$v)},expression:"createdNew.c_u_NewsAVE"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('h6',{staticClass:"section3Title"},[_vm._v("Página")]),_vm._v(" "),_c('b-input',{attrs:{"type":"number","min":"0"},model:{value:(_vm.createdNew.c_u_NewsPageNumber),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_u_NewsPageNumber", $$v)},expression:"createdNew.c_u_NewsPageNumber"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('h6',{staticClass:"section3Title"},[_vm._v("Jornalista")]),_vm._v(" "),_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"taggable":"","label":"name","append-to-body":"","calculate-position":_vm.withPopper,"id":"journalistDropDown","options":_vm.optionsJournalists,"reduce":function (journalist) { return journalist.id ? journalist.id : journalist; }},on:{"input":function (journalist) { return _vm.createJournalist(journalist); }},model:{value:(_vm.createdNew.c_r_Journalist),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_r_Journalist", $$v)},expression:"createdNew.c_r_Journalist"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"10px"}},[_c('b-col',{attrs:{"sm":"1"}},[_c('b-form-checkbox',{staticClass:"section3Title",attrs:{"value":"true","unchecked-value":"false"},model:{value:(_vm.createdNew.c_u_isHighlighted),callback:function ($$v) {_vm.$set(_vm.createdNew, "c_u_isHighlighted", $$v)},expression:"createdNew.c_u_isHighlighted"}},[_vm._v("Destaque")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"d-flex justify-content-end",staticStyle:{"margin-bottom":"20px"}},[_c('b-button',{staticStyle:{"margin-right":"5px","background-color":"rgb(66, 139, 172)"},on:{"click":function($event){return _vm.rememberCreateObject(_vm.createdNew)}}},[_vm._v("Memorizar")]),_vm._v(" "),_c('b-button',{staticStyle:{"margin-left":"5px","background-color":"rgb(44, 99, 112)"},on:{"click":function($event){return _vm.loadCreateObject()}}},[_vm._v("Carregar")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section2Footer"},[_c('b-row',{staticClass:"d-flex justify-content-end"},[_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticStyle:{"background-color":"rgb(162, 91, 113)"},on:{"click":function($event){return _vm.cancelCreationOfNew()}}},[_vm._v("Cancelar")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticStyle:{"background-color":"rgb(99, 190, 200)"},on:{"click":function($event){return _vm.postCreateNew(_vm.createdNew)}}},[_vm._v("Guardar")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticStyle:{"background-color":"rgb(160, 205, 99)"},on:{"click":function($event){return _vm.publishCreateNew(_vm.createdNew)}}},[_vm._v("Publicar")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticStyle:{"background-color":"rgb(160, 205, 99)"},on:{"click":function($event){return _vm.copyCreateNew(_vm.createdNew)}}},[_vm._v("Descarregar")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section6Div",staticStyle:{"padding":"0px"},attrs:{"sm":"3"},on:{"keyup":function($event){return _vm.thematicKB($event)}}},[_c('b-col',{staticStyle:{"display":"inline","overflow":"hidden"}},[_c('b-col',{staticClass:"section1Title"},[_c('p',[_vm._v("Tematicas")])]),_vm._v(" "),_c('b-col',[_c('b-row',{staticStyle:{"margin-bottom":"20px"}},[_c('b-col',{staticStyle:{"padding":"0px"},attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Pesquisa")])]),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px"}},[_c('b-form-input',{attrs:{"autocomplete":"off"},model:{value:(_vm.thematicsSearch),callback:function ($$v) {_vm.thematicsSearch=$$v},expression:"thematicsSearch"}})],1)],1)],1),_vm._v(" "),(!_vm.isNotCreatedNew)?_c('b-col',{staticClass:"section6Themes",attrs:{"id":"sectionThems"}},_vm._l((_vm.thematicItems),function(item,index){return _c('b-col',{key:index,staticClass:"thematicStyle",attrs:{"id":("drag" + (item.id)),"data-id":("" + (item.id)),"draggable":"false"},on:{"dragstart":_vm.drag,"click":function($event){return _vm.drag(item)}}},[_vm._v(_vm._s(item.wordName))])}),1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"width":"100%","height":"100%"}},[_c('b-col',{staticClass:"section2Div",attrs:{"sm":"5"}},[_c('b-col',{staticStyle:{"display":"inline"}},[_c('b-col',{staticClass:"section1Title"},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left"}},[_vm._v("Noticias")]),_vm._v(" "),_c('b-col',{staticClass:"createDiv"},[_c('b-button',{staticClass:"createBtn",on:{"click":function($event){return _vm.refreshNews()}}},[_vm._v("Atualizar")]),_vm._v(" "),_c('b-button',{staticClass:"createBtn",on:{"click":function($event){return _vm.createNewsInfo()}}},[_vm._v("Criar")])],1)],1)],1),_vm._v(" "),(_vm.filteredsNews != [])?_c('b-col',{staticClass:"section2",attrs:{"id":"section2"},on:{"&scroll":function($event){return _vm.handleScrolll($event)}}},[_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{staticClass:"d-flex justify-content-end"},[(_vm.filteredsNews.length > 0 || _vm.noNewsFromCheckbox)?_c('b-form-checkbox',{model:{value:(_vm.validateNews),callback:function ($$v) {_vm.validateNews=$$v},expression:"validateNews"}},[_vm._v("Esconder Publicadas")]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',[(_vm.filteredsNews.length == 0)?_c('b-col',{staticClass:"not-found-section3 col-sm-12"},[_c('b-col',{staticClass:"not-found"},[_c('b-row',[_vm._v("\n                        Sem noticias!\n                        "),_c('br'),_vm._v("Por favor selecione uma Fonte.\n                      ")])],1)],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.filteredsNews),function(news){return _c('b-col',{key:news.c_id,staticClass:"section2News",attrs:{"id":("section2NewId" + (news.c_id)),"name":"dNewsItem"}},[_c('h6',{staticStyle:{"font-weight":"bold","text-align":"left","cursor":"pointer"},domProps:{"innerHTML":_vm._s(news.c_u_Title)},on:{"click":function($event){return _vm.editNews(news.c_id, news)}}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","cursor":"pointer"},domProps:{"innerHTML":_vm._s(
                      news.c_u_Summary != ''
                        ? news.c_u_Summary.replace(/<[^>]*>?/gm, '')
                        : news.c_u_Summary
                    )},on:{"click":function($event){return _vm.editNews(news.c_id, news)}}}),_vm._v(" "),_c('b-row',{staticClass:"d-flex justify-content-end"},[_c('p',[_vm._v("\n                      "+_vm._s(new Date(news.c_u_NewsDateCreate).toLocaleDateString(
                          "en-GB",
                          {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          }
                        ) +
                        " às " +
                        new Date(news.c_u_NewsDateCreate).toLocaleTimeString(
                          "en-GB"
                        ))+"\n                    ")]),_vm._v(" "),(news.c_u_Status == 8 || news.c_u_Status == 10)?_c('b-col',{attrs:{"sm":"1"}},[_c('b-button',{staticClass:"section2Btn",attrs:{"size":"sm"}},[_c('fa',{staticStyle:{"color":"green"},attrs:{"icon":['fas', 'upload'],"size":"lg"}})],1)],1):_vm._e(),_vm._v(" "),(news.c_u_Status == 6 || _vm.isTrueEdited)?_c('b-col',{attrs:{"sm":"1"}},[_c('b-button',{staticClass:"section2Btn",attrs:{"size":"sm"}},[_c('fa',{staticStyle:{"color":"#d1d6a3"},attrs:{"icon":['fas', 'clipboard-check'],"size":"lg"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"1"}},[_c('b-button',{staticClass:"section2Btn",attrs:{"size":"sm"},on:{"click":function($event){return _vm.editNews(news.c_id, news)}}},[_c('fa',{staticStyle:{"color":"#428bac"},attrs:{"icon":"edit","size":"lg"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"1"}},[_c('b-form-checkbox',{attrs:{"value":news.c_id,"name":"itcNewsItem"},model:{value:(_vm.selectedNews),callback:function ($$v) {_vm.selectedNews=$$v},expression:"selectedNews"}})],1)],1)],1)})],2):_vm._e(),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"section2Footer"},[_c('b-col',{staticClass:"btn1section2"},[_c('b-button',{staticStyle:{"background-color":"rgb(162, 91, 113)"},on:{"click":function($event){return _vm.deleteAllNews()}}},[_vm._v("Apagar")])],1),_vm._v(" "),_c('b-col',{staticClass:"btn2section2"},[_c('b-button',{staticStyle:{"background-color":"rgb(160, 205, 99)"},on:{"click":function($event){return _vm.publishAllNews()}}},[_vm._v("Publicar")])],1),_vm._v(" "),_c('b-col',{staticClass:"btn3section2"},[_c('b-button',{staticStyle:{"background-color":"rgb(99, 190, 200)"},on:{"click":function($event){return _vm.selectAllNews()}}},[_vm._v("\n                      Selec.Tudo")])],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px"}},[_c('b-button',{staticStyle:{"border-radius":"20px","background-color":"rgb(231, 242, 245)","color":"rgb(66, 139, 172)","padding":"0.275rem 0.55rem"},on:{"click":function($event){return _vm.clickedScrolll()}}},[_vm._v("Ver Mais")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section3Div",attrs:{"sm":"6"}},[_c('b-col',{staticStyle:{"display":"inline"}},[_c('b-col',{staticClass:"section1Title"},[_c('p',[_vm._v("Edição de Noticia")])]),_vm._v(" "),_c('b-col',{staticClass:"section3"},[(!_vm.isHidden)?_c('b-col',{staticClass:"not-found-section3 col-sm-12"},[_c('b-col',{staticClass:"not-found"},[_c('b-row',[_vm._v("\n                      Nenhuma noticia selecionada!\n                      "),_c('br'),_vm._v("Por favor selecione uma Noticia.\n                    ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isHidden)?_c('b-col',[(
                      _vm.newsArray.c_u_Status == 6 || _vm.newsArray.c_u_Status == 11
                    )?_c('b-col',[_c('p',{staticClass:"isEditedNewUser"},[_c('fa',{staticClass:"label",staticStyle:{"color":"orange"},attrs:{"icon":['fas', 'exclamation-triangle'],"size":"lg"}}),_vm._v("\n                      Noticia editada pelo utilizador "+_vm._s(_vm.getUserInfoEdit)+" no dia\n                      "+_vm._s(_vm.getFormatedNewsEditedDate)+"\n                    ")],1)]):_vm._e(),_vm._v(" "),(
                      _vm.newsArray.c_u_Status == 8 || _vm.newsArray.c_u_Status == 10
                    )?_c('b-col',[_c('p',{staticClass:"isEditedNewUser"},[_c('fa',{staticClass:"label",staticStyle:{"color":"orange"},attrs:{"icon":['fas', 'exclamation-triangle'],"size":"lg"}}),_vm._v("\n                      Noticia publicada pelo utilizador "+_vm._s(_vm.getUserInfoPublish)+"\n                    ")],1)]):_vm._e(),_vm._v(" "),_c('b-col',{style:({ display: _vm.newsArray.c_u_Type == 0 ? 'inherit' : 'none' })},[_c('h6',{staticClass:"section3Title"},[_vm._v("Fonte")]),_vm._v(" "),_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsFilterSource,"label":"item","reduce":function (item) { return item.code; }},model:{value:(_vm.newsArray.c_r_Source),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_r_Source", $$v)},expression:"newsArray.c_r_Source"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1),_vm._v(" "),_c('b-col',{style:({ display: _vm.newsArray.c_u_Type == 0 ? 'inherit' : 'none' })},[_c('h6',{staticClass:"section3Title"},[_vm._v("Tipo de Noticia")]),_vm._v(" "),_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsNewsOriginType,"label":"item","reduce":function (item) { return item.code; }},model:{value:(_vm.newsArray.c_u_NewsOriginType),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_NewsOriginType", $$v)},expression:"newsArray.c_u_NewsOriginType"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1),_vm._v(" "),_c('b-col',{style:({ display: _vm.newsArray.c_u_Type == 0 ? 'inherit' : 'none' })},[_c('h6',{staticClass:"section3Title"},[_vm._v("Programa")]),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.newsArray.c_u_News_MMS_ProgramName),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_News_MMS_ProgramName", $$v)},expression:"newsArray.c_u_News_MMS_ProgramName"}})],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Titulo")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea","rows":"3","max-rows":"6"},model:{value:(_vm.newsArray.c_u_Title),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_Title", $$v)},expression:"newsArray.c_u_Title"}})],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Data/Hora")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm._newsDate),callback:function ($$v) {_vm._newsDate=$$v},expression:"_newsDate"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"type":"time"},model:{value:(_vm._newsTime),callback:function ($$v) {_vm._newsTime=$$v},expression:"_newsTime"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Resumo")]),_vm._v(" "),_c('editor',{attrs:{"id":"taEditSummary","apiKey":"l34w175sigd9rnbvl4lt1mnv5hnzy81uatlgilxlwdukn8rl","licenseKey":"gpl","init":{
                        height: 250,
                        menubar: true,
                        entity_encoding: 'raw',
                        toolbar1:
                          'styleselect | bold italic | alignleft aligncenter alignright alignjustify',
                      }},model:{value:(_vm.newsArray.c_u_Summary),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_Summary", $$v)},expression:"newsArray.c_u_Summary"}})],1),_vm._v(" "),(_vm.isNotCreatedNew)?_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Imagem")]),_vm._v(" "),_c('b-col',{staticClass:"section3Image"},[_c('b-row',{staticClass:"section3ImageMargin"},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',[_c('img',{staticStyle:{"width":"200px","height":"200px"},attrs:{"id":"output"}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"imageBtnStyle"},[_c('fa',{staticClass:"label",staticStyle:{"cursor":"pointer"},attrs:{"icon":['fa', 'search-plus'],"size":"lg"},on:{"click":_vm.openEnLargeImg}})],1),_vm._v(" "),_c('b-col',{staticClass:"imageBtnStyle"},[_c('fa',{staticClass:"label",staticStyle:{"cursor":"pointer"},attrs:{"icon":['fa', 'times'],"size":"lg"},on:{"click":_vm.deleteImg}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-col',{staticClass:"uploadBtn"},[_c('fa',{staticClass:"label",attrs:{"icon":['fas', 'plus'],"size":"lg"}}),_vm._v(" "),_c('input',{attrs:{"id":"files","name":"files","type":"file"},on:{"change":function($event){return _vm.uploadFiles('files', _vm.newsArray.c_id)}}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"myModal"}},[_c('span',{staticClass:"close"},[_vm._v("×")]),_vm._v(" "),_c('img',{staticClass:"modal-content",attrs:{"id":"img01"}}),_vm._v(" "),_c('div',{attrs:{"id":"caption"}})]),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Media "),_c('small',[_vm._v("(mp3, mp4)")])]),_vm._v(" "),_c('b-col',{staticClass:"section3Image"},[_c('b-row',{staticClass:"section3ImageMargin"},[_c('b-col',{attrs:{"sm":"6","id":"fileVideoAudio2"}},[_c('input',{attrs:{"id":"filesMedia2","name":"filesMedia2","type":"file","accept":".mp3,.mp4"},on:{"change":function($event){return _vm.uploadFilesMedia('filesMedia2', _vm.newsArray.c_id)},"click":function($event){$event.target.value=''}}})])],1)],1)],1),_vm._v(" "),_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Conteúdo")]),_vm._v(" "),_c('editor',{attrs:{"id":"taEditContent","apiKey":"l34w175sigd9rnbvl4lt1mnv5hnzy81uatlgilxlwdukn8rl","licenseKey":"gpl","init":this.configTinyMce},model:{value:(_vm.newsArray.c_u_Content),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_Content", $$v)},expression:"newsArray.c_u_Content"}}),_vm._v(" "),(_vm.selectedThematics.length == 0)?_c('b-button',{staticStyle:{"background-color":"rgb(44, 99, 112)","margin-top":"5px"},on:{"click":function($event){return _vm.findThematics2()}}},[_vm._v("Reconhecer temáticas no texto")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hidden",attrs:{"id":"imageUpload"}})],1),_vm._v(" "),(_vm.isNotCreatedNew)?_c('b-col',[_c('h6',{staticClass:"section3Title"},[_vm._v("Tematicas")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"},on:{"drop":_vm.drop,"dragover":_vm.allowDrop}},[(_vm.selectedThematics.length == 0)?_c('b-row',{staticClass:"d-flex justify-content-center"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n                          Não existem temáticas associadas\n                        ")])]):_vm._e(),_vm._v(" "),(_vm.selectedThematics.length > 0)?_c('b-row',{staticClass:"thematics"},_vm._l((_vm.selectedThematics),function(item,index){return _c('p',{key:index,staticClass:"thematic",attrs:{"data-id":("" + (item.id))}},[_vm._v("\n                          "+_vm._s(item.wordName)+"\n                          "),_c('span',{staticStyle:{"text-align":"right"}},[_c('fa',{staticClass:"thematicRemove",staticStyle:{"color":"black","cursor":"pointer"},attrs:{"icon":['fas', 'times'],"size":"sm"},on:{"click":function($event){return _vm.deleteThematic(index, _vm.newsArray.c_id)}}})],1)])}),0):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('h6',{staticClass:"section3Title"},[_vm._v("FAV")]),_vm._v(" "),_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsFavView,"append-to-body":"","calculate-position":_vm.withPopper,"label":"id","reduce":function (fav) { return fav.id; }},model:{value:(_vm.newsArray.c_u_NewsidxFav),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_NewsidxFav", $$v)},expression:"newsArray.c_u_NewsidxFav"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('h6',{staticClass:"section3Title"},[_vm._v("AVE")]),_vm._v(" "),_c('v-select',{attrs:{"id":"AVEdropDown","append-to-body":"","calculate-position":_vm.withPopper,"options":_vm.optionsAve,"label":"newAve","reduce":function (newAve) { return newAve.id; }},model:{value:(_vm.newsArray.c_u_NewsAVE),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_NewsAVE", $$v)},expression:"newsArray.c_u_NewsAVE"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('h6',{staticClass:"section3Title"},[_vm._v("Página")]),_vm._v(" "),_c('b-input',{attrs:{"type":"number","min":"0"},model:{value:(_vm.newsArray.c_u_NewsPageNumber),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_NewsPageNumber", $$v)},expression:"newsArray.c_u_NewsPageNumber"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('h6',{staticClass:"section3Title"},[_vm._v("Jornalista")]),_vm._v(" "),_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"taggable":"","label":"name","append-to-body":"","calculate-position":_vm.withPopper,"id":"journalistDropDown","options":_vm.optionsJournalists,"reduce":function (journalist) { return journalist.id ? journalist.id : journalist; }},on:{"input":function (journalist) { return _vm.createJournalist(journalist); }},model:{value:(_vm.newsArray.c_r_Journalist),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_r_Journalist", $$v)},expression:"newsArray.c_r_Journalist"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"10px"}},[_c('b-col',{attrs:{"sm":"1"}},[_c('b-form-checkbox',{staticClass:"section3Title",attrs:{"value":"true","unchecked-value":"false"},model:{value:(_vm.newsArray.c_u_isHighlighted),callback:function ($$v) {_vm.$set(_vm.newsArray, "c_u_isHighlighted", $$v)},expression:"newsArray.c_u_isHighlighted"}},[_vm._v("Destaque")])],1)],1),_vm._v(" "),(_vm.newsArray.c_u_UrlNews != '')?_c('b-row',[_c('b-col',{staticClass:"NewsExtractedFrom"},[_c('h6',{staticClass:"section3Title"},[_vm._v("Noticia extraida de:")]),_vm._v(" "),_c('a',{staticStyle:{"text-align":"left","font-size":"12px"},attrs:{"href":("" + (_vm.newsArray.c_u_UrlNews)),"target":"_blank"}},[_vm._v(_vm._s(_vm.newsArray.c_u_UrlNews))])])],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.isHidden)?_c('b-col',{staticClass:"section2Footer"},[_c('b-row',{staticClass:"d-flex justify-content-end"},[_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticStyle:{"background-color":"rgb(162, 91, 113)"},on:{"click":function($event){return _vm.deleteEditNew(_vm.newsArray)}}},[_vm._v("Apagar")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticStyle:{"background-color":"rgb(99, 190, 200)"},on:{"click":function($event){return _vm.postEditNew(_vm.newsArray)}}},[_vm._v("Guardar")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticStyle:{"background-color":"rgb(160, 205, 99)"},on:{"click":function($event){return _vm.publishEditedNew(_vm.newsArray)}}},[_vm._v("Publicar")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticStyle:{"background-color":"rgb(160, 205, 99)"},on:{"click":function($event){return _vm.copyEditedNew(_vm.newsArray)}}},[_vm._v("Descarregar")])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section4Div",staticStyle:{"padding":"0px"},attrs:{"sm":"1"},on:{"keyup":function($event){return _vm.thematicKB($event)}}},[_c('b-col',{staticStyle:{"display":"inline","overflow":"hidden"}},[_c('b-col',{staticClass:"section1Title"},[_c('p',[_vm._v("Tematicas")])]),_vm._v(" "),(!_vm.isHidden)?_c('b-col',{staticStyle:{"background-color":"rgb(242, 242, 242)","height":"100%"}}):_vm._e(),_vm._v(" "),(_vm.isHidden)?_c('b-col',[_c('b-row',{staticStyle:{"margin-bottom":"20px"}},[_c('b-col',{staticStyle:{"padding":"0px"},attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Pesquisa")])]),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px"}},[_c('b-form-input',{attrs:{"autocomplete":"off"},model:{value:(_vm.thematicsSearch),callback:function ($$v) {_vm.thematicsSearch=$$v},expression:"thematicsSearch"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isHidden || _vm.isNotCreatedNew)?_c('b-col',{staticClass:"section4Themes",attrs:{"id":"sectionThems"}},_vm._l((_vm.thematicItems),function(item,index){return _c('b-col',{key:index,staticClass:"thematicStyle",attrs:{"id":("drag" + (item.id)),"data-id":("" + (item.id)),"draggable":"false"},on:{"dragstart":_vm.drag,"click":function($event){return _vm.drag(item)}}},[_vm._v(_vm._s(item.wordName))])}),1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('b-modal',{ref:"modal-logout",attrs:{"id":"modal-logout","title":"Aviso","ok-only":""},on:{"hidden":_vm.handleModelLogoutHide}},[_c('p',{staticClass:"my-4"},[_vm._v("A sua sessão expirou. Para continuar, por favor, efetue login.")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "8MIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateRss_vue__ = __webpack_require__("yexb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_694015b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateRss_vue__ = __webpack_require__("07LI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateRss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_694015b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateRss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Apz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Get value from HTML meta tag
 */
function getMetaValue(key) {
  var value = '';
  var node = document.querySelector('meta[property=' + key + ']');
  if (node !== null) {
    value = node.getAttribute('content');
  }
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = ({ getMetaValue: getMetaValue });

/***/ }),

/***/ "CKGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainWrapper"},[_c('div',{staticClass:"sourceMain"},[_c('b-row',{staticClass:"sourceMainSections"},[_c('b-col',{staticClass:"sectionsFilters",attrs:{"sm":"2"}},[_c('b-col',{staticClass:"filters"},[_c('p',[_vm._v("Filtros")])]),_vm._v(" "),_c('b-col',{staticClass:"section1"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Temática")])]),_vm._v(" "),_c('b-col',[_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsThemesFilter,"label":"item","reduce":function (item) { return item.code; }},model:{value:(_vm.selectedThemeViewFilter),callback:function ($$v) {_vm.selectedThemeViewFilter=$$v},expression:"selectedThemeViewFilter"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Palavra")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{model:{value:(_vm.stringOfThemesFilter),callback:function ($$v) {_vm.stringOfThemesFilter=$$v},expression:"stringOfThemesFilter"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Palavra Proibida")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{model:{value:(_vm.stringOfProhibitedThemesFilter),callback:function ($$v) {_vm.stringOfProhibitedThemesFilter=$$v},expression:"stringOfProhibitedThemesFilter"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"sectionOperation",staticStyle:{"margin-top":"20px"},attrs:{"sm":"10"}},[_c('h5',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.left",value:(
            'Adicione aqui as temáticas que ainda não foram caracterizadas no motor de scrapping'
          ),expression:"\n            'Adicione aqui as temáticas que ainda não foram caracterizadas no motor de scrapping'\n          ",modifiers:{"hover":true,"left":true}}],staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n          Caracterização da Temática\n        ")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('v-select',{attrs:{"options":_vm.optionsThemesView,"label":"item","placeholder":"selecionar temática","reduce":function (item) { return item.code; }},model:{value:(_vm.selectedThemeView),callback:function ($$v) {_vm.selectedThemeView=$$v},expression:"selectedThemeView"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Adicionar Palavras"},model:{value:(_vm.stringOfThemes),callback:function ($$v) {_vm.stringOfThemes=$$v},expression:"stringOfThemes"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Adicionar Palavras Proibidas"},model:{value:(_vm.stringOfProhibitedThemes),callback:function ($$v) {_vm.stringOfProhibitedThemes=$$v},expression:"stringOfProhibitedThemes"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('button',{staticStyle:{"background-color":"rgb(66, 139, 172)","color":"white"},on:{"click":function($event){return _vm.createNewTheme(_vm.selectedThemeView, _vm.stringOfThemes, _vm.stringOfProhibitedThemes)}}},[_vm._v("\n              Adicionar\n            ")])])],1),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"black","margin-top":"20px","margin-bottom":"20px"}}),_vm._v(" "),_c('b-col',{staticStyle:{"margin-top":"10px","padding":"0px"}},[_c('h5',{staticStyle:{"font-weight":"bold","text-align":"left","margin-top":"20px"}},[_vm._v("\n            Listagem Temática-Keywords\n          ")]),_vm._v(" "),_c('b-table',{attrs:{"hover":"","items":_vm.filteredData,"per-page":15,"currentPage":_vm.currentPage,"fields":_vm.fieldsThemeWords,"small":"","fixed":"","caption-top":""},on:{"row-dblclicked":_vm.toggleDetails},scopedSlots:_vm._u([{key:"table-caption",fn:function(){return [_c('span',{staticStyle:{"font-weight":"bold","color":"black"}},[_vm._v("Nota:")]),_vm._v(" Para\n              editar a caracterização de um Temática-Keywords, faça duplo clique\n              sobre a linha da temática pretendida")]},proxy:true},{key:"row-details",fn:function(row){return [_c('b-row',{staticClass:"rowDetails"},[_c('b-col',{staticStyle:{"text-align":"center"},attrs:{"sm":"2"}},[_c('b-col',[_c('span',{staticClass:"ThemeWord"},[_vm._v("Temática:")])]),_vm._v(" "),_c('b-col',[_vm._v("\n                    "+_vm._s(row.item.wordName)+"\n                  ")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-col',[_c('span',{staticClass:"ThemeWord"},[_vm._v("Palavras:")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{model:{value:(row.item.c_u_Words),callback:function ($$v) {_vm.$set(row.item, "c_u_Words", $$v)},expression:"row.item.c_u_Words"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-col',[_c('span',{staticClass:"ThemeWord"},[_vm._v("Palavras Proibida:")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{model:{value:(row.item.c_u_ProhibitedWords),callback:function ($$v) {_vm.$set(row.item, "c_u_ProhibitedWords", $$v)},expression:"row.item.c_u_ProhibitedWords"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-col',[_c('button',{staticStyle:{"background-color":"rgb(66, 139, 172)","color":"white"},on:{"click":function($event){return _vm.editThemWords(row.item)}}},[_vm._v("\n                      Guardar\n                    ")]),_vm._v(" "),_c('button',{staticStyle:{"color":"rgb(66, 139, 172)","margin-top":"5px"},on:{"click":function($event){row.item._showDetails = false}}},[_vm._v("\n                      Cancelar\n                    ")])])],1)],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-pagination',{attrs:{"total-rows":_vm.totalItems,"per-page":15,"align":"center"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ENlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('b-row',[_c('b-col',[_c('canvas',{attrs:{"id":"operation-chart"}})]),_vm._v(" "),_c('b-col',[_c('canvas',{attrs:{"id":"planet-chart"}})])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__("ikxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_chartjs_plugin_annotation__ = __webpack_require__("+WEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_chartjs_plugin_annotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_chartjs_plugin_annotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chart_data_js__ = __webpack_require__("UtyK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chart_operation_logs_js__ = __webpack_require__("vMnq");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",

  data: function data() {
    return {
      items: [],
      endpointForLogs: "DashBoard/OperationLogs",
      endpointForErrors: "DashBoard/OperationErrors",
      endpointForNews: "DashBoard/News",
      operationLogs: [],
      everyHourChartData: __WEBPACK_IMPORTED_MODULE_7__chart_data_js__["a" /* default */],
      operationLogsChart: __WEBPACK_IMPORTED_MODULE_8__chart_operation_logs_js__["a" /* default */],
      totalItemsNews: 0,
      currentPageNews: 1,
      timer: "",
      operationErrors: [],
      newsExtractPerHour: null,
      fieldsNews: [{
        key: "hours",
        label: "Hours",
        formatter: function formatter(value, key, item) {
          return item.hour;
        }
      }, {
        key: "extracted",
        label: "Extracted News"
      }]
    };
  },


  components: {},

  methods: {
    autoReloadData: function autoReloadData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$api.data.endpoint = _this.endpointForNews;
                _context.next = 3;
                return _this.$api.data.find();

              case 3:
                _this.newsExtractPerHour = _context.sent;

                _this.totalItemsNews = _this.newsExtractPerHour.length;
                for (index = 0; index < _this.newsExtractPerHour.length; index++) {
                  if (index + 1 < 12) {
                    _this.newsExtractPerHour[index] = {
                      hour: index + 1 + ":00 AM",
                      extracted: _this.newsExtractPerHour[index]
                    };
                    _this.everyHourChartData.data.labels[index] = _this.newsExtractPerHour[index].hour;
                    _this.everyHourChartData.data.datasets[0].data[index] = _this.newsExtractPerHour[index].extracted;
                  }
                  if (index + 1 >= 12) {
                    _this.newsExtractPerHour[index] = {
                      hour: index + 1 + ":00 PM",
                      extracted: _this.newsExtractPerHour[index]
                    };
                    _this.everyHourChartData.data.labels[index] = _this.newsExtractPerHour[index].hour;
                    _this.everyHourChartData.data.datasets[0].data[index] = _this.newsExtractPerHour[index].extracted;
                  }
                  if (index + 1 == 24) {
                    _this.newsExtractPerHour[index] = {
                      hour: index + 1 + ":00 AM",
                      extracted: _this.newsExtractPerHour[index]
                    };
                    _this.everyHourChartData.data.labels[index] = _this.newsExtractPerHour[index].hour;
                    _this.everyHourChartData.data.datasets[0].data[index] = _this.newsExtractPerHour[index].extracted;
                  }
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showData: function showData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var index, getDaysSuccessLog, getDaysErrorLog, date, x, _x;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.data.endpoint = _this2.endpointForLogs;
                _context2.next = 3;
                return _this2.$api.data.find();

              case 3:
                _this2.operationLogs = _context2.sent;


                _this2.$api.data.endpoint = _this2.endpointForErrors;
                _context2.next = 7;
                return _this2.$api.data.find();

              case 7:
                _this2.operationErrors = _context2.sent;


                _this2.$api.data.endpoint = _this2.endpointForNews;
                _context2.next = 11;
                return _this2.$api.data.find();

              case 11:
                _this2.newsExtractPerHour = _context2.sent;

                _this2.totalItemsNews = _this2.newsExtractPerHour.length;

                //console.log(this.newsExtractPerHour);

                for (index = 0; index < _this2.newsExtractPerHour.length; index++) {
                  if (index < 12) {
                    _this2.newsExtractPerHour[index] = {
                      hour: index + ":00 AM",
                      extracted: _this2.newsExtractPerHour[index]
                    };
                    _this2.everyHourChartData.data.labels[index] = _this2.newsExtractPerHour[index].hour;
                    _this2.everyHourChartData.data.datasets[0].data[index] = _this2.newsExtractPerHour[index].extracted;
                  }
                  if (index >= 12) {
                    _this2.newsExtractPerHour[index] = {
                      hour: index + ":00 PM",
                      extracted: _this2.newsExtractPerHour[index]
                    };
                    _this2.everyHourChartData.data.labels[index] = _this2.newsExtractPerHour[index].hour;
                    _this2.everyHourChartData.data.datasets[0].data[index] = _this2.newsExtractPerHour[index].extracted;
                  }
                  // if (index + 1 == 24) {
                  //   this.newsExtractPerHour[index] = {
                  //     hour: index + 1 + ":00 AM",
                  //     extracted: this.newsExtractPerHour[index]
                  //   };
                  //   this.everyHourChartData.data.labels[index] = this.newsExtractPerHour[
                  //     index
                  //   ].hour;
                  //   this.everyHourChartData.data.datasets[0].data[
                  //     index
                  //   ] = this.newsExtractPerHour[index].extracted;
                  // }
                }
                // for to create the last seven days;
                getDaysSuccessLog = [];
                getDaysErrorLog = [];
                date = new Date();

                date.setDate(date.getDate() - 7);

                getDaysSuccessLog = _this2.operationLogs;
                getDaysErrorLog = _this2.operationErrors;

                _.remove(getDaysSuccessLog, function (n) {
                  return n.day == date.getDate();
                });
                _.remove(getDaysErrorLog, function (n) {
                  return n.day == date.getDate();
                });

                for (x = 0; x < getDaysSuccessLog.length; x++) {
                  _this2.operationLogsChart.data.labels[x] = getDaysSuccessLog[x].day ? getDaysSuccessLog[x].day : getDaysSuccessLog[x];
                  _this2.operationLogsChart.data.datasets[0].data[x] = getDaysSuccessLog[x].number ? getDaysSuccessLog[x].number : 0;
                }

                for (_x = 0; _x < getDaysErrorLog.length; _x++) {
                  _this2.operationLogsChart.data.labels[_x] = getDaysErrorLog[_x].day ? getDaysErrorLog[_x].day : getDaysErrorLog[_x];
                  _this2.operationLogsChart.data.datasets[1].data[_x] = getDaysErrorLog[_x].number ? getDaysErrorLog[_x].number : 0;
                }
                _this2.operationLogsChart.data.labels = _.uniq(_this2.operationLogsChart.data.labels);
                _this2.createChart("planet-chart", _this2.everyHourChartData);
                _this2.createChart("operation-chart", _this2.operationLogsChart);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    createChart: function createChart(chartId, chartData) {
      var ctx = document.getElementById(chartId);
      var myChart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      });
    },
    createChart2: function createChart2(chartId, chartData) {
      var ctx = document.getElementById(chartId);
      var myChart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({})),

  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.showData();

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),

/***/ "GQMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SourceMain_vue__ = __webpack_require__("QZQF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d42c8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SourceMain_vue__ = __webpack_require__("PmxX");
function injectStyle (ssrContext) {
  __webpack_require__("eyip")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68d42c8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SourceMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d42c8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SourceMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hobc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CreateUrl",
  props: {
    isNotSearchEngine: Boolean,
    sourceObject: Object
  },
  data: function data() {
    return {
      clicked: 1,
      test: "",
      endpoint: "Sources",
      addDivTitle: 2,
      addDivToQuery: [1],
      addDivToQueryOfRemove: [1],
      addDivResume: 1,
      addDivImage: 1,
      addDivText: 1,
      addDivRemove: 1,
      addDivPartialUrl: 1,
      addDivToRemove: 1,
      addDivNotFullUrl: [false],
      addDivToRemoveQueries: [false],
      addTheDivForPartial: [],
      optionsForExtractUrl: [{ item: 0, name: "URL1" }],
      optionsForRemoveUrl: [{ item: 0, name: "URL1" }],
      selectedUrlForExtract: [[]],
      selectedUrlForRemove: [[]],
      addQueryToRemove: [1],
      isSimple: true,
      isPartialQuery: [[0]],
      isPartialQueryRemove: [[0]],
      isSimple2: true,
      disabled: true,
      document: __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document),
      advancedXML: "",
      advancedXML2: "",
      toReplaceOptions: [{
        toReplace: "",
        queryToReplace: [{
          query: "",
          toReplace: "",
          prepateQs: false,
          isPartial: false
        }],
        urlToReplace: ""
      }],
      toRemoveOptions: [{
        queryToRemove: [{
          query: "",
          toReplace: "",
          prepateQs: false,
          isRemoved: false
        }],
        urlToRemove: ""
      }],
      urlArray: [{
        url: "",
        priority: 0,
        checkedIsFullUrl: true,
        replace: "",
        query: ""
      }],
      optionsFullUrl: [{ text: "URL1", value: 1 }],
      titleArray: [{
        query: "//meta[@property='og:title']/@content",
        confidenceLevel: 30
      }, {
        query: "//title",
        confidenceLevel: 20
      }],
      resumeArray: [{
        query: "//meta[@property='og:description']/@content",
        confidenceLevel: 30
      }],
      imageArray: [{
        query: "//meta[@property='og:image']/@content",
        isPartial: 0,
        topReplace: "",
        confidenceLevel: 30
      }],
      imageArrayUrl: "",
      textArray: [{
        query: "",
        confidenceLevel: 0
      }],
      removeArray: [{
        reference: 0,
        queries: [{ query: "" }]
      }],
      SourceUrl: {
        c_u_Type: 1,
        c_u_Status: 0,
        c_u_Regularity: 0,
        c_u_ReferenceSource: "",
        c_u_Keywords: "",
        c_u_Parameters1: "",
        c_u_Parameters2: ""
      },
      priorityOptions: [{ value: "0", text: "Please select a priority" }, { value: "30", text: "High" }, { value: "20", text: "Medium" }, { value: "10", text: "Low" }],
      statusOptions: [{ value: "0", text: "Please select a status" }, { value: "1", text: "Enabled" }, { value: "2", text: "Disabled" }],
      regularityOptions: [{ value: "0", text: "Please select a regularity" }, { value: "10", text: "10 Minutos" }, { value: "20", text: "20 Minutos" }, { value: "30", text: "30 Minutos" }, { value: "40", text: "40 Minutos" }, { value: "50", text: "50 Minutos" }, { value: "60", text: "60 Minutos" }],
      confidenceOptions: [{ value: "0", text: "Please select a priority" }, { value: "30", text: "High" }, { value: "20", text: "Medium" }, { value: "10", text: "Low" }],
      removeOptions: [{ value: "0", text: "Please select a Reference" }, { value: "title", text: "Title" }, { value: "resume", text: "Resume" }, { value: "image", text: "Image" }, { value: "text", text: "Text" }]
    };
  },


  components: {},

  computed: {},

  watch: {
    isNotSearchEngine: function isNotSearchEngine(newVal, oldVal) {
      if (newVal) {
        this.isSimple = true;
      } else {
        this.isSimple = false;
        this.advancedMode(false);
      }
      this.$forceUpdate();
    },
    selectedUrlForRemove: function selectedUrlForRemove(newVal, oldVal) {
      if (newVal[this.addDivToRemove - 1].length == 0) {
        this.addDivToRemoveQueries[this.addDivToRemove - 1] = false;
      }
      if (newVal[this.addDivToRemove - 1].length >= 1) {
        this.addDivToRemoveQueries[this.addDivToRemove - 1] = true;
      }
    },
    selectedUrlForExtract: function selectedUrlForExtract(newVal, oldVal) {
      if (newVal[this.addDivPartialUrl - 1].length == 0) {
        this.addDivNotFullUrl[this.addDivPartialUrl - 1] = false;
      }
      if (newVal[this.addDivPartialUrl - 1].length >= 1) {
        this.addDivNotFullUrl[this.addDivPartialUrl - 1] = true;
      }
    }
  },

  methods: {
    resetFields: function resetFields() {
      this.SourceUrl.c_u_ReferenceSource = "";
      this.SourceUrl.c_u_Status = 0;
      this.isPartialQuery = [[0]];
      this.isPartialQueryRemove = [[0]];
      this.SourceUrl.c_u_Regularity = 0;
      this.SourceUrl.c_u_Keywords = "";
      this.urlArray = [{
        url: "",
        priority: 0,
        checkedIsFullUrl: true
      }];
      this.toReplaceOptions = [{
        toReplace: "",
        queryToReplace: [{
          query: "",
          toReplace: "",
          prepateQs: false,
          isPartial: false
        }],
        urlToReplace: ""
      }];
      this.toRemoveOptions = [{
        queryToRemove: [{
          query: "",
          toReplace: "",
          prepateQs: false,
          isRemoved: false
        }],
        urlToRemove: ""
      }];
      this.addDivPartialUrl = 1;
      this.addDivToQuery = [1];
      this.addDivNotFullUrl = [];
      this.selectedUrlForExtract = [[]];
      this.selectedUrlForRemove = [[]];
      this.addDivRemove = 1;
      this.addDivToQueryOfRemove = [1];
      this.addDivToRemoveQueries = [false];
      this.addQueryToRemove = [1];
      this.addDivToRemove = 1;
      this.addDivResume = 1, this.addDivImage = 1, this.addDivText = 1, this.removeArray = [{
        reference: 0,
        queries: [{ query: "" }]
      }];
      this.titleArray = [{
        query: "//meta[@property='og:title']/@content",
        confidenceLevel: 30
      }, {
        query: "//title",
        confidenceLevel: 20
      }], this.resumeArray = [{
        query: "//meta[@property='og:description']/@content",
        confidenceLevel: 30
      }], this.imageArray = [{
        query: "//meta[@property='og:image']/@content",
        isPartial: 0,
        topReplace: "",
        confidenceLevel: 30
      }], this.imageArrayUrl = "", this.textArray = [{
        query: "",
        confidenceLevel: 0
      }];
      this.clicked = 1;
      this.isSimple = true;
    },

    semicolonKey: function semicolonKey(event) {
      if (event.key != undefined) {
        if (event.keyCode == 32) {
          this.SourceUrl.c_u_Keywords = this.SourceUrl.c_u_Keywords.replace(/\s/g, "") + ";";
        }
      }
    },
    createXml2: function createXml2(evt) {
      var xml = __webpack_require__("K7uN");
      // structur of the xml for the parameters2
      if (this.isSimple2) {
        var xml2 = [{
          Configuration: [{ _attr: { For: "News" } }, { URLs: "" }, {
            ToExtract: [{
              Item: [{ _attr: { ForURLsID: "", Reference: "title" } }, { Queries: [] }, { URL: [] }]
            }, {
              Item: [{ _attr: { ForURLsID: "", Reference: "resume" } }, { Queries: [] }, { URL: [] }]
            }, {
              Item: [{ _attr: { ForURLsID: "", Reference: "image" } }, { Queries: [] }, { URL: "" }]
            }, {
              Item: [{ _attr: { ForURLsID: "", Reference: "text" } }, { Queries: [] }, { URL: [] }]
            }]
          }, { ToRemove: [] }]
        }];

        //for loop to create the queries of title in the xml
        for (var index = 0; index < this.titleArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[0].Item[1].Queries.push({
            Query: [{
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.titleArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: "",
                PrepareTextForQS: "false"
              }
            }, this.titleArray[index].query]
          });
        }

        //for loop to create the queries of resume in the xml
        for (var index = 0; index < this.resumeArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[1].Item[1].Queries.push({
            Query: [{
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.resumeArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: "",
                PrepareTextForQS: "false"
              }
            }, this.resumeArray[index].query]
          });
        }

        //for loop to create the queries of image in the xml
        for (var index = 0; index < this.imageArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[2].Item[1].Queries.push({
            Query: [{
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.imageArray[index].confidenceLevel,
                IsURL: "true",
                IsFullURL: this.imageArray[index].isPartial == "1" ? "false" : "true",
                ToReplace: this.imageArray[index].isPartial == "1" ? this.imageArray[index].toReplace : "",
                PrepareTextForQS: "false"
              }
            }, this.imageArray[index].query]
          });
          if (this.imageArray[index].isPartial == "1") {
            xml2[0].Configuration[2].ToExtract[2].Item[2].URL = this.imageArrayUrl;
          }
        }

        //for loop to create the queries of text in the xml
        for (var index = 0; index < this.textArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[3].Item[1].Queries.push({
            Query: [{
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.textArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: "",
                PrepareTextForQS: "false"
              }
            }, this.textArray[index].query]
          });
        }
        // for loop to create the queries of remove in the xml
        for (var index = 0; index < this.removeArray.length; index++) {
          xml2[0].Configuration[3].ToRemove.push({
            Item: [{
              _attr: {
                ForURLsId: "",
                Reference: this.removeArray[index].reference
              }
            }, {
              Queries: []
            }]
          });
          for (var i = 0; i < this.removeArray[index].queries.length; i++) {
            xml2[0].Configuration[3].ToRemove[index].Item[1].Queries.push({
              Query: [{
                _attr: {
                  Id: i + 1,
                  ConfidenceLevel: 0,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace: "",
                  PrepareTextForQS: "false"
                }
              }, this.removeArray[index].queries[i].query]
            });
          }
        }
        this.SourceUrl.c_u_Parameters2 = xml(xml2, {
          declaration: { version: "1.0", encoding: "UTF-8" }
        });
      } else {
        this.SourceUrl.c_u_Parameters2 = this.advancedXML2;
      }

      this.$emit("ok", this.SourceUrl.c_u_Parameters1, this.SourceUrl.c_u_Parameters2);
    },
    createUrlSouce: function createUrlSouce(evt) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var xml, indexUrls, queryIndex, xml1, index, arrayForToReplace, stringOfUrl, numbers, i, u, arrayToRemoveItems, stringOfUrls, _numbers, _i, _u;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.isSimple) {
                  // create the xml for the source
                  xml = __webpack_require__("K7uN");
                  indexUrls = [];
                  queryIndex = 1;
                  //structure for the parameters1 xml

                  xml1 = [{
                    Configuration: [{ _attr: { For: "List" } }, { URLs: [] }, { ToExtract: [] }, { ToRemove: [] }]
                  }];

                  // for loop to create the url queries in the xml

                  for (index = 0; index < _this.urlArray.length; index++) {
                    xml1[0].Configuration[1].URLs.push({
                      URL: [{
                        _attr: {
                          Id: index + 1,
                          Priority: _this.urlArray[index].priority
                        }
                      }, _this.urlArray[index].url]
                    });
                    if (_this.urlArray[index].checkedIsFullUrl == true) {
                      indexUrls.push(index + 1);
                    }
                  }

                  arrayForToReplace = [];
                  stringOfUrl = "";
                  numbers = [];

                  for (index = 0; index < _this.selectedUrlForExtract.length; index++) {
                    for (i = 0; i < _this.selectedUrlForExtract[index].length; i++) {
                      numbers.push(_this.selectedUrlForExtract[index][i] + 1);
                    }
                    _this.selectedUrlForExtract[index].sort();
                    stringOfUrl = numbers.join(",");
                    //Create the final array for the to replace
                    arrayForToReplace.push({
                      stringForUrlsId: stringOfUrl,
                      url: _this.toReplaceOptions[index].urlToReplace,
                      query: _this.toReplaceOptions[index].queryToReplace
                    });
                  }

                  for (index = 0; index < arrayForToReplace.length; index++) {
                    xml1[0].Configuration[2].ToExtract.push({
                      Item: [{
                        _attr: { ForURLsId: arrayForToReplace[index].stringForUrlsId }
                      }, {
                        Queries: []
                      }, {
                        URL: arrayForToReplace[index].url
                      }]
                    });
                    for (u = 0; u < arrayForToReplace[index].query.length; u++) {
                      xml1[0].Configuration[2].ToExtract[index].Item[1].Queries.push({
                        Query: [{
                          _attr: {
                            Id: u + 1,
                            ConfidenceLevel: "0",
                            IsURL: "true",
                            IsFullURL: arrayForToReplace[index].query[u].isPartial == true ? "false" : "true",
                            ToReplace: arrayForToReplace[index].query[u].toReplace != "" ? arrayForToReplace[index].query[u].toReplace.includes("#") == true ? arrayForToReplace[index].query[u].toReplace : "#" + arrayForToReplace[index].query[u].toReplace + "#" : "",
                            PrepareTextForQS: arrayForToReplace[index].query[u].prepateQs
                          }
                        }, _this.sourceObject.c_u_Type != 2 ? arrayForToReplace[index].query[u].query.includes("/a") == true ? arrayForToReplace[index].query[u].query.includes("/@href") == true ? arrayForToReplace[index].query[u].query : arrayForToReplace[index].query[u].query + "/@href" : arrayForToReplace[index].query[u].query : arrayForToReplace[index].query[u].query]
                      });
                    }
                    arrayToRemoveItems = [];
                    stringOfUrls = "";
                    _numbers = [];
                    // to create the toRemove Items with queries

                    for (index = 0; index < _this.selectedUrlForRemove.length; index++) {
                      if (_this.selectedUrlForRemove[index].length >= 1) {
                        for (_i = 0; _i < _this.selectedUrlForRemove[index].length; _i++) {
                          _numbers.push(_this.selectedUrlForRemove[index][_i] + 1);
                        }
                        _this.selectedUrlForRemove[index].sort();
                        stringOfUrls = _numbers.join(",");
                        arrayToRemoveItems.push({
                          stringForUrlsId: stringOfUrls,
                          url: _this.toRemoveOptions[index].urlToRemove,
                          query: _this.toRemoveOptions[index].queryToRemove
                        });
                      }
                    }

                    if (arrayToRemoveItems != []) {
                      for (index = 0; index < arrayToRemoveItems.length; index++) {
                        xml1[0].Configuration[3].ToRemove.push({
                          Item: [{
                            _attr: {
                              ForURLsId: arrayToRemoveItems[index].stringForUrlsId
                            }
                          }, {
                            Queries: []
                          }, {
                            URL: arrayToRemoveItems[index].url
                          }]
                        });

                        for (_u = 0; _u < arrayToRemoveItems[index].query.length; _u++) {
                          xml1[0].Configuration[3].ToRemove[index].Item[1].Queries.push({
                            Query: [{
                              _attr: {
                                Id: _u + 1,
                                ConfidenceLevel: "0",
                                IsURL: "true",
                                IsFullURL: arrayToRemoveItems[index].query[_u].isRemoved == true ? "false" : "true",
                                ToReplace: arrayToRemoveItems[index].query[_u].toReplace != "" ? arrayToRemoveItems[index].query[_u].toReplace.includes("#") == true ? arrayToRemoveItems[index].query[_u].toReplace : "#" + arrayToRemoveItems[index].query[_u].toReplace + "#" : "",
                                PrepareTextForQS: arrayToRemoveItems[index].query[_u].prepateQs
                              }
                            }, _this.sourceObject.c_u_Type != 2 ? arrayForToReplace[index].query[_u].query.includes("/a") == true ? arrayForToReplace[index].query[_u].query.includes("/@href") == true ? arrayForToReplace[index].query[_u].query : arrayForToReplace[index].query[_u].query + "/href" : arrayForToReplace[index].query[_u].query : arrayForToReplace[index].query[_u].query]
                          });
                        }
                      }
                    }
                  }

                  _this.SourceUrl.c_u_Parameters1 = xml(xml1, {
                    declaration: { version: "1.0", encoding: "UTF-8" }
                  });
                } else {
                  _this.SourceUrl.c_u_Parameters1 = _this.advancedXML;
                }
                //api post to create the source
                // this.$api.data.endpoint = this.endpoint;
                // await this.$api.data.create(this.SourceUrl);
                _this.$emit("ok", _this.SourceUrl.c_u_Parameters1, _this.SourceUrl.c_u_Parameters2);
                _this.$forceUpdate();

                //remove the values from the modal
                //this.resetFields();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addQueryForUrl: function addQueryForUrl(evt, item) {
      this.addDivToQuery[item - 1]++;
      this.toReplaceOptions[item - 1].queryToReplace[this.addDivToQuery[item - 1] - 1] = { query: "", toReplace: "", prepateQs: false, isPartial: false };
      this.$forceUpdate();
    },
    addQueryForRemove: function addQueryForRemove(evt, item) {
      this.addDivToQueryOfRemove[item - 1]++;
      this.toRemoveOptions[item - 1].queryToRemove[this.addDivToQueryOfRemove[item - 1] - 1] = { query: "", toReplace: "", prepateQs: false, isRemoved: false };
      this.$forceUpdate();
    },
    toRemoveAddQueries: function toRemoveAddQueries(item) {
      if (this.addDivToRemoveQueries[item - 1] == undefined) {
        this.addDivToRemoveQueries[item - 1] = false;
        this.addDivToQueryOfRemove[item - 1] = 1;
      }
      this.$forceUpdate();
    },
    addDivForItemToRemove: function addDivForItemToRemove() {
      this.addDivToRemove++;
      if (this.toRemoveOptions[this.addDivToRemove - 1] == undefined) {
        this.toRemoveOptions[this.addDivToRemove - 1] = {
          toReplace: "",
          queryToRemove: [],
          urlToReplace: ""
        };
        this.toRemoveOptions[this.addDivToRemove - 1].queryToRemove[0] = {
          query: "",
          toReplace: "",
          prepateQs: false,
          isRemoved: false
        };
        this.isPartialQueryRemove[this.addDivToRemove - 1] = [0];
        this.$forceUpdate();
      }
    },
    addPartialUrlDiv: function addPartialUrlDiv(evt) {
      this.addDivPartialUrl++;
      if (this.toReplaceOptions[this.addDivPartialUrl - 1] == undefined) {
        this.toReplaceOptions[this.addDivPartialUrl - 1] = {
          toReplace: "",
          queryToReplace: [],
          urlToReplace: ""
        };
        this.toReplaceOptions[this.addDivPartialUrl - 1].queryToReplace[0] = {
          query: "",
          toReplace: "",
          prepateQs: false,
          isPartial: false
        };
        this.addDivToQuery[this.addDivPartialUrl - 1] = 1;
      }
      this.isPartialQuery[this.addDivPartialUrl - 1] = [0];
      this.$forceUpdate();
    },
    addTitleDiv: function addTitleDiv(evt) {
      this.addDivTitle++;
      this.titleArray[this.addDivTitle - 1] = { query: "", confidenceLevel: 0 };
    },
    addResumeDiv: function addResumeDiv(evt) {
      this.addDivResume++;
      this.resumeArray[this.addDivResume - 1] = {
        query: "",
        confidenceLevel: 0
      };
    },
    addImageDiv: function addImageDiv(evt) {
      this.addDivImage++;
      this.imageArray[this.addDivImage - 1] = {
        query: "",
        isPartial: 0,
        topReplace: "",
        confidenceLevel: 0
      };
    },
    addTextDiv: function addTextDiv(evt) {
      this.addDivText++;
      this.textArray[this.addDivText - 1] = { query: "", confidenceLevel: 0 };
    },
    addUrlDiv: function addUrlDiv(evt) {
      this.clicked++;
      this.optionsForRemoveUrl.push({
        item: this.clicked - 1,
        name: "URL" + this.clicked
      });
      this.optionsForExtractUrl.push({
        item: this.clicked - 1,
        name: "URL" + this.clicked
      });
      this.urlArray.push({
        url: "",
        priority: 0,
        checkedIsFullUrl: true,
        replace: "",
        query: ""
      });
    },
    addRemoveDiv: function addRemoveDiv(evt) {
      this.addDivRemove++;
      this.removeArray[this.addDivRemove - 1] = {
        reference: 0,
        queries: [{ query: "" }]
      };
      this.addQueryToRemove[this.addDivRemove - 1] = 1;
    },
    addRemoveDivQuery: function addRemoveDivQuery(evt, item) {
      this.addQueryToRemove[item - 1]++;
      this.removeArray[item - 1].queries[this.addQueryToRemove[item - 1] - 1] = { query: "" };
      this.$forceUpdate();
    },
    advancedMode: function advancedMode(evt) {
      if (this.isSimple == true) {
        this.advancedXML = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<Configuration For=\"list\">\n    <URLs>\n    </URLs>\n    <ToExtract>\n        <Item ForURLsId=\"\" Reference=\"\">\n            <Queries>\n                <Query Id=\"1\" ConfidenceLevel=\"0\" IsURL=\"true\" IsFullURL=\"true\" ToReplace=\"\" PrepareTextForQS=\"false\">\n                </Query>\n            </Queries>\n            <URL></URL>\n        </Item>\n    </ToExtract>\n    <ToRemove></ToRemove>\n</Configuration>";

        document.getElementsByClassName("advance")[0].innerText = "Simple Mode";
        this.isSimple = false;
      } else {
        this.advancedXML = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<Configuration For=\"list\">\n    <URLs>\n    </URLs>\n    <ToExtract>\n        <Item ForURLsId=\"\" Reference=\"\">\n            <Queries>\n                <Query Id=\"1\" ConfidenceLevel=\"0\" IsURL=\"true\" IsFullURL=\"true\" ToReplace=\"\" PrepareTextForQS=\"false\">\n                </Query>\n            </Queries>\n            <URL></URL>\n        </Item>\n    </ToExtract>\n    <ToRemove></ToRemove>\n</Configuration>";
        document.getElementsByClassName("advance")[0].innerText = "Advanced Mode";
        this.isSimple = true;
      }
    },
    advancedMode2: function advancedMode2(evt) {
      if (this.isSimple2 == true) {
        this.advancedXML2 = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<Configuration For=\"news\">\n    <URLs></URLs>\n    <ToExtract>\n        <Item ForURLsId=\"\" Reference=\"title\">\n            <Queries>\n                <Query Id=\"1\" ConfidenceLevel=\"30\" IsURL=\"false\" IsFullURL=\"false\" ToReplace=\"\" PrepareTextForQS=\"false\">\n                    //meta[@property='og:title']/@content\n                </Query>\n                <Query Id=\"2\" ConfidenceLevel=\"20\" IsURL=\"false\" IsFullURL=\"false\" ToReplace=\"\" PrepareTextForQS=\"false\">\n                    //title\n                </Query>\n            </Queries>\n            <URL></URL>\n        </Item>\n        <Item ForURLsId=\"\" Reference=\"resume\">\n            <Queries>\n                <Query Id=\"1\" ConfidenceLevel=\"30\" IsURL=\"false\" IsFullURL=\"false\" ToReplace=\"\" PrepareTextForQS=\"false\">\n                    //meta[@property='og:description']/@content\n                </Query>\n            </Queries>\n            <URL></URL>\n        </Item>\n        <Item ForURLsId=\"\" Reference=\"image\">\n            <Queries>\n                <Query Id=\"1\" ConfidenceLevel=\"30\" IsURL=\"true\" IsFullURL=\"true\" ToReplace=\"\" PrepareTextForQS=\"false\">\n                    //meta[@property='og:image']/@content\n                </Query>\n            </Queries>\n            <URL></URL>\n        </Item>\n        <Item ForURLsId=\"\" Reference=\"text\">\n            <Queries>\n            </Queries>\n            <URL></URL>\n        </Item>\n    </ToExtract>\n    <ToRemove></ToRemove>\n</Configuration>";

        document.getElementsByClassName("advance2")[0].innerText = "Simple Mode";
        this.isSimple2 = false;
      } else {
        document.getElementsByClassName("advance2")[0].innerText = "Advanced Mode";
        this.isSimple2 = true;
      }
    },
    removeUrlDiv: function removeUrlDiv(evt) {
      this.urlArray.splice(evt, 1);
      this.optionsForExtractUrl.splice(evt, 1);
      // for to remove the url if its already selected
      for (var index = 0; index < this.selectedUrlForExtract.length; index++) {
        _.remove(this.selectedUrlForExtract[index], function (id) {
          return id == evt;
        });
      }
      this.optionsForRemoveUrl.splice(evt, 1);
      // for to remove the url if its already selected
      for (var index = 0; index < this.selectedUrlForRemove.length; index++) {
        _.remove(this.selectedUrlForRemove[index], function (id) {
          return id == evt;
        });
      }
      this.clicked--;
    },
    removeTitleDiv: function removeTitleDiv(evt) {
      this.titleArray.splice(evt, 1);
      this.addDivTitle--;
    },
    removeResumeDiv: function removeResumeDiv(evt) {
      this.resumeArray.splice(evt, 1);
      this.addDivResume--;
    },
    removeImageDiv: function removeImageDiv(evt) {
      this.imageArray.splice(evt, 1);
      this.addDivImage--;
    },
    removeTextDiv: function removeTextDiv(evt) {
      this.textArray.splice(evt, 1);
      this.addDivText--;
    },
    removeRemoveQueries: function removeRemoveQueries(item, query) {
      this.removeArray[item].queries.splice(query, 1);
      this.addQueryToRemove[item]--;
      this.$forceUpdate();
    },
    removeQueryOfUrl: function removeQueryOfUrl(item, query) {
      this.toReplaceOptions[item].queryToReplace.splice(query, 1);
      this.addDivToQuery[item]--;
      this.$forceUpdate();
    },
    removeRemoveQueryUrl: function removeRemoveQueryUrl(item, query) {
      this.toRemoveOptions[item].queryToRemove.splice(query, 1);
      this.addDivToQueryOfRemove[item]--;
      this.$forceUpdate();
    },
    removeItemOfRemove: function removeItemOfRemove(item) {
      this.addDivToRemove--;
      this.addDivToRemoveQueries.splice(item, 1);
      this.selectedUrlForRemove.splice(item, 1);
      this.toRemoveOptions.splice(item, 1);
      this.$forceUpdate();
    },
    removeItemfromUrl: function removeItemfromUrl(item) {
      this.addDivPartialUrl--;
      this.selectedUrlForExtract.splice(item, 1);
      this.toReplaceOptions.splice(item, 1);
      this.addDivToQuery.splice(item, 1);
      this.addDivNotFullUrl.splice(item, 1);
      this.$forceUpdate();
    },
    removeRemoveDiv: function removeRemoveDiv(evt) {
      this.removeArray.splice(evt, 1);
      this.addDivRemove--;
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "JWrW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DeleteUrl",

  data: function data() {
    return {};
  },


  props: {
    sourceUrl: Number
  },

  components: {},

  methods: {
    DeleteUrlSouce: function DeleteUrlSouce() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.data.destroyById(_this.sourceUrl);

              case 2:
                _this.$emit("ok");
                _this.$forceUpdate();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "Jaez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"fluid":""}},[(_vm.sourceToEdit)?_c('b-modal',{attrs:{"scrollable":"","id":"editUrlSource","size":"xl","title":"Configuraçao XML1"},on:{"cancel":_vm.resetFields,"shown":_vm.loadData,"ok":_vm.createUrlSouce}},[(_vm.isSimple)?_c('div',{staticClass:"isSimple"},[_c('b-row',[_c('b-col',[_c('label',[_vm._v("URLS")])])],1),_vm._v(" "),_c('b-row',{staticClass:"borderStyler"},[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.clicked),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Url:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the url"},model:{value:(_vm.urlArray[item - 1].url),callback:function ($$v) {_vm.$set(_vm.urlArray[item - 1], "url", $$v)},expression:"urlArray[item - 1].url"}})],1),_vm._v(" "),_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"2"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeUrlDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Priority:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.urlArray[item - 1].priority),callback:function ($$v) {_vm.$set(_vm.urlArray[item - 1], "priority", $$v)},expression:"urlArray[item - 1].priority"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other url'),expression:"'Add other url'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addUrlDiv(_vm.clicked)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',[_vm._v(" TO EXTRACT")])])],1),_vm._v(" "),_c('b-row',{staticClass:"borderStyler"}),_vm._v(" "),_vm._l((_vm.addDivPartialUrl),function(item){return _c('div',{staticClass:"borderItem"},[_c('b-row',[_c('b-col',[_c('label',[_vm._v("Item "+_vm._s(item))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("For:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox-group',{attrs:{"options":_vm.optionsForUrl,"value-field":"item","text-field":"name"},model:{value:(_vm.selectedUrlForExtract[item - 1]),callback:function ($$v) {_vm.$set(_vm.selectedUrlForExtract, item - 1, $$v)},expression:"selectedUrlForExtract[item - 1]"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Eliminar Item'),expression:"'Eliminar Item'",modifiers:{"hover":true,"right":true}}],attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeItemfromUrl(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),(_vm.addDivNotFullUrl[item - 1])?_c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivToQuery[item - 1]),function(idQuery){return _c('div',{staticClass:"queryBorder"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Query:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-textarea',{attrs:{"placeholder":"Enter the query...","rows":"1","id":"text-area"},model:{value:(
                        _vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                          .query
                      ),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                          , "query", $$v)},expression:"\n                        toReplaceOptions[item - 1].queryToReplace[idQuery - 1]\n                          .query\n                      "}})],1),_vm._v(" "),(idQuery > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeQueryOfUrl(item - 1, idQuery - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Parcial Url:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox',{on:{"change":function($event){_vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                          .isPartial == false
                          ? (_vm.toReplaceOptions[item - 1].queryToReplace[
                              idQuery - 1
                            ].isPartial = true)
                          : (_vm.toReplaceOptions[item - 1].queryToReplace[
                              idQuery - 1
                            ].isPartial = false);
                        _vm.$forceUpdate();}},model:{value:(
                        _vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                          .isPartial
                      ),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                          , "isPartial", $$v)},expression:"\n                        toReplaceOptions[item - 1].queryToReplace[idQuery - 1]\n                          .isPartial\n                      "}})],1)],1),_vm._v(" "),(
                    _vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                      .isPartial
                  )?_c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("To Replace:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(
                          _vm.toReplaceOptions[item - 1].queryToReplace[
                            idQuery - 1
                          ].toReplace
                        ),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1].queryToReplace[
                            idQuery - 1
                          ], "toReplace", $$v)},expression:"\n                          toReplaceOptions[item - 1].queryToReplace[\n                            idQuery - 1\n                          ].toReplace\n                        "}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Prepare QS:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox',{model:{value:(
                          _vm.toReplaceOptions[item - 1].queryToReplace[
                            idQuery - 1
                          ].prepateQs
                        ),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1].queryToReplace[
                            idQuery - 1
                          ], "prepateQs", $$v)},expression:"\n                          toReplaceOptions[item - 1].queryToReplace[\n                            idQuery - 1\n                          ].prepateQs\n                        "}})],1)],1)],1):_vm._e()],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other url'),expression:"'Add other url'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addQueryForUrl(_vm.addDivToQuery[item - 1], item)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("URL:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(_vm.toReplaceOptions[item - 1].urlToReplace),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1], "urlToReplace", $$v)},expression:"toReplaceOptions[item - 1].urlToReplace"}})],1)],1)],1):_vm._e()],1)}),_vm._v(" "),(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other url'),expression:"'Add other url'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addPartialUrlDiv(_vm.addDivPartialUrl)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',[_vm._v(" TO REMOVE")])])],1),_vm._v(" "),_c('b-row',{staticClass:"borderStyler"}),_vm._v(" "),_vm._l((_vm.addDivToRemove),function(item){return _c('div',[_c('b-row',[_c('b-col',[_c('label',[_vm._v("Item "+_vm._s(item))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("For:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox-group',{attrs:{"options":_vm.optionsForRemoveUrl,"value-field":"item","text-field":"name"},model:{value:(_vm.selectedUrlForRemove[item - 1]),callback:function ($$v) {_vm.$set(_vm.selectedUrlForRemove, item - 1, $$v)},expression:"selectedUrlForRemove[item - 1]"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Eliminar Item'),expression:"'Eliminar Item'",modifiers:{"hover":true,"right":true}}],attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeItemOfRemove(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),(_vm.addDivToRemoveQueries[item - 1])?_c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivToQueryOfRemove[item - 1]),function(id){return _c('div',{key:id,staticClass:"queryBorder"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Query:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-textarea',{attrs:{"placeholder":"Enter the query...","rows":"1","id":"text-area"},model:{value:(
                        _vm.toRemoveOptions[item - 1].queryToRemove[id - 1].query
                      ),callback:function ($$v) {_vm.$set(_vm.toRemoveOptions[item - 1].queryToRemove[id - 1], "query", $$v)},expression:"\n                        toRemoveOptions[item - 1].queryToRemove[id - 1].query\n                      "}})],1),_vm._v(" "),(id > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeRemoveQueryUrl(item - 1, id - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("Parcial Url:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox',{on:{"change":function($event){_vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                          .isRemoved == false
                          ? (_vm.toRemoveOptions[item - 1].queryToRemove[
                              id - 1
                            ].isRemoved = true)
                          : (_vm.toRemoveOptions[item - 1].queryToRemove[
                              id - 1
                            ].isRemoved = false);
                        _vm.$forceUpdate();}}})],1)],1),_vm._v(" "),(
                    _vm.toRemoveOptions[item - 1].queryToRemove[id - 1].isRemoved
                  )?_c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("To Replace:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(
                          _vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                            .toReplace
                        ),callback:function ($$v) {_vm.$set(_vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                            , "toReplace", $$v)},expression:"\n                          toRemoveOptions[item - 1].queryToRemove[id - 1]\n                            .toReplace\n                        "}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("Prepare QS:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox',{model:{value:(
                          _vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                            .prepateQs
                        ),callback:function ($$v) {_vm.$set(_vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                            , "prepateQs", $$v)},expression:"\n                          toRemoveOptions[item - 1].queryToRemove[id - 1]\n                            .prepateQs\n                        "}})],1)],1)],1):_vm._e()],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other url'),expression:"'Add other url'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addQueryForRemove(_vm.addDivToQueryOfRemove[item - 1], item)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("URL:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(_vm.toRemoveOptions[item - 1].urlToRemove),callback:function ($$v) {_vm.$set(_vm.toRemoveOptions[item - 1], "urlToRemove", $$v)},expression:"toRemoveOptions[item - 1].urlToRemove"}})],1)],1)],1):_vm._e()],1)}),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{attrs:{"sm":"11 text-right"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add new Item'),expression:"'Add new Item'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){_vm.addDivForItemToRemove(_vm.addDivToRemove);
              _vm.toRemoveAddQueries(_vm.addDivToRemove);
              _vm.$forceUpdate();}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1)],2):_vm._e(),_vm._v(" "),(_vm.isSimple == false)?_c('div',{staticClass:"isSimple"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',[_c('b-form-textarea',{attrs:{"id":"textarea-large","rows":"12","size":"sm"},model:{value:(_vm.advancedXML),callback:function ($$v) {_vm.advancedXML=$$v},expression:"advancedXML"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"advance",attrs:{"variant":"outline-primary","size":"sm","id":"advancedBtn"},on:{"click":function($event){return _vm.advancedMode(_vm.isSimple)}}},[_vm._v("Advanced Mode")])],1):_vm._e(),_vm._v(" "),(_vm.sourceToEdit)?_c('b-modal',{attrs:{"scrollable":"","id":"editSource2","size":"xl","title":"Configuraçao XML2"},on:{"ok":_vm.createXml2,"show":_vm.loadData,"cancel":_vm.resetFields}},[(_vm.isSimple2)?_c('div',{staticClass:"isSimple2"},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Title")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivTitle),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.titleArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.titleArray[item - 1], "query", $$v)},expression:"titleArray[item - 1].query"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeTitleDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.titleArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.titleArray[item - 1], "confidenceLevel", $$v)},expression:"titleArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addTitleDiv(_vm.addDivTitle)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Resume")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivResume),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.resumeArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.resumeArray[item - 1], "query", $$v)},expression:"resumeArray[item - 1].query"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeResumeDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.resumeArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.resumeArray[item - 1], "confidenceLevel", $$v)},expression:"resumeArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addResumeDiv(_vm.addDivResume)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Image")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},[_vm._l((_vm.addDivImage),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.imageArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "query", $$v)},expression:"imageArray[item - 1].query"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeImageDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.imageArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "confidenceLevel", $$v)},expression:"imageArray[item - 1].confidenceLevel"}})],1)],1),_vm._v(" "),(item > 1)?_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Partial Url:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},on:{"change":function($event){_vm.imageArray[item - 1].isPartial == '0'
                      ? (_vm.imageArray[item - 1].isPartial = '1')
                      : (_vm.imageArray[item - 1].isPartial = '0');
                    _vm.$forceUpdate();}},model:{value:(_vm.imageArray[item - 1].isPartial),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "isPartial", $$v)},expression:"imageArray[item - 1].isPartial"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.imageArray[item - 1].isPartial == '1')?_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("To Replace:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(_vm.imageArray[item - 1].toReplace),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "toReplace", $$v)},expression:"imageArray[item - 1].toReplace"}})],1)],1):_vm._e()],1)}),_vm._v(" "),_c('b-row',{staticStyle:{"margin-bottom":"10px"}},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Url:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"URL QUERY"},model:{value:(_vm.imageArrayUrl),callback:function ($$v) {_vm.imageArrayUrl=$$v},expression:"imageArrayUrl"}})],1)],1)],2),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addImageDiv(_vm.addDivImage)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Text")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivText),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.textArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.textArray[item - 1], "query", $$v)},expression:"textArray[item - 1].query"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeTextDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"options":_vm.confidenceOptions},model:{value:(_vm.textArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.textArray[item - 1], "confidenceLevel", $$v)},expression:"textArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addTextDiv(_vm.addDivText)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Remove")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivRemove),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Reference :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-select',{attrs:{"options":_vm.removeOptions},model:{value:(_vm.removeArray[item - 1].reference),callback:function ($$v) {_vm.$set(_vm.removeArray[item - 1], "reference", $$v)},expression:"removeArray[item - 1].reference"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeRemoveDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.addQueryToRemove[item - 1]),function(idQuery){return _c('div',{key:idQuery},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},model:{value:(_vm.removeArray[item - 1].queries[idQuery - 1].query),callback:function ($$v) {_vm.$set(_vm.removeArray[item - 1].queries[idQuery - 1], "query", $$v)},expression:"removeArray[item - 1].queries[idQuery - 1].query"}})],1),_vm._v(" "),(idQuery > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeRemoveQueries(item - 1, idQuery - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1)],1)}),_vm._v(" "),_c('b-col',[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addRemoveDivQuery(_vm.addQueryToRemove[item - 1], item)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],2)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Novo Item'),expression:"'Novo Item'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addRemoveDiv(_vm.addDivRemove)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isSimple2 == false)?_c('div',{staticClass:"isSimple2"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',[_c('b-form-textarea',{attrs:{"id":"textarea-large","rows":"25","size":"sm"},model:{value:(_vm.advancedXML2),callback:function ($$v) {_vm.advancedXML2=$$v},expression:"advancedXML2"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"advance2",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.advancedMode2(_vm.isSimple2)}}},[_vm._v("Advanced Mode")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jusl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L+B5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_editor__ = __webpack_require__("+qPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tinymce_tinymce_vue__ = __webpack_require__("q47d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select_dist_vue_select_css__ = __webpack_require__("R870");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_element_resize_detector__ = __webpack_require__("471V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_element_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_element_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__popperjs_core__ = __webpack_require__("1fcd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_loader__ = __webpack_require__("Apz4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_jquery__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_element_resize_detector___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NewsEdition",

  data: function data() {
    var _createdNew, _ref;

    return _ref = {
      newsDate: {
        d: '01',
        m: '01',
        y: '2020'
      },
      newsTime: {
        h: '00',
        m: '00'
      },
      isHidden: false,
      isFiltered: 0,
      noNewsFromCheckbox: false,
      isNotCreatedNew: true,
      endpointSources: "Sources",
      lo: _,
      placement: "top",
      endpointNews: "News",
      isTrueEdited: false,
      isTruePublish: false,
      filtersUsers: [],
      endpointUsers: "Users",
      endpointNewsBySource: "News/BySource"
    }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointUsers", "Users"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointJournalist", "Journalists"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointAVE", "VAVEs"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointThemes", "VThemes"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointThemeWords", "ThemeWords"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsFilterSource", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "selectedFilterSource", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "selectedFilterUsers", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "thematicsSearch", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "imageArray", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "journalists", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "newsForLength", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsJournalists", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filteredText", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "sourceOfCreatedNew", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "contentOfCreatedNew", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "createdNew", (_createdNew = {
      c_r_Journalist: null,
      c_u_ProcessedDate: "",
      c_u_NumberOfGetTries: 0,
      c_u_NumberOfExtractTries: 0,
      c_u_RawNews: "",
      c_u_ExtractionMethod: "0,0,0,0",
      c_u_ExtractionNotes: "",
      c_u_IdentificationMethod: "",
      c_u_UrlNews: "",
      c_r_Source: 0,
      c_u_Content: "",
      c_u_ExternalID: 0
    }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_ExtractionMethod", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_ExtractionNotes", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_IdentificationMethod", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_Image", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_Keywords", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsAVE", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsCreateByUser", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsDateCreate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsFilePath", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsOriginType", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_News_MMS_ProgramName", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsThumbnail", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsidxFav", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_ProcessedDate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_Status", 5), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_Summary", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_Title", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_Type", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_isHighlighted", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsEditByUser", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsDateEdit", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsPublishedByUser", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew, "c_u_NewsPageNumber", null), _createdNew)), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsSourceForCreate", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsNewsOriginType", [{ code: 1, item: "TV" }, { code: 2, item: "Radio" }, { code: 3, item: "ePaper" }, { code: 4, item: "Online" }, { code: 5, item: "RSS" }]), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "Vave", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsAve", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "configTinyMce", {
      height: 500,
      menubar: true,
      paste_data_images: true,
      entity_encoding: "raw",
      plugins: ["advlist autolink lists link image media charmap print preview hr anchor pagebreak", "searchreplace wordcount visualblocks visualchars code fullscreen", "insertdatetime media nonbreaking save table directionality", "emoticons template paste textpattern"],
      toolbar1: "styleselect | bold italic | alignleft aligncenter alignright alignjustify | link image media",
      image_advtab: true,
      document_base_url: "" + this.getUrl,
      file_picker_callback: function file_picker_callback(cb, value, meta) {
        var div = document.getElementsByClassName("hidden");
        var input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");

        __WEBPACK_IMPORTED_MODULE_16_jquery___default()("#imageUpload").append(input);
        input.onchange = function () {
          var file = this.files[0];

          var reader = new FileReader();
          reader.onload = function () {
            var id = "blobid" + new Date().getTime();
            var blobCache = tinymce.activeEditor.editorUpload.blobCache;
            var base64 = reader.result.split(",")[1];
            var blobInfo = blobCache.create(id, file, base64);
            blobCache.add(blobInfo);

            cb(blobInfo.blobUri(), { title: file.name });
          };
          reader.readAsDataURL(file);
        };

        input.click();
      }
    }), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointImages", this.getUrl), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "sourcesArray", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filteredSourceArray", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "selectedNews", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsNews", [[]]), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "thematicItems", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsStatus", [{ code: 4, status: "Por Validar" }, { code: 5, status: "Por Editar" }, { code: 6, status: "Editadas" }, { code: 7, status: "Copiadas" }, { code: 8, status: "Publicadas" }]), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsTypeNews", [{ code: 0, type: "Sistema" },
    // { code: 1, type: "MMS" },
    // { code: 2, type: "RSS" },
    { code: 3, type: "Scraper" }]), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "selectedFilterType", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "selectedFilterStatus", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "newsArray", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filtersDates", {
      startDate: "",
      endDate: ""
    }), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filterStartDate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filterEndDate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filters", {
      source: "",
      thematic: "",
      startDate: "",
      endDate: "",
      status: 0,
      text: ""
    }), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsFilterTheme", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "selectedFilterTheme", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filteredsNews", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filteredNewsBySource", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "selectedThematics", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "thematicsArray", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filteredData", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "getUserInfoCreate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "getUserInfoEdit", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "getUserInfoPublish", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "getFormatedNewsCreatedDate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "getFormatedNewsEditedDate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "getFormatedNewsPublishedDate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointFilteredNews", "ByFilterSource"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointFiltereds", "ByFilter"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointFilteredByDate", "ByFilterDate"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointFilteredByType", "ByFilterType"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointFilteredByStatus", "ByFilterStatus"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointFilteredByUser", "ByFilterUser"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointFilteredByTheme", "ByFilterTheme"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "eachNewBySource", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "postImageData", {}), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "filtersHeight", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "optionsFavView", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "images", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "imagePath", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "scrolled", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "mediaPath", {}), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "sourceIdForScroll", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "clickedEventSourceId", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "clickedEventSourceName", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "neededArrayOfNews", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "itsAudio", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "validateNews", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "itsVideo", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "neededId", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "neededNews", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "itemsThemeWords", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "newThematicItems", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "isFilteredData", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "savedCreatedNew", {}), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "idOfCreatedNew", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "themeWordsToFind", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "themeProhibitedWordsToFind", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "isThematicDelete", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "isThematicDeleteId", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "endpointFilteredSection", "ByFilteredSection"), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "dataFromFilter", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "valueOfScroll", false), _ref;
  },

  watch: {
    isFiltered: function isFiltered(to, from) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newSourceArray, index, ScraperSources, _ScraperSources;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (to == "1") {
                  newSourceArray = [];

                  for (index = 0; index < _this.sourcesArray.length; index++) {
                    if (_this.newsForLength[_this.sourcesArray[index].c_id].totalOfNumber != 0) {
                      newSourceArray.push(_this.sourcesArray[index]);
                    }
                  }
                  ScraperSources = _.filter(newSourceArray, function (o) {
                    return o.c_u_Status == 1;
                  });

                  //old version
                  /*this.filteredSourceArray = _.sortBy(ScraperSources, [
                    function (o) {
                      return o.c_u_ReferenceSource;
                    },
                  ]);*/

                  //new version - the webapi has pre-ordered the results

                  _this.filteredSourceArray = ScraperSources;
                }
                if (to == "0") {
                  _ScraperSources = _.filter(_this.sourcesArray, function (o) {
                    return o.c_u_Status == 1;
                  });

                  //old version
                  /*this.filteredSourceArray = _.sortBy(ScraperSources, [
                    function (o) {
                      return o.c_u_ReferenceSource;
                    },
                  ]);*/

                  //new version - the webapi has pre-ordered the results

                  _this.filteredSourceArray = _ScraperSources;
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    selectedThematics: function selectedThematics(to, from) {
      var _this2 = this;

      //debugger;
      if (this.thematicsSearch != "") {
        this.thematicsSearch = "";
      }
      if (this.isThematicDelete == false) {
        to.forEach(function (to) {
          var checkedThemes = _.filter(_this2.thematicItems, function (o) {
            return o.id == to.id;
          });

          _.remove(_this2.thematicItems, function (n) {
            return n.id == to.id;
          });
          if (checkedThemes[0] != undefined) {
            _this2.thematicItems.unshift(checkedThemes[0]);
          }
        });

        var section = document.getElementById("sectionThems") != undefined ? document.getElementById("sectionThems").childNodes : [];
        for (var index = 0; index < this.selectedThematics.length; index++) {
          try {
            if (section[index].style.color != "black") {
              section[index].style = "color:Black; font-weight: bold; background-color: rgb(160, 205, 99)";
              // section[index].style = "font-weight: bold; background-color:green";
            }
          } catch (err) {}
        }
      } else {
        this.isThematicDelete = false;
        // let id = this.isThematicDeleteId;
        // let checkedThemes = _.filter(this.thematicItems, o => {
        //   return o.id == id;
        // });
        // let indexOfid = _.indexOf(this.thematicItems, checkedThemes[0]);
        // console.log(indexOfid)
        // this.thematicItems.splice(indexOfid, 1);
        // // _.remove(this.thematicItems, function(n) {
        // //   return n.id == id;
        // // });
        // let number = this.selectedThematics.length;
        // this.thematicItems.splice(number, 0,checkedThemes[0]);
      }
    },
    thematicsSearch: function thematicsSearch(to, from) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var section, index;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //debugger;
                if (_this3.thematicsSearch != "") {
                  section = [];

                  if (document.getElementsByClassName("section4Div")[0].style.display != "none") {
                    section = document.getElementsByClassName("section4Themes")[0] != undefined ? document.getElementsByClassName("section4Themes")[0].childNodes : [];
                  } else if (document.getElementsByClassName("section6Div")[0].style.display != "none") {
                    section = document.getElementsByClassName("section6Themes")[0] != undefined ? document.getElementsByClassName("section6Themes")[0].childNodes : [];
                  }

                  for (index = 0; index < _this3.thematicItems.length; index++) {
                    try {
                      if (section[index].style.color == "black") {
                        section[index].style = "";
                      }
                    } catch (err) {}
                  }

                  _this3.thematicItems = _.filter(_this3.newThematicItems, function (theme) {
                    return theme.wordName ? theme.wordName.toLowerCase().indexOf(_this3.thematicsSearch.toLowerCase()) > -1 : false;
                  });
                  _this3.thematicItems = _.uniqBy(_this3.thematicItems, "wordName");
                } else {
                  _this3.isThematicDelete == false;
                  _this3.thematicItems = _.xor(_this3.newThematicItems);
                  setTimeout(function () {
                    //section is always undefined because this is executed before it is drawn; using a timed function to execute and not be undefined
                    var section = [];
                    if (document.getElementsByClassName("section4Div")[0].style.display != "none") {
                      section = document.getElementsByClassName("section4Themes")[0] != undefined ? document.getElementsByClassName("section4Themes")[0].childNodes : [];
                    } else if (document.getElementsByClassName("section6Div")[0].style.display != "none") {
                      section = document.getElementsByClassName("section6Themes")[0] != undefined ? document.getElementsByClassName("section6Themes")[0].childNodes : [];
                    }
                    //console.log("section", section);
                    //console.log("this.selectedThematics", this.selectedThematics);
                    //console.log("this.thematicItems", this.thematicItems);
                    for (var _index = 0; _index < _this3.selectedThematics.length; _index++) {
                      _this3.thematicItems.unshift(_this3.selectedThematics[_index]);
                      try {
                        section[_index].style = "color:Black; font-weight: bold; background-color: rgb(160, 205, 99)";
                      } catch (err) {}
                    }
                    _this3.thematicItems = _.uniqBy(_this3.thematicItems, "wordName");
                  }, 1500);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    validateNews: function validateNews(to, from) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var predicate;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //debugger;
                if (to == true) {
                  predicate = function predicate(start, end) {
                    return function (_ref2) {
                      var c_u_Status = _ref2.c_u_Status;
                      return c_u_Status != start && c_u_Status != end;
                    };
                  };

                  _this4.filteredsNews = _this4.filteredsNews.filter(predicate(8, 10));
                  if (_this4.filteredsNews.length == 0) {
                    _this4.noNewsFromCheckbox = true;
                  } else {
                    _this4.noNewsFromCheckbox = false;
                  }
                } else {
                  if (_this4.isFilteredData == true) {
                    _this4.filteredsNews = _this4.dataFromFilter;
                  } else {
                    _this4.filteredsNews = _this4.neededArrayOfNews;
                  }
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    sourceOfCreatedNew: function sourceOfCreatedNew(to, from) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(to != null)) {
                  _context4.next = 8;
                  break;
                }

                _this5.Vave = [];
                _this5.optionsAve = [];
                //receive the list of AVES
                _this5.$api.data.endpoint = _this5.endpointAVE;
                _context4.next = 6;
                return _this5.$api.data.findOneById(to);

              case 6:
                _this5.Vave = _context4.sent;

                for (index = 0; index < _this5.Vave.length; index++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this5.optionsAve, index, {
                    id: _this5.Vave[index].id,
                    newAve: _this5.Vave[index].aveText
                  });
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    idOfCreatedNew: function idOfCreatedNew(to, from) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this6$createdNew;

        var _loop, index, section, NewsLengthResponse, _index2, NewsLengthForSource, index2, NewsLengthResponseItem;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop(index) {
                  var objectThemesWord, findOneByIdThemes, findThemeNews, objectThemes;
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          objectThemesWord = {
                            c_u_Words: _this6.selectedThematics[index].wordName,
                            c_u_ThemeId: _this6.selectedThematics[index].id
                          };

                          _this6.$api.data.endpoint = "ThemeWords";
                          _context5.t0 = _;
                          _context5.next = 5;
                          return _this6.$api.data.find();

                        case 5:
                          _context5.t1 = _context5.sent;

                          _context5.t2 = function (o) {
                            return o.c_u_ThemeId == objectThemesWord.c_u_ThemeId;
                          };

                          findOneByIdThemes = _context5.t0.find.call(_context5.t0, _context5.t1, _context5.t2);

                          _this6.$api.data.endpoint = "ThemeWordsNews/Thematics/" + to;
                          _context5.t3 = _;
                          _context5.next = 12;
                          return _this6.$api.data.find();

                        case 12:
                          _context5.t4 = _context5.sent;

                          _context5.t5 = function (r) {
                            return r.themeNews == to && r.themeWordId == findOneByIdThemes.c_u_ThemeId;
                          };

                          findThemeNews = _context5.t3.find.call(_context5.t3, _context5.t4, _context5.t5);

                          if (!(findThemeNews == undefined)) {
                            _context5.next = 20;
                            break;
                          }

                          _this6.$api.data.endpoint = "ThemeWordsNews";
                          objectThemes = {
                            c_u_MatchedWords: findOneByIdThemes.c_u_Words,
                            c_u_Type: 0,
                            c_u_Status: 1,
                            c_r_ThemeWords: findOneByIdThemes.c_id,
                            c_r_News: to
                          };
                          _context5.next = 20;
                          return _this6.$api.data.create(objectThemes);

                        case 20:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _loop, _this6);
                });
                index = 0;

              case 2:
                if (!(index < _this6.selectedThematics.length)) {
                  _context6.next = 7;
                  break;
                }

                return _context6.delegateYield(_loop(index), "t0", 4);

              case 4:
                index++;
                _context6.next = 2;
                break;

              case 7:

                _this6.imagesUpload(to);
                //clear all data after its created
                _this6.contentOfCreatedNew = "";
                _this6.createdNew = (_this6$createdNew = {
                  c_r_Journalist: null,
                  c_u_ProcessedDate: "",
                  c_u_NumberOfGetTries: 0,
                  c_u_NumberOfExtractTries: 0,
                  c_u_RawNews: "",
                  c_u_ExtractionMethod: "0,0,0,0",
                  c_u_ExtractionNotes: "",
                  c_u_IdentificationMethod: "",
                  c_u_UrlNews: "",
                  c_r_Source: 0,
                  c_u_Content: "",
                  c_u_ExternalID: 0
                }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_ExtractionMethod", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_ExtractionNotes", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_IdentificationMethod", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_Image", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_Keywords", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_NewsAVE", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_NewsCreateByUser", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_NewsDateCreate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_NewsFilePath", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_NewsOriginType", _this6.createdNew.c_u_NewsOriginType), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_News_MMS_ProgramName", _this6.createdNew.c_u_News_MMS_ProgramName), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_NewsThumbnail", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_NewsidxFav", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_ProcessedDate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_Status", 5), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_Summary", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_Title", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_Type", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_isHighlighted", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_this6$createdNew, "c_u_NewsPageNumber", null), _this6$createdNew);
                _this6.selectedThematics = [];
                section = document.getElementById("sectionThems") != undefined ? document.getElementById("sectionThems").childNodes : [];

                for (index = 0; index < section.length; index++) {
                  if (section[index].style.color == "black") {
                    section[index].style.color = null;
                    section[index].style.backgroundColor = null;
                    section[index].style.fontWeight = null;
                  }
                }
                _this6.journalists = [];
                _this6.Vave = [];

                try {
                  _this6.postImageData = null;
                } catch (err) {}
                try {
                  _this6.mediaPath = null;
                } catch (err) {}
                document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
                document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";
                document.getElementById("audioUploaded") != null ? document.getElementById("audioUploaded").remove() : "";
                document.getElementById("videoUploaded") != null ? document.getElementById("videoUploaded").remove() : "";
                document.getElementById("filesMedia1") != null ? document.getElementById("filesMedia1").value = "" : "";
                document.getElementById("filesMedia2") != null ? document.getElementById("filesMedia2").value = "" : "";
                document.getElementById("output") != null ? document.getElementById("output").src = "" : "";
                document.getElementById("files") != null ? document.getElementById("files").value = "" : "";

                //refresh the number of news in the section of sources
                //old NewsLength
                /*for (let index = 0; index < this.sourcesArray.length; index++) {
                  this.$api.data.endpoint = `Sources/NewsLength/${this.sourcesArray[index].c_id}`;
                  this.newsForLength[
                    this.sourcesArray[index].c_id
                  ] = await this.$api.data.find();
                }*/

                //new NewsLength
                _this6.$api.data.endpoint = "Sources/NewsLength";
                _context6.next = 28;
                return _this6.$api.data.find();

              case 28:
                NewsLengthResponse = _context6.sent;
                _index2 = 0;

              case 30:
                if (!(_index2 < _this6.sourcesArray.length)) {
                  _context6.next = 45;
                  break;
                }

                NewsLengthForSource = { totalOfNumber: 0, isTrue: false };
                index2 = 0;

              case 33:
                if (!(index2 < NewsLengthResponse.length)) {
                  _context6.next = 41;
                  break;
                }

                NewsLengthResponseItem = NewsLengthResponse[index2];

                if (!(NewsLengthResponseItem.sourceID == _this6.sourcesArray[_index2].c_id)) {
                  _context6.next = 38;
                  break;
                }

                NewsLengthForSource = {
                  totalOfNumber: NewsLengthResponseItem.numNews,
                  isTrue: NewsLengthResponseItem.hasEditedNews
                };
                return _context6.abrupt("break", 41);

              case 38:
                index2++;
                _context6.next = 33;
                break;

              case 41:
                _this6.newsForLength[_this6.sourcesArray[_index2].c_id] = NewsLengthForSource;

              case 42:
                _index2++;
                _context6.next = 30;
                break;

              case 45:
                //console.log("this.newsForLength", this.newsForLength);

                _this6.$forceUpdate();

              case 46:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])({
    getUserId: "auth/getUserId",
    getUrl: "api/getUrl"
  }), {
    _newsDate: {
      get: function get() {
        var _newsDate = this.newsDate,
            d = _newsDate.d,
            m = _newsDate.m,
            y = _newsDate.y;

        return y + "-" + m + "-" + d;
      },
      set: function set(newVal) {
        var _newVal$split = newVal.split('-'),
            _newVal$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_newVal$split, 3),
            y = _newVal$split2[0],
            m = _newVal$split2[1],
            d = _newVal$split2[2];

        this.newsDate = { y: y, m: m, d: d };
      }
    },
    _newsTime: {
      get: function get() {
        var _newsTime = this.newsTime,
            h = _newsTime.h,
            m = _newsTime.m;

        return h + ":" + m;
      },
      set: function set(newVal) {
        var _newVal$split3 = newVal.split(':'),
            _newVal$split4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_newVal$split3, 2),
            h = _newVal$split4[0],
            m = _newVal$split4[1];

        this.newsTime = { h: h, m: m };
      }
    }
  }),
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_9_vue2_editor__["a" /* VueEditor */],
    editor: __WEBPACK_IMPORTED_MODULE_10__tinymce_tinymce_vue__["a" /* default */],
    vSelect: __WEBPACK_IMPORTED_MODULE_11_vue_select___default.a
  },

  methods: {
    handleModelLogoutHide: function handleModelLogoutHide(e) {
      this.$api.logout();
    },
    onResize: function onResize(e) {
      if (window.innerWidth < 1600) {
        document.getElementsByClassName("createBtnFonte")[0].innerHTML = "Atualizar";
        if (window.innerHeight < 750) {
          var number = document.getElementsByClassName("section2Div")[0].clientHeight * 0.5;
          var numberOfContentSection1 = document.getElementsByClassName("section1")[0].clientHeight * 0.5;
          document.getElementsByClassName("contentOfSection1")[0].style.height = numberOfContentSection1 + "px";
          document.getElementsByClassName("section4Div")[0].style.height = "80%";
          document.getElementsByClassName("section2")[0].style.height = number + "px";
          document.getElementsByClassName("section3")[0].style.height = number + "px";
          document.getElementsByClassName("section5")[0].style.height = number + "px";
          document.getElementsByClassName("section6Div")[0].style.height = "80%";
        } else {
          var valueOfSection2 = "60%";
          var valueOfSection3 = "60%";
          var valueOfSection4 = "85%";
          var valueOfSection5 = "60%";
          var valueOfSection6 = "85%";
          var valueOfContentSection1 = "50%";
          document.getElementsByClassName("contentOfSection1")[0].style.height = "" + valueOfContentSection1;
          document.getElementsByClassName("section4Div")[0].style.height = "" + valueOfSection4;
          document.getElementsByClassName("section6Div")[0].style.height = "" + valueOfSection6;
          document.getElementsByClassName("section2")[0].style.height = "" + valueOfSection2;
          // section3 if screen is less than 1600
          document.getElementsByClassName("section3")[0].style.height = "" + valueOfSection3;
          document.getElementsByClassName("section5")[0].style.height = "" + valueOfSection5;
        }

        document.getElementsByClassName("btn1section2")[0].style = "padding:0px";
        document.getElementsByClassName("btn2section2")[0].style = "padding:0px";
        document.getElementsByClassName("btn3section2")[0].style = "padding:0px";
        document.getElementsByClassName("btnClear")[0].style = "";
        document.getElementsByClassName("btnSearch")[0].style = "margin-right: 25px;padding: 0px;";
        document.getElementsByClassName("ifLowWidth")[0].style = "display:none;";
        document.getElementsByClassName("textBtn")[0].style = "padding:0px 2px;";
      }
      if (window.innerWidth < 1350) {
        document.getElementsByClassName("createBtnFonte")[0].innerHTML = "Atualizar";
        if (window.innerHeight < 750) {
          var _number = (document.getElementsByClassName("section2Div")[0].clientHeight - this.filtersHeight) * 0.55;
          var _numberOfContentSection = document.getElementsByClassName("section1")[0].clientHeight * 0.5;
          document.getElementsByClassName("contentOfSection1")[0].style.height = _number + "px";
          document.getElementsByClassName("section4Div")[0].style.height = "60%";
          document.getElementsByClassName("section6Div")[0].style.height = "60%";
          document.getElementsByClassName("section2")[0].style.height = _number + "px";
          document.getElementsByClassName("section3")[0].style.height = _number + "px";
          document.getElementsByClassName("section5")[0].style.height = _number + "px";
        } else {
          var _valueOfSection = "55%";
          var _valueOfSection2 = "55%";
          var _valueOfSection3 = "75%";
          var _valueOfSection4 = "53%";
          var _valueOfSection5 = "70%";
          var _valueOfContentSection = "50%";
          document.getElementsByClassName("contentOfSection1")[0].style.height = "" + _valueOfContentSection;
          document.getElementsByClassName("section4Div")[0].style.height = "" + _valueOfSection3;
          document.getElementsByClassName("section6Div")[0].style.height = "" + _valueOfSection5;
          document.getElementsByClassName("section2")[0].style.height = "" + _valueOfSection;
          // section3 if screen is less than 1600
          document.getElementsByClassName("section3")[0].style.height = "" + _valueOfSection2;
          document.getElementsByClassName("section5")[0].style.height = "" + _valueOfSection4;
        }

        document.getElementsByClassName("btn1section2")[0].style = "padding:0px";
        document.getElementsByClassName("btn2section2")[0].style = "padding:0px";
        document.getElementsByClassName("btn3section2")[0].style = "padding:0px";
        document.getElementsByClassName("btnClear")[0].style = "display:none";
        document.getElementsByClassName("btnSearch")[0].style = "display:none";
        document.getElementsByClassName("ifLowWidth")[0].style = "";
        document.getElementsByClassName("textBtn")[0].style = "padding:0px 2px; margin-right:25px";
      }
      if (window.innerWidth <= 1200) {
        document.getElementsByClassName("createBtnFonte")[0].innerHTML = "Atualizar";
        if (window.innerHeight < 750) {
          var _number2 = (document.getElementsByClassName("section2Div")[0].clientHeight - this.filtersHeight) * 0.5;
          var _numberOfContentSection2 = document.getElementsByClassName("section1")[0].clientHeight * 0.45;
          document.getElementsByClassName("contentOfSection1")[0].style.height = _numberOfContentSection2 + "px";
          document.getElementsByClassName("section4Div")[0].style.height = "60%";
          document.getElementsByClassName("section6Div")[0].style.height = "60%";
          document.getElementsByClassName("section2")[0].style.height = _number2 + "px";
          document.getElementsByClassName("section3")[0].style.height = _number2 + "px";
          document.getElementsByClassName("section5")[0].style.height = _number2 + "px";
        } else {
          var _valueOfSection6 = "60%";
          var _valueOfSection7 = "60%";
          var _valueOfSection8 = "65%";
          var _valueOfSection9 = "60%";
          var _valueOfSection10 = "65%";
          var _valueOfContentSection2 = "45%";
          document.getElementsByClassName("contentOfSection1")[0].style.height = "" + _valueOfContentSection2;
          document.getElementsByClassName("section4Div")[0].style.height = "" + _valueOfSection8;
          document.getElementsByClassName("section6Div")[0].style.height = "" + _valueOfSection10;
          document.getElementsByClassName("section2")[0].style.height = "" + _valueOfSection6;
          // section3 if screen is less than 1600
          document.getElementsByClassName("section3")[0].style.height = "" + _valueOfSection7;
          document.getElementsByClassName("section5")[0].style.height = "" + _valueOfSection9;
        }
        // let valueOfSection2 = "55%";
        // let valueOfSection3 = "55%";
        // document.getElementsByClassName(
        //   "section2"
        // )[0].style.height = `${valueOfSection2}`;
        document.getElementsByClassName("btn1section2")[0].style = "padding:0px";
        document.getElementsByClassName("btn2section2")[0].style = "padding:0px";
        document.getElementsByClassName("btn3section2")[0].style = "padding:0px";

        document.getElementsByClassName("btnClear")[0].style = "display:none";
        document.getElementsByClassName("btnSearch")[0].style = "display:none";
        document.getElementsByClassName("ifLowWidth")[0].style = "";
        document.getElementsByClassName("textBtn")[0].style = "padding:0px 2px; margin-right:25px";
        // section3 if screen is less than 1600
        // document.getElementsByClassName(
        //   "section3"
        // )[0].style.height = `${valueOfSection3}`;
      }
      if (window.innerWidth >= 1600) {
        document.getElementsByClassName("section2")[0].style.height = "";
        document.getElementsByClassName("btn1section2")[0].style = "";
        document.getElementsByClassName("btn2section2")[0].style = "";
        document.getElementsByClassName("btn3section2")[0].style = "";
        document.getElementsByClassName("contentOfSection1")[0].style.height = "";
        document.getElementsByClassName("section4Div")[0].style.height = "";
        document.getElementsByClassName("section6Div")[0].style.height = "";
        // section3 if screen is less than 1600
        document.getElementsByClassName("section3")[0].style.height = "";
        document.getElementsByClassName("section5")[0].style.height = "";
        document.getElementsByClassName("createBtnFonte")[0].innerHTML = "Atualizar SRC";
        document.getElementsByClassName("btnClear")[0].style = "";
        document.getElementsByClassName("ifLowWidth")[0].style = "display:none;";
        document.getElementsByClassName("btnSearch")[0].style = "margin-right: 25px;padding: 0px;";
        document.getElementsByClassName("textBtn")[0].style = "padding:0px 2px;";
      }

      if (e != undefined) {
        if (e.detail.height > this.filtersHeight) {
          document.getElementsByClassName("section2Div")[0].style.height = "calc(100% - " + e.detail.height + "px)";
          document.getElementsByClassName("section3Div")[0].style.height = "calc(100% - " + e.detail.height + "px)";
          //document.body.style = "overflow-y:scroll";
        } else {
          document.getElementsByClassName("section2Div")[0].style.height = "";
          document.getElementsByClassName("section3Div")[0].style.height = "";

          // document.body.style.overflow = "hidden";
          // window.scrollTo(0, 0);
        }
      }
    },
    getLoggedInUserID: function getLoggedInUserID() {
      var UserID1 = this.getUserId;
      var UserID2 = parseInt(document.getElementById("ithUserID").value, 10);
      if (UserID1) {
        return UserID1;
      } else {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(UserID2)) {
          return UserID2;
        } else {
          return 0;
        }
      }
    },
    thematicKBDown: function thematicKBDown() {
      //debugger;
      var ThemesContainer = document.getElementById("sectionThems");
      var FirstElement = null;
      if (ThemesContainer.childElementCount > 0) {
        FirstElement = ThemesContainer.childNodes[0];
      }
      var CurrentKBElement = ThemesContainer.querySelector("[kb='1']");
      if (CurrentKBElement !== null) {
        var NextElement = CurrentKBElement.nextElementSibling;
        if (NextElement != null) {
          var Elements = ThemesContainer.childNodes;
          for (var i = 0; i < Elements.length; i++) {
            Elements[i].setAttribute("kb", "0");
          }
          NextElement.setAttribute("kb", "1");
          var ScrollTop = NextElement.offsetTop - NextElement.offsetHeight / 2 - ThemesContainer.offsetHeight / 2;
          ThemesContainer.scrollTop = NextElement.offsetTop > ThemesContainer.offsetHeight / 2 ? ScrollTop : 0;
        }
      } else if (FirstElement != null) {
        var Elements = ThemesContainer.childNodes;
        for (var i = 0; i < Elements.length; i++) {
          Elements[i].setAttribute("kb", "0");
        }
        FirstElement.setAttribute("kb", "1");
        var ScrollTop = FirstElement.offsetTop - FirstElement.offsetHeight / 2 - ThemesContainer.offsetHeight / 2;
        ThemesContainer.scrollTop = FirstElement.offsetTop > ThemesContainer.offsetHeight / 2 ? ScrollTop : 0;
      }
    },
    thematicKBUp: function thematicKBUp() {
      //debugger;
      var ThemesContainer = document.getElementById("sectionThems");
      var LastElement = null;
      if (ThemesContainer.childElementCount > 0) {
        LastElement = ThemesContainer.childNodes[ThemesContainer.childElementCount - 1];
      }
      var CurrentKBElement = ThemesContainer.querySelector("[kb='1']");
      if (CurrentKBElement != null) {
        var PreviousElement = CurrentKBElement.previousElementSibling;
        if (PreviousElement != null) {
          var Elements = ThemesContainer.childNodes;
          for (var i = 0; i < Elements.length; i++) {
            Elements[i].setAttribute("kb", "0");
          }
          PreviousElement.setAttribute("kb", "1");
          var ScrollTop = PreviousElement.offsetTop - PreviousElement.offsetHeight / 2 - ThemesContainer.offsetHeight / 2;
          ThemesContainer.scrollTop = PreviousElement.offsetTop > ThemesContainer.offsetHeight / 2 ? ScrollTop : 0;
        }
      } else if (LastElement != null) {
        var Elements = ThemesContainer.childNodes;
        for (var i = 0; i < Elements.length; i++) {
          Elements[i].setAttribute("kb", "0");
        }
        LastElement.setAttribute("kb", "1");
        var ScrollTop = LastElement.offsetTop - LastElement.offsetHeight / 2 - ThemesContainer.offsetHeight / 2;
        ThemesContainer.scrollTop = LastElement.offsetTop > ThemesContainer.offsetHeight / 2 ? ScrollTop : 0;
      }
    },
    thematicKBLeft: function thematicKBLeft() {
      //debugger;
      try {
        var ThemesContainer = document.getElementById("sectionThems");
        var CurrentKBElement = ThemesContainer.querySelector("[kb='1']");
        if (CurrentKBElement != null) {
          var ID = CurrentKBElement.getAttribute("data-id");
          var Section = null;
          if (!this.isNotCreatedNew) {
            //new news
            Section = document.getElementsByClassName("section5")[0];
          } else {
            //edit news
            Section = document.getElementsByClassName("section3")[0];
          }
          var ThematicsContainer = Section.querySelector(".thematics");
          var Thematic = ThematicsContainer.querySelector(".thematic[data-id='" + ID + "']");
          var RemoveThematic = Thematic.querySelector(".thematicRemove");
          RemoveThematic.dispatchEvent(new Event('click'));
        }
      } catch (err) {}
    },
    thematicKBRight: function thematicKBRight() {
      //debugger;
      var ThemesContainer = document.getElementById("sectionThems");
      var CurrentKBElement = ThemesContainer.querySelector("[kb='1']");
      if (CurrentKBElement != null) {
        CurrentKBElement.click();
      }
    },
    thematicKB: function thematicKB(pEvent) {
      //debugger;
      //console.log("pEvent", pEvent);
      try {
        if (pEvent.keyCode == 40) {
          //key arrow down
          this.thematicKBDown();
        } else if (pEvent.keyCode == 38) {
          //key arrow up
          this.thematicKBUp();
        } else if (pEvent.keyCode == 37) {
          //key arrow left
          this.thematicKBLeft();
        } else if (pEvent.keyCode == 39) {
          //key arrow right
          this.thematicKBRight();
        }
      } catch (err) {}
    },
    setInterfaceNewsDateTime: function setInterfaceNewsDateTime(pDateTime) {
      try {
        //debugger;
        //console.log("datetime: " + pDateTime);
        var NewsDate = new Date(moment(pDateTime)._d);
        var Year = NewsDate.getFullYear();
        var Month = NewsDate.getMonth() + 1;
        Month = (Month < 10 ? "0" : "") + Month;
        var Day = NewsDate.getDate();
        Day = (Day < 10 ? "0" : "") + Day;

        var Hours = NewsDate.getHours();
        Hours = (Hours < 10 ? "0" : "") + Hours;
        var Minutes = NewsDate.getMinutes();
        Minutes = (Minutes < 10 ? "0" : "") + Minutes;

        this._newsDate = Year + "-" + Month + "-" + Day;
        this._newsTime = Hours + ":" + Minutes;
      } catch (err) {}
    },
    showData: function showData() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var NewsLengthResponse, index, NewsLengthForSource, index2, NewsLengthResponseItem, ScraperSources, _index3, viewFavorability, _index4, viewThemes, _loop2, _index5, _index6, usersArray, _index7;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!_this7.getLoggedInUserID()) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 5;
                break;

              case 3:
                //this.$bvModal.show("modal-logout");
                _this7.$refs["modal-logout"].show();
                //this.$api.logout();
                return _context7.abrupt("return");

              case 5:

                _this7.$api.data.endpoint = _this7.endpointSources;
                _context7.next = 8;
                return _this7.$api.data.find();

              case 8:
                _this7.sourcesArray = _context7.sent;


                //old NewsLength
                /*for (let index = 0; index < this.sourcesArray.length; index++) {
                  this.$api.data.endpoint = `Sources/NewsLength/${this.sourcesArray[index].c_id}`;
                  this.newsForLength[
                    this.sourcesArray[index].c_id
                  ] = await this.$api.data.find();
                }*/

                //new NewsLength
                _this7.$api.data.endpoint = "Sources/NewsLength";
                _context7.next = 12;
                return _this7.$api.data.find();

              case 12:
                NewsLengthResponse = _context7.sent;
                index = 0;

              case 14:
                if (!(index < _this7.sourcesArray.length)) {
                  _context7.next = 29;
                  break;
                }

                NewsLengthForSource = { totalOfNumber: 0, isTrue: false };
                index2 = 0;

              case 17:
                if (!(index2 < NewsLengthResponse.length)) {
                  _context7.next = 25;
                  break;
                }

                NewsLengthResponseItem = NewsLengthResponse[index2];

                if (!(NewsLengthResponseItem.sourceID == _this7.sourcesArray[index].c_id)) {
                  _context7.next = 22;
                  break;
                }

                NewsLengthForSource = {
                  totalOfNumber: NewsLengthResponseItem.numNews,
                  isTrue: NewsLengthResponseItem.hasEditedNews
                };
                return _context7.abrupt("break", 25);

              case 22:
                index2++;
                _context7.next = 17;
                break;

              case 25:
                _this7.newsForLength[_this7.sourcesArray[index].c_id] = NewsLengthForSource;

              case 26:
                index++;
                _context7.next = 14;
                break;

              case 29:
                //console.log("this.newsForLength", this.newsForLength);

                // order the sources by who have more news
                ScraperSources = _.filter(_this7.sourcesArray, function (o) {
                  return o.c_u_Status == 1;
                });

                //old version
                /*this.filteredSourceArray = _.sortBy(ScraperSources, [
                  function (o) {
                    return o.c_u_ReferenceSource;
                  },
                ]);*/

                //new version - the webapi has pre-ordered the results

                _this7.filteredSourceArray = ScraperSources;

                for (_index3 = 0; _index3 < _this7.sourcesArray.length; _index3++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this7.optionsFilterSource, _index3, {
                    item: _this7.sourcesArray[_index3].c_u_ReferenceSource,
                    code: _this7.sourcesArray[_index3].c_id
                  });
                }

                //receive the favorability from the view table in sql
                _this7.$api.data.endpoint = "VFavorability";
                _context7.next = 35;
                return _this7.$api.data.find();

              case 35:
                viewFavorability = _context7.sent;

                for (_index4 = 0; _index4 < viewFavorability.length; _index4++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this7.optionsFavView, _index4, {
                    id: viewFavorability[_index4].id,
                    fav: viewFavorability[_index4].favorability
                  });
                }

                //receive the themes from the view table in sql
                _this7.$api.data.endpoint = "VThemes";
                _context7.next = 40;
                return _this7.$api.data.find();

              case 40:
                viewThemes = _context7.sent;

                _this7.$api.data.endpoint = _this7.endpointThemeWords;
                _context7.next = 44;
                return _this7.$api.data.find();

              case 44:
                _this7.itemsThemeWords = _context7.sent;

                _loop2 = function _loop2(_index5) {
                  var id = _this7.itemsThemeWords[_index5].c_u_ThemeId;
                  var thm = _.find(viewThemes, function (o) {
                    return o.id == id;
                  });
                  _this7.itemsThemeWords[_index5] = {
                    c_id: _this7.itemsThemeWords[_index5].c_id,
                    c_u_ThemeId: _this7.itemsThemeWords[_index5].c_u_ThemeId,
                    c_u_Words: _this7.itemsThemeWords[_index5].c_u_Words,
                    wordName: thm == undefined ? thm : thm.wordName
                  };
                  //console.log("this.itemsThemeWords[index]: ", this.itemsThemeWords[index]);
                };

                //debugger;
                for (_index5 = 0; _index5 < _this7.itemsThemeWords.length; _index5++) {
                  _loop2(_index5);
                }
                _.remove(_this7.itemsThemeWords, function (n) {
                  return n.wordName == undefined;
                });
                for (_index6 = 0; _index6 < _this7.itemsThemeWords.length; _index6++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this7.optionsFilterTheme, _index6, {
                    code: _this7.itemsThemeWords[_index6].c_u_ThemeId,
                    theme: _this7.itemsThemeWords[_index6].wordName
                  });
                }
                // for (let index = 0; index < viewThemes.length; index++) {
                //   Vue.set(this.optionsFilterTheme, index, {
                //     code: viewThemes[index].id,
                //     theme: viewThemes[index].wordName
                //   });
                // }

                //receive the users from the table in sql
                _this7.$api.data.endpoint = _this7.endpointUsers;
                _context7.next = 52;
                return _this7.$api.data.find();

              case 52:
                usersArray = _context7.sent;

                for (_index7 = 0; _index7 < usersArray.length; _index7++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this7.filtersUsers, _index7, {
                    id: usersArray[_index7].userID,
                    name: usersArray[_index7].displayName
                  });
                }
                document.getElementById("themeDropDown").getElementsByTagName("ul")[0].style.width = "450px";
                document.getElementById("usersDropDown").getElementsByTagName("ul")[0].style.width = "350px";

              case 56:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    handleScrolll: function handleScrolll() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var that;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = _this8;

                __WEBPACK_IMPORTED_MODULE_16_jquery___default()("#section2").on("scroll", function () {
                  if (__WEBPACK_IMPORTED_MODULE_16_jquery___default()("#section2").prop("scrollHeight") - __WEBPACK_IMPORTED_MODULE_16_jquery___default()("#section2").scrollTop() <= Math.ceil(__WEBPACK_IMPORTED_MODULE_16_jquery___default()("#section2").height())) {
                    that.valueOfScroll = true;
                    that.$forceUpdate();
                  } else {
                    that.valueOfScroll = false;
                    that.$forceUpdate();
                  }
                });
                // if (this.isFilteredData == false && this.filteredText == "") {
                //   let itsFinal = 0;
                //   let that = this;
                //   let newDataOfNews = [];
                //   $("#section2").on("scroll", async function () {
                //     var scrollPosition = Math.round(
                //       $(this).scrollTop() + $(this).innerHeight(),
                //       10
                //     );
                //     var divTotalHeight =
                //       $(this)[0].scrollHeight +
                //       parseInt($(this).css("padding-top"), 10) +
                //       parseInt($(this).css("padding-bottom"), 10) +
                //       parseInt($(this).css("border-top-width"), 10) +
                //       parseInt($(this).css("border-bottom-width"), 10);
                //     if (scrollPosition == divTotalHeight && itsFinal == 0) {
                //       that.$api.data.endpoint = `News/scrollDown/${that.sourceIdForScroll}/${that.neededArrayOfNews.length}`;
                //       newDataOfNews = await that.$api.data.find();
                //       for (let index = 0; index < newDataOfNews.length; index++) {
                //         that.neededArrayOfNews.push(newDataOfNews[index]);
                //       }
                //       that.filteredsNews = that.neededArrayOfNews;
                //       for (let index = 0; index < that.filteredsNews.length; index++) {
                //         that.optionsNews[index] = [];
                //         that.optionsNews[index].push({
                //           item: that.filteredsNews[index].c_id,
                //           name: "",
                //         });
                //       }
                //     }

                //     itsFinal++;
                //   });
                //   if (this.validateNews == true) {
                //     // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
                //     //   return o.c_u_Status != 8;
                //     // });
                //     const predicate = (start, end) => ({ c_u_Status }) =>
                //   c_u_Status != start && c_u_Status != end;

                //   this.filteredsNews = this.filteredsNews.filter(predicate(8,10));
                //   } else {
                //     this.filteredsNews = this.neededArrayOfNews;
                //   }
                // }
                // if (this.isFilteredData == true) {
                //   let itsFinal = 0;
                //   let that = this;
                //   $("#section2").on("scroll", async function () {
                //     var scrollPosition = Math.round(
                //       $(this).scrollTop() + $(this).innerHeight(),
                //       10
                //     );
                //     var divTotalHeight =
                //       $(this)[0].scrollHeight +
                //       parseInt($(this).css("padding-top"), 10) +
                //       parseInt($(this).css("padding-bottom"), 10) +
                //       parseInt($(this).css("border-top-width"), 10) +
                //       parseInt($(this).css("border-bottom-width"), 10);
                //     if (scrollPosition == divTotalHeight && itsFinal == 0) {
                //       if (
                //         that.filtersDates.startDate != "" &&
                //         that.filtersDates.endDate == ""
                //       ) {
                //         let todaysDate = new Date();
                //         todaysDate =
                //           todaysDate.getFullYear() +
                //           "-" +
                //           (todaysDate.getMonth() + 1 < 10
                //             ? "0" + (todaysDate.getMonth() + 1)
                //             : todaysDate.getMonth() + 1) +
                //           "-" +
                //           (todaysDate.getDate() < 10
                //             ? "0" + todaysDate.getDate()
                //             : todaysDate.getDate());
                //         that.filtersDates.endDate = todaysDate;
                //       }
                //       let urlEncoderSource =
                //         that.selectedFilterSource.length != 0
                //           ? encodeURIComponent(that.selectedFilterSource.toString())
                //           : 0;
                //       let startDateFilter =
                //         that.filtersDates.startDate == ""
                //           ? 0
                //           : that.filtersDates.startDate;
                //       let endDateFilter =
                //         that.filtersDates.endDate == "" ? 0 : that.filtersDates.endDate;
                //       let statusFilter =
                //         typeof that.selectedFilterStatus != "number"
                //           ? 0
                //           : that.selectedFilterStatus;
                //       let typeFilter =
                //         typeof that.selectedFilterType != "number"
                //           ? 20
                //           : that.selectedFilterType;
                //       let themeFilter =
                //         typeof that.selectedFilterTheme != "number"
                //           ? 0
                //           : that.selectedFilterTheme;
                //       let userFilter =
                //         typeof that.selectedFilterUsers != "number"
                //           ? 0
                //           : that.selectedFilterUsers;
                //       let textFilter = that.filteredText == "" ? 0 : that.filteredText;

                //       //Call the endpoint of filter
                //       that.$api.data.endpoint = `${that.endpointNews}/${that.endpointFilteredSection}/${urlEncoderSource}/${typeFilter}/${themeFilter}/${startDateFilter}/${endDateFilter}/${statusFilter}/${userFilter}/${textFilter}/${that.dataFromFilter.length}`;
                //       let news = await that.$api.data.find();
                //       for (let index = 0; index < news.length; index++) {
                //         that.dataFromFilter.push(news[index]);
                //       }
                //       that.filteredsNews = that.dataFromFilter;
                //       for (let index = 0; index < that.filteredsNews.length; index++) {
                //         that.optionsNews[index] = [];
                //         that.optionsNews[index].push({
                //           item: that.filteredsNews[index].c_id,
                //           name: "",
                //         });
                //       }
                //     }

                //     itsFinal++;
                //   });
                //   if (this.validateNews == true) {
                //     // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
                //     //   return o.c_u_Status != 8;
                //     // });
                //     const predicate = (start, end) => ({ c_u_Status }) =>
                //   c_u_Status != start && c_u_Status != end;

                //   this.filteredsNews = this.filteredsNews.filter(predicate(8,10));
                //   } else {
                //     this.filteredsNews = this.dataFromFilter;
                //   }
                // }

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    clickedScrolll: function clickedScrolll() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var itsFinal, that, newDataOfNews, index, _index8, predicate, _that, todaysDate, urlEncoderSource, startDateFilter, endDateFilter, statusFilter, typeFilter, themeFilter, userFilter, textFilter, news, _index9, _index10, _predicate;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(_this9.isFilteredData == false && _this9.filteredText == "")) {
                  _context9.next = 13;
                  break;
                }

                itsFinal = 0;
                that = _this9;
                newDataOfNews = [];

                that.$api.data.endpoint = "News/scrollDown/" + that.sourceIdForScroll + "/" + that.neededArrayOfNews.length;
                _context9.next = 7;
                return that.$api.data.find();

              case 7:
                newDataOfNews = _context9.sent;

                if (newDataOfNews.length == 0) {
                  _this9.$bvToast.toast("Não existem mais registos", {
                    autoHideDelay: 4000,
                    variant: "danger"
                  });
                }
                for (index = 0; index < newDataOfNews.length; index++) {
                  that.neededArrayOfNews.push(newDataOfNews[index]);
                }
                //debugger;
                that.filteredsNews = that.neededArrayOfNews;
                for (_index8 = 0; _index8 < that.filteredsNews.length; _index8++) {
                  that.optionsNews[_index8] = [];
                  that.optionsNews[_index8].push({
                    item: that.filteredsNews[_index8].c_id,
                    name: ""
                  });
                }

                if (_this9.validateNews == true) {
                  // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
                  //   return o.c_u_Status != 8;
                  // });
                  predicate = function predicate(start, end) {
                    return function (_ref3) {
                      var c_u_Status = _ref3.c_u_Status;
                      return c_u_Status != start && c_u_Status != end;
                    };
                  };

                  _this9.filteredsNews = _this9.filteredsNews.filter(predicate(8, 10));
                } else {
                  _this9.filteredsNews = _this9.neededArrayOfNews;
                }

              case 13:
                if (!(_this9.isFilteredData == true)) {
                  _context9.next = 32;
                  break;
                }

                _that = _this9;

                if (_that.filtersDates.startDate != "" && _that.filtersDates.endDate == "") {
                  todaysDate = new Date();

                  todaysDate = todaysDate.getFullYear() + "-" + (todaysDate.getMonth() + 1 < 10 ? "0" + (todaysDate.getMonth() + 1) : todaysDate.getMonth() + 1) + "-" + (todaysDate.getDate() < 10 ? "0" + todaysDate.getDate() : todaysDate.getDate());
                  _that.filtersDates.endDate = todaysDate;
                }
                urlEncoderSource = _that.selectedFilterSource.length != 0 ? encodeURIComponent(_that.selectedFilterSource.toString()) : 0;
                startDateFilter = _that.filtersDates.startDate == "" ? 0 : _that.filtersDates.startDate;
                endDateFilter = _that.filtersDates.endDate == "" ? 0 : _that.filtersDates.endDate;
                statusFilter = typeof _that.selectedFilterStatus != "number" ? 0 : _that.selectedFilterStatus;
                typeFilter = typeof _that.selectedFilterType != "number" ? 20 : _that.selectedFilterType;
                themeFilter = typeof _that.selectedFilterTheme != "number" ? 0 : _that.selectedFilterTheme;
                userFilter = typeof _that.selectedFilterUsers != "number" ? 0 : _that.selectedFilterUsers;
                textFilter = _that.filteredText == "" ? 0 : _that.filteredText;

                //Call the endpoint of filter

                _that.$api.data.endpoint = _that.endpointNews + "/" + _that.endpointFilteredSection + "/" + urlEncoderSource + "/" + typeFilter + "/" + themeFilter + "/" + startDateFilter + "/" + endDateFilter + "/" + statusFilter + "/" + userFilter + "/" + textFilter + "/" + _that.dataFromFilter.length;
                _context9.next = 27;
                return _that.$api.data.find();

              case 27:
                news = _context9.sent;

                for (_index9 = 0; _index9 < news.length; _index9++) {
                  _that.dataFromFilter.push(news[_index9]);
                }
                //debugger;
                _that.filteredsNews = _that.dataFromFilter;
                for (_index10 = 0; _index10 < _that.filteredsNews.length; _index10++) {
                  _that.optionsNews[_index10] = [];
                  _that.optionsNews[_index10].push({
                    item: _that.filteredsNews[_index10].c_id,
                    name: ""
                  });
                }

                if (_this9.validateNews == true) {
                  // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
                  //   return o.c_u_Status != 8;
                  // });
                  _predicate = function _predicate(start, end) {
                    return function (_ref4) {
                      var c_u_Status = _ref4.c_u_Status;
                      return c_u_Status != start && c_u_Status != end;
                    };
                  };

                  _this9.filteredsNews = _this9.filteredsNews.filter(_predicate(8, 10));
                } else {
                  _this9.filteredsNews = _this9.dataFromFilter;
                }

              case 32:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    clickedEvent: function clickedEvent(index, referenceSource) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var sourceName, sourceFindById, i, predicate, _index11;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!_this10.isNotCreatedNew) {
                  _this10.cancelCreationOfNew();
                }

                sourceName = document.getElementsByClassName("section1Name");

                if (!(referenceSource.trim().length == 0)) {
                  _context10.next = 4;
                  break;
                }

                return _context10.abrupt("return");

              case 4:
                if (!(sourceName[index].style.color == "")) {
                  _context10.next = 33;
                  break;
                }

                _this10.isNotCreatedNew = true;
                _this10.isFilteredData = false;
                _this10.filteredsNews = [];
                _this10.clickedEventSourceId = index;
                _this10.clickedEventSourceName = referenceSource;
                _this10.selectedThematics = [];
                _this10.$api.data.endpoint = _this10.endpointSources;
                _context10.t0 = _;
                _context10.next = 15;
                return _this10.$api.data.find();

              case 15:
                _context10.t1 = _context10.sent;

                _context10.t2 = function (filter) {
                  return filter.c_u_ReferenceSource == referenceSource;
                };

                sourceFindById = _context10.t0.find.call(_context10.t0, _context10.t1, _context10.t2);

                for (i = 0; i < sourceName.length; i++) {
                  if (sourceName[i].style.color != "") {
                    sourceName[i].style.color = null;
                    sourceName[i].style.fontWeight = null;
                  }
                }
                sourceName[index].style.color = "#428bac";
                sourceName[index].style.fontWeight = "900";

                _this10.sourceIdForScroll = sourceFindById.c_id;
                _this10.$api.data.endpoint = _this10.endpointNewsBySource + "/" + sourceFindById.c_id;
                _context10.next = 25;
                return _this10.$api.data.find();

              case 25:
                _this10.filteredsNews = _context10.sent;


                //console.log(this.filteredsNews);

                // order the news by the date
                _this10.filteredsNews = _this10.filteredsNews.sort(function (a, b) {
                  return Date.parse(b.c_u_ProcessedDate) - Date.parse(a.c_u_ProcessedDate);
                });

                //debugger;
                _this10.neededArrayOfNews = _this10.filteredsNews;
                if (_this10.validateNews == true) {
                  // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
                  //   return o.c_u_Status != 8;
                  // });
                  predicate = function predicate(start, end) {
                    return function (_ref5) {
                      var c_u_Status = _ref5.c_u_Status;
                      return c_u_Status != start && c_u_Status != end;
                    };
                  };

                  _this10.filteredsNews = _this10.filteredsNews.filter(predicate(8, 10));
                } else {
                  _this10.filteredsNews = _this10.neededArrayOfNews;
                }
                _this10.optionsNews = [[]];
                for (_index11 = 0; _index11 < _this10.filteredsNews.length; _index11++) {
                  _this10.optionsNews[_index11] = [];
                  _this10.optionsNews[_index11].push({
                    item: _this10.filteredsNews[_index11].c_id,
                    name: ""
                  });
                }
                _context10.next = 34;
                break;

              case 33:
                if (_this10.isNotCreatedNew == true) {
                  document.getElementsByClassName("section2Div")[0].style.display = "";
                  document.getElementsByClassName("section3Div")[0].style.display = "";
                  document.getElementsByClassName("section4Div")[0].style.display = "";
                  document.getElementsByClassName("newsCreationContainer")[0].style.display = "none";
                  sourceName[index].style.color = "";
                  sourceName[index].style.fontWeight = "";
                  _this10.filteredsNews = [];
                } else {
                  document.getElementsByClassName("section2Div")[0].style.display = "";
                  document.getElementsByClassName("section3Div")[0].style.display = "";
                  document.getElementsByClassName("section4Div")[0].style.display = "";
                  document.getElementsByClassName("newsCreationContainer")[0].style.display = "none";
                  _this10.isNotCreatedNew = true;
                  _this10.isHidden = false;
                }

              case 34:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    refreshNews: function refreshNews() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var predicate;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this11.filteredsNews = [];
                _this11.$api.data.endpoint = _this11.endpointNewsBySource + "/" + _this11.sourceIdForScroll;
                _context11.next = 4;
                return _this11.$api.data.find();

              case 4:
                _this11.filteredsNews = _context11.sent;

                _this11.neededArrayOfNews = _this11.filteredsNews;
                if (_this11.validateNews == true) {
                  // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
                  //   return o.c_u_Status != 8;
                  // });
                  predicate = function predicate(start, end) {
                    return function (_ref6) {
                      var c_u_Status = _ref6.c_u_Status;
                      return c_u_Status != start && c_u_Status != end;
                    };
                  };

                  _this11.filteredsNews = _this11.filteredsNews.filter(predicate(8, 10));
                } else {
                  _this11.filteredsNews = _this11.neededArrayOfNews;
                }

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    createNewsInfo: function createNewsInfo() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var listOfSources, index, _index12, _index13;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this12.selectedThematics = [];
                // this.thematicItems = [];
                _this12.journalists = [];
                _this12.Vave = [];
                // this.itemsThemeWords = [];
                _this12.isNotCreatedNew = false;
                document.getElementsByClassName("section2Div")[0].style.display = "none";
                document.getElementsByClassName("section3Div")[0].style.display = "none";
                document.getElementsByClassName("section4Div")[0].style.display = "none";
                document.getElementsByClassName("newsCreationContainer")[0].style.display = "block";

                try {
                  _this12.postImageData = null;
                } catch (err) {}
                try {
                  _this12.mediaPath = null;
                } catch (err) {}
                document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
                document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";
                document.getElementById("audioUploaded") != null ? document.getElementById("audioUploaded").remove() : "";
                document.getElementById("videoUploaded") != null ? document.getElementById("videoUploaded").remove() : "";
                document.getElementById("filesMedia1") != null ? document.getElementById("filesMedia1").value = "" : "";
                document.getElementById("filesMedia2") != null ? document.getElementById("filesMedia2").value = "" : "";
                document.getElementById("output") != null ? document.getElementById("output").src = "" : "";
                document.getElementById("files") != null ? document.getElementById("files").value = "" : "";

                _this12.$api.data.endpoint = "ThemeWords";
                _context12.next = 21;
                return _this12.$api.data.find();

              case 21:
                _this12.themeWordsToFind = _context12.sent;

                _.remove(_this12.themeWordsToFind, function (o) {
                  return o.c_u_Words == "";
                });
                _context12.next = 25;
                return _this12.$api.data.find();

              case 25:
                _this12.themeProhibitedWordsToFind = _context12.sent;

                _.remove(_this12.themeProhibitedWordsToFind, function (o) {
                  return o.c_u_ProhibitedWords == "";
                });

                //show the sources
                _this12.$api.data.endpoint = _this12.endpointSources;
                _context12.next = 30;
                return _this12.$api.data.find();

              case 30:
                listOfSources = _context12.sent;


                for (index = 0; index < listOfSources.length; index++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this12.optionsSourceForCreate, index, {
                    item: listOfSources[index].c_u_ReferenceSource,
                    code: listOfSources[index].c_id
                  });
                }

                //receive the list of journalists
                _this12.$api.data.endpoint = _this12.endpointJournalist;
                _context12.next = 35;
                return _this12.$api.data.find();

              case 35:
                _this12.journalists = _context12.sent;

                for (_index12 = 0; _index12 < _this12.journalists.length; _index12++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this12.optionsJournalists, _index12, {
                    id: _this12.journalists[_index12].c_id,
                    name: _this12.journalists[_index12].c_u_Name
                  });
                }
                //receive the list of themes
                // this.$api.data.endpoint = this.endpointThemes;
                // let themes = await this.$api.data.find();
                for (_index13 = 0; _index13 < _this12.itemsThemeWords.length; _index13++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this12.thematicItems, _index13, {
                    id: _this12.itemsThemeWords[_index13].c_u_ThemeId,
                    wordName: _this12.itemsThemeWords[_index13].wordName,
                    words: _this12.itemsThemeWords[_index13].c_u_Words
                  });
                }
                _this12.newThematicItems = _this12.thematicItems;

                //set newsDate and newsTime
                _this12.setInterfaceNewsDateTime(moment().format("YYYY-MM-DDTHH:mm:ss.SSS"));

              case 40:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    },
    findThematics: function findThematics() {
      var _this13 = this;

      if (this.contentOfCreatedNew != "") {
        (function () {
          var validateString = [];
          var unvalidateString = [];
          var toSelectThematicItems = [];
          var unselectThematicItems = [];

          for (var index = 0; index < _this13.themeWordsToFind.length; index++) {
            var string = _this13.themeWordsToFind[index].c_u_Words.split(";");
            validateString.push({
              string: string,
              id: _this13.themeWordsToFind[index].c_u_ThemeId
            });
          }
          for (var _index14 = 0; _index14 < _this13.themeProhibitedWordsToFind.length; _index14++) {
            var _string = _this13.themeProhibitedWordsToFind[_index14].c_u_ProhibitedWords.split(";");
            unvalidateString.push({
              string: _string,
              id: _this13.themeProhibitedWordsToFind[_index14].c_u_ThemeId
            });
          }

          var _loop3 = function _loop3(_index15) {
            for (var i = 0; i < unvalidateString[_index15].string.length; i++) {
              if (unvalidateString[_index15].string[i].length != 0 && unvalidateString[_index15].string[i].length != 1) {
                //SIGLAS find
                if (unvalidateString[_index15].string[i].trim() == unvalidateString[_index15].string[i].trim().toUpperCase()) {
                  if (new RegExp("\\b" + ("" + unvalidateString[_index15].string[i].trim()) + "\\b").test(_this13.contentOfCreatedNew)) {
                    var thematic = _.find(_this13.thematicItems, function (o) {
                      return o.id == unvalidateString[_index15].id;
                    });
                    if (thematic != undefined) {
                      if (!unselectThematicItems.includes(thematic)) {
                        unselectThematicItems.push(thematic);
                      }
                    }
                  }
                } else {
                  if (new RegExp("\\b" + ("" + unvalidateString[_index15].string[i].trim()) + "\\b").test(_this13.contentOfCreatedNew) || new RegExp("\\b" + ("" + unvalidateString[_index15].string[i].trim().toLowerCase()) + "\\b").test(_this13.contentOfCreatedNew.toLowerCase()) || new RegExp("\\b" + ("" + unvalidateString[_index15].string[i].trim().toUpperCase()) + "\\b").test(_this13.contentOfCreatedNew.toUpperCase())) {
                    var _thematic = _.find(_this13.thematicItems, function (o) {
                      return o.id == unvalidateString[_index15].id;
                    });
                    if (_thematic != undefined) {
                      if (!unselectThematicItems.includes(_thematic)) {
                        unselectThematicItems.push(_thematic);
                      }
                    }
                  }
                }
              }
            }
          };

          for (var _index15 = 0; _index15 < unvalidateString.length; _index15++) {
            _loop3(_index15);
          }

          var _loop4 = function _loop4(_index16) {
            for (var i = 0; i < validateString[_index16].string.length; i++) {
              if (validateString[_index16].string[i].length != 0 && validateString[_index16].string[i].length != 1) {
                //SIGLAS find
                if (validateString[_index16].string[i].trim() == validateString[_index16].string[i].trim().toUpperCase()) {
                  if (new RegExp("\\b" + ("" + validateString[_index16].string[i].trim()) + "\\b").test(_this13.contentOfCreatedNew)) {
                    var thematic = _.find(_this13.thematicItems, function (o) {
                      return o.id == validateString[_index16].id;
                    });
                    if (thematic != undefined) {
                      if (!toSelectThematicItems.includes(thematic)) {
                        toSelectThematicItems.push(thematic);
                      }
                    }
                  }
                } else {
                  if (new RegExp("\\b" + ("" + validateString[_index16].string[i].trim()) + "\\b").test(_this13.contentOfCreatedNew) || new RegExp("\\b" + ("" + validateString[_index16].string[i].trim().toLowerCase()) + "\\b").test(_this13.contentOfCreatedNew.toLowerCase()) || new RegExp("\\b" + ("" + validateString[_index16].string[i].trim().toUpperCase()) + "\\b").test(_this13.contentOfCreatedNew.toUpperCase())) {
                    var _thematic2 = _.find(_this13.thematicItems, function (o) {
                      return o.id == validateString[_index16].id;
                    });
                    if (_thematic2 != undefined) {
                      if (!toSelectThematicItems.includes(_thematic2)) {
                        toSelectThematicItems.push(_thematic2);
                      }
                    }
                  }
                }
              }
            }
          };

          for (var _index16 = 0; _index16 < validateString.length; _index16++) {
            _loop4(_index16);
          }
          for (var _index17 = 0; _index17 < _this13.thematicItems.length; _index17++) {
            if (_this13.thematicItems[_index17].wordName == _this13.thematicItems[_index17].wordName.toUpperCase()) {
              if (new RegExp("\\b" + ("" + _this13.thematicItems[_index17].wordName) + "\\b").test(_this13.contentOfCreatedNew)) {
                if (!toSelectThematicItems.includes(_this13.thematicItems[_index17])) {
                  toSelectThematicItems.push(_this13.thematicItems[_index17]);
                }
              }
            } else {
              if (new RegExp("\\b" + ("" + _this13.thematicItems[_index17].wordName) + "\\b").test(_this13.contentOfCreatedNew) || new RegExp("\\b" + ("" + _this13.thematicItems[_index17].wordName.toLowerCase()) + "\\b").test(_this13.contentOfCreatedNew.toLowerCase()) || new RegExp("\\b" + ("" + _this13.thematicItems[_index17].wordName.toUpperCase()) + "\\b").test(_this13.contentOfCreatedNew.toUpperCase())) {
                if (!toSelectThematicItems.includes(_this13.thematicItems[_index17])) {
                  toSelectThematicItems.push(_this13.thematicItems[_index17]);
                }
              }
            }
          }
          toSelectThematicItems = toSelectThematicItems.filter(function (a) {
            return !unselectThematicItems.some(function (b) {
              return b.id === a.id;
            });
          });
          _this13.selectedThematics = toSelectThematicItems;
          //console.log("this.thematicItems: ", this.thematicItems);
          //debugger;
        })();
      } else {
        this.$bvToast.toast("Necessário preencher o Conteúdo para poder efetuar reconhecimento de temáticas", {
          autoHideDelay: 4000,
          variant: "danger"
        });
      }
    },
    findThematics2: function findThematics2() {
      var _this14 = this;

      //console.log("this.newsArray.c_u_Content: ", this.newsArray.c_u_Content);
      //debugger;
      if (this.newsArray.c_u_Content != "") {
        //console.log("validateString: ", validateString);
        //debugger;
        for (var index = 0; index < this.thematicItems.length; index++) {}
      }

      if (this.newsArray.c_u_Content != "") {
        var Thematic;
        var Words;
        var index2;
        var Word;
        var WordProcessed;
        var HasMatch;

        (function () {
          var validateString = [];
          var unvalidateString = [];
          var toSelectThematicItems = [];
          var unselectThematicItems = [];

          for (var _index18 = 0; _index18 < _this14.themeWordsToFind.length; _index18++) {
            var string = _this14.themeWordsToFind[_index18].c_u_Words.split(";");
            validateString.push({
              string: string,
              id: _this14.themeWordsToFind[_index18].c_u_ThemeId
            });
          }
          for (var _index19 = 0; _index19 < _this14.themeProhibitedWordsToFind.length; _index19++) {
            var _string2 = _this14.themeProhibitedWordsToFind[_index19].c_u_ProhibitedWords.split(";");
            unvalidateString.push({
              string: _string2,
              id: _this14.themeProhibitedWordsToFind[_index19].c_u_ThemeId
            });
          }

          var _loop5 = function _loop5(_index20) {
            for (var i = 0; i < unvalidateString[_index20].string.length; i++) {
              if (unvalidateString[_index20].string[i].length != 0 && unvalidateString[_index20].string[i].length != 1) {
                //SIGLAS find
                if (unvalidateString[_index20].string[i].trim() == unvalidateString[_index20].string[i].trim().toUpperCase()) {
                  if (new RegExp("\\b" + ("" + unvalidateString[_index20].string[i].trim()) + "\\b").test(_this14.contentOfCreatedNew)) {
                    var thematic = _.find(_this14.thematicItems, function (o) {
                      return o.id == unvalidateString[_index20].id;
                    });
                    if (thematic != undefined) {
                      if (!unselectThematicItems.includes(thematic)) {
                        unselectThematicItems.push(thematic);
                      }
                    }
                  }
                } else {
                  if (new RegExp("\\b" + ("" + unvalidateString[_index20].string[i].trim()) + "\\b").test(_this14.contentOfCreatedNew) || new RegExp("\\b" + ("" + unvalidateString[_index20].string[i].trim().toLowerCase()) + "\\b").test(_this14.contentOfCreatedNew.toLowerCase()) || new RegExp("\\b" + ("" + unvalidateString[_index20].string[i].trim().toUpperCase()) + "\\b").test(_this14.contentOfCreatedNew.toUpperCase())) {
                    var _thematic3 = _.find(_this14.thematicItems, function (o) {
                      return o.id == unvalidateString[_index20].id;
                    });
                    if (_thematic3 != undefined) {
                      if (!unselectThematicItems.includes(_thematic3)) {
                        unselectThematicItems.push(_thematic3);
                      }
                    }
                  }
                }
              }
            }
          };

          for (var _index20 = 0; _index20 < unvalidateString.length; _index20++) {
            _loop5(_index20);
          }

          var _loop6 = function _loop6(_index21) {
            for (var i = 0; i < validateString[_index21].string.length; i++) {
              if (validateString[_index21].string[i].length != 0 && validateString[_index21].string[i].length != 1) {
                //SIGLAS find
                if (validateString[_index21].string[i].trim() == validateString[_index21].string[i].trim().toUpperCase()) {
                  if (new RegExp("\\b" + ("" + validateString[_index21].string[i].trim()) + "\\b").test(_this14.newsArray.c_u_Content)) {
                    var thematic = _.find(_this14.thematicItems, function (o) {
                      return o.id == validateString[_index21].id;
                    });
                    if (thematic != undefined) {
                      if (!toSelectThematicItems.includes(thematic)) {
                        toSelectThematicItems.push(thematic);
                      }
                    }
                  }
                } else {
                  if (new RegExp("\\b" + ("" + validateString[_index21].string[i].trim()) + "\\b").test(_this14.newsArray.c_u_Content) || new RegExp("\\b" + ("" + validateString[_index21].string[i].trim().toLowerCase()) + "\\b").test(_this14.newsArray.c_u_Content.toLowerCase()) || new RegExp("\\b" + ("" + validateString[_index21].string[i].trim().toUpperCase()) + "\\b").test(_this14.newsArray.c_u_Content.toUpperCase())) {
                    var _thematic4 = _.find(_this14.thematicItems, function (o) {
                      return o.id == validateString[_index21].id;
                    });
                    if (_thematic4 != undefined) {
                      if (!toSelectThematicItems.includes(_thematic4)) {
                        toSelectThematicItems.push(_thematic4);
                      }
                    }
                  }
                }
              }
            }
          };

          for (var _index21 = 0; _index21 < validateString.length; _index21++) {
            _loop6(_index21);
          }
          for (var _index22 = 0; _index22 < _this14.thematicItems.length; _index22++) {
            Thematic = _this14.thematicItems[_index22];
            Words = Thematic.words.split(";");

            for (index2 = 0; index2 < Words.length; index2++) {
              Word = Words[index2];

              try {
                WordProcessed = Word.trim();

                if (WordProcessed.length > 0) {
                  HasMatch = false;

                  if (WordProcessed.length <= 3) {
                    //title
                    HasMatch = new RegExp("\\b" + WordProcessed + "\\b").test(_this14.newsArray.c_u_Title);
                    //summary
                    if (!HasMatch) {
                      HasMatch = new RegExp("\\b" + WordProcessed + "\\b").test(_this14.newsArray.c_u_Summary);
                    }
                    //body
                    if (!HasMatch) {
                      HasMatch = new RegExp("\\b" + WordProcessed + "\\b").test(_this14.newsArray.c_u_Content);
                    }
                  } else {
                    //title
                    HasMatch = new RegExp("\\b" + WordProcessed.toLowerCase() + "\\b").test(_this14.newsArray.c_u_Title.toLowerCase());
                    //summary
                    if (!HasMatch) {
                      HasMatch = new RegExp("\\b" + WordProcessed.toLowerCase() + "\\b").test(_this14.newsArray.c_u_Summary.toLowerCase());
                    }
                    //body
                    if (!HasMatch) {
                      HasMatch = new RegExp("\\b" + WordProcessed.toLowerCase() + "\\b").test(_this14.newsArray.c_u_Content.toLowerCase());
                    }
                  }
                  if (HasMatch) {
                    if (!toSelectThematicItems.includes(_this14.thematicItems[_index22])) {
                      toSelectThematicItems.push(_this14.thematicItems[_index22]);
                    }
                    break;
                  }
                }
              } catch (err) {}
            }
          }
          toSelectThematicItems = toSelectThematicItems.filter(function (a) {
            return !unselectThematicItems.some(function (b) {
              return b.id === a.id;
            });
          });
          _this14.selectedThematics = toSelectThematicItems;

          //console.log("this.thematicItems: ", this.thematicItems);
          //debugger;
        })();
      } else {
        this.$bvToast.toast("Necessário preencher o Conteúdo para poder efetuar reconhecimento de temáticas", {
          autoHideDelay: 4000,
          variant: "danger"
        });
      }
    },
    rememberCreateObject: function rememberCreateObject(item) {
      this.createdNew.c_r_Source = this.sourceOfCreatedNew;
      this.createdNew.c_u_NewsOriginType = item.c_u_NewsOriginType;
      this.createdNew.c_u_News_MMS_ProgramName = item.c_u_News_MMS_ProgramName;
      this.savedCreatedNew = this.createdNew;
    },
    loadCreateObject: function loadCreateObject() {
      this.sourceOfCreatedNew = this.savedCreatedNew.c_r_Source;
      //this.contentOfCreatedNew = this.savedCreatedNew.c_u_Content;
      this.createdNew.c_u_NewsOriginType = this.savedCreatedNew.c_u_NewsOriginType;
      this.createdNew.c_u_News_MMS_ProgramName = this.savedCreatedNew.c_u_News_MMS_ProgramName;
      //this.createdNew = this.savedCreatedNew;
      this.$forceUpdate();
    },
    cancelCreationOfNew: function cancelCreationOfNew() {
      var _createdNew2;

      this.isNotCreatedNew = true;
      this.isHidden = false;
      document.getElementsByClassName("section2Div")[0].style.display = "";
      document.getElementsByClassName("section3Div")[0].style.display = "";
      document.getElementsByClassName("section4Div")[0].style.display = "";
      document.getElementsByClassName("newsCreationContainer")[0].style.display = "none";
      this.selectedThematics = [];
      //clear all data after its created
      this.sourceOfCreatedNew = 0;
      this.contentOfCreatedNew = "";
      this.createdNew = (_createdNew2 = {
        c_r_Journalist: null,
        c_u_ProcessedDate: "",
        c_u_NumberOfGetTries: 0,
        c_u_NumberOfExtractTries: 0,
        c_u_RawNews: "",
        c_u_ExtractionMethod: "0,0,0,0",
        c_u_ExtractionNotes: "",
        c_u_IdentificationMethod: "",
        c_u_UrlNews: "",
        c_r_Source: 0,
        c_u_Content: "",
        c_u_ExternalID: 0
      }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_ExtractionMethod", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_ExtractionNotes", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_IdentificationMethod", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_Image", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_Keywords", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_NewsAVE", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_NewsCreateByUser", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_NewsDateCreate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_NewsFilePath", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_NewsOriginType", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_News_MMS_ProgramName", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_NewsThumbnail", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_NewsidxFav", null), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_ProcessedDate", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_Status", 5), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_Summary", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_Title", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_Type", 0), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_isHighlighted", false), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_createdNew2, "c_u_NewsPageNumber", null), _createdNew2);
    },
    postCreateNew: function postCreateNew(item) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var checkIdJournalist, d, mm, dd, yy, createdImageFile, createdMediaFile, previewImage, that, urlMedia, NewsResult, NewsID, ImageResult, VideoAudioResult, Payload;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(_this15.sourceOfCreatedNew == 0)) {
                  _context13.next = 4;
                  break;
                }

                _this15.$bvToast.toast("Para efetuar a criação da noticia é necessario preencher a fonte", {
                  autoHideDelay: 4000,
                  variant: "danger"
                });
                _context13.next = 62;
                break;

              case 4:
                item.c_r_Source = _this15.sourceOfCreatedNew;
                item.c_u_NewsCreateByUser = _this15.getLoggedInUserID();
                item.c_u_Summary = item.c_u_Summary != "" ? item.c_u_Summary.replace(/<[^>]*>?/gm, "") : item.c_u_Summary;
                item.c_u_Content = _this15.contentOfCreatedNew;

                //console.log("item.c_r_Journalist before", item.c_r_Journalist);
                // check if we have the journalist in the list

                if (!(item.c_r_Journalist != null)) {
                  _context13.next = 21;
                  break;
                }

                if (!(typeof item.c_r_Journalist.name == "string")) {
                  _context13.next = 20;
                  break;
                }

                _this15.$api.data.endpoint = _this15.endpointJournalist;
                _context13.t0 = _;
                _context13.next = 14;
                return _this15.$api.data.find();

              case 14:
                _context13.t1 = _context13.sent;

                _context13.t2 = function (journalist) {
                  return journalist.c_u_Name == item.c_r_Journalist.name;
                };

                checkIdJournalist = _context13.t0.find.call(_context13.t0, _context13.t1, _context13.t2);

                item.c_r_Journalist = checkIdJournalist.c_id;
                _context13.next = 21;
                break;

              case 20:
                item.c_r_Journalist = item.c_r_Journalist;

              case 21:
                //console.log("item.c_r_Journalist after", item.c_r_Journalist);

                d = new Date();
                mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                yy = d.getFullYear();

                item.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
                item.c_u_NewsDateCreate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

                //news create date and time
                if (_this15._newsDate.trim().length > 0 && _this15._newsTime.trim().length > 0) {
                  item.c_u_NewsDateCreate = _this15._newsDate + "T" + _this15._newsTime + ":00.000";
                }

                if (item.c_u_Title == "" || item.c_u_Content == "" || item.c_u_Summary == "") {
                  item.c_u_Status = 11; //what is this state?
                } else {
                  item.c_u_Status = 6;
                  item.c_u_NewsEditByUser = _this15.getLoggedInUserID();
                  item.c_u_NewsDateEdit = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
                }

                createdImageFile = _this15.postImageData;
                createdMediaFile = _this15.mediaPath;
                previewImage = document.getElementById("output");
                that = _this15;
                urlMedia = _this15.getUrl;

                //old way - CORS errors
                /*$.ajax({
                  type: "POST",
                  contentType: "application/json; charset=utf-8",
                  cache: false,
                  url: `${this.getUrl}/api/News`,
                  data: JSON.stringify(item),
                  xhrFields: {
                    withCredentials: true
                  },
                  success: async function (data) {
                    that.idOfCreatedNew = data.c_id;
                    if (previewImage.src != "") {
                      $.ajax({
                        url: `${urlMedia}/api/Image/${data.c_id}`,
                        data: createdImageFile,
                        processData: false,
                        contentType: false,
                        type: "PATCH",
                        xhrFields: {
                          withCredentials: true
                        },
                      });
                    }
                    $.ajax({
                      url: `${urlMedia}/api/Image/VideoAudio/${data.c_id}`,
                      data: createdMediaFile,
                      processData: false,
                      contentType: false,
                      type: "PATCH",
                      xhrFields: {
                        withCredentials: true
                      },
                    });
                  },
                  error: function (jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR.responseText);
                  },
                  dataType: "json",
                });*/

                //new way - to avoid CORS errors

                _this15.$api.data.endpoint = _this15.endpointNews;
                _context13.next = 37;
                return _this15.$api.data.create2(item);

              case 37:
                NewsResult = _context13.sent;

                //console.log("NewsResult", NewsResult);
                NewsID = 0;

                try {
                  if (NewsResult.c_id > 0) {
                    NewsID = NewsResult.c_id;
                  }
                } catch (err) {}

                if (!(NewsID > 0)) {
                  _context13.next = 51;
                  break;
                }

                that.idOfCreatedNew = NewsID;

                if (!(previewImage.src != "")) {
                  _context13.next = 47;
                  break;
                }

                _this15.$api.data.endpoint = "Image";
                _context13.next = 46;
                return _this15.$api.data.uploadImageById(NewsResult.c_id, createdImageFile);

              case 46:
                ImageResult = _context13.sent;

              case 47:
                _this15.$api.data.endpoint = "Image/VideoAudio";
                _context13.next = 50;
                return _this15.$api.data.uploadImageById(NewsResult.c_id, createdMediaFile);

              case 50:
                VideoAudioResult = _context13.sent;

              case 51:
                if (!(NewsID > 0)) {
                  _context13.next = 61;
                  break;
                }

                //process base64 images after other media uploads
                _this15.$api.data.endpoint = "News/PostSaveProcessBase64";
                Payload = { NewsID: NewsID, UserID: _this15.getLoggedInUserID() };
                _context13.prev = 54;
                _context13.next = 57;
                return _this15.$api.data.update(Payload);

              case 57:
                _context13.next = 61;
                break;

              case 59:
                _context13.prev = 59;
                _context13.t3 = _context13["catch"](54);

              case 61:

                if (NewsID > 0) {
                  _this15.$bvToast.toast("Noticia criada com sucesso", {
                    autoHideDelay: 4000,
                    variant: "success"
                  });
                } else {
                  _this15.$bvToast.toast("Não foi possível criar a notícia", {
                    autoHideDelay: 4000,
                    variant: "danger"
                  });
                }

              case 62:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee12, _this15, [[54, 59]]);
      }))();
    },
    publishCreateNew: function publishCreateNew(item) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var checkIdJournalist, d, mm, dd, yy, createdImageFile, createdMediaFile, previewImage, that, urlMedia, NewsResult, NewsID, ImageResult, VideoAudioResult, Payload;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                item.c_r_Source = _this16.sourceOfCreatedNew;
                item.c_u_NewsCreateByUser = _this16.getLoggedInUserID();
                item.c_u_Summary = item.c_u_Summary != "" ? item.c_u_Summary.replace(/<[^>]*>?/gm, "") : item.c_u_Summary;
                item.c_u_Content = _this16.contentOfCreatedNew;

                //console.log("item.c_r_Journalist before", item.c_r_Journalist);
                // check if we have the journalist in the list

                if (!(item.c_r_Journalist != null)) {
                  _context14.next = 17;
                  break;
                }

                if (!(typeof item.c_r_Journalist.name == "string")) {
                  _context14.next = 16;
                  break;
                }

                _this16.$api.data.endpoint = _this16.endpointJournalist;
                _context14.t0 = _;
                _context14.next = 10;
                return _this16.$api.data.find();

              case 10:
                _context14.t1 = _context14.sent;

                _context14.t2 = function (journalist) {
                  return journalist.c_u_Name == item.c_r_Journalist.name;
                };

                checkIdJournalist = _context14.t0.find.call(_context14.t0, _context14.t1, _context14.t2);

                item.c_r_Journalist = checkIdJournalist.c_id;
                _context14.next = 17;
                break;

              case 16:
                item.c_r_Journalist = item.c_r_Journalist;

              case 17:
                //console.log("item.c_r_Journalist after", item.c_r_Journalist);

                d = new Date();
                mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                yy = d.getFullYear();

                item.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
                item.c_u_NewsDateCreate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

                //news create date and time
                if (_this16._newsDate.trim().length > 0 && _this16._newsTime.trim().length > 0) {
                  item.c_u_NewsDateCreate = _this16._newsDate + "T" + _this16._newsTime + ":00.000";
                }

                if (!(item.c_u_Title == "" || item.c_u_Content == "" || item.c_u_Summary == "")) {
                  _context14.next = 28;
                  break;
                }

                _this16.$bvToast.toast("Para efetuar a publicação é necessario preencher o titulo, resumo e o Conteúdo", {
                  autoHideDelay: 4000,
                  variant: "danger"
                });
                _context14.next = 63;
                break;

              case 28:
                item.c_u_Status = 8;
                item.c_u_NewsPublishedByUser = _this16.getLoggedInUserID();
                createdImageFile = _this16.postImageData;
                createdMediaFile = _this16.mediaPath;
                previewImage = document.getElementById("output");
                that = _this16;
                urlMedia = _this16.getUrl;

                //old way - CORS errors
                /*$.ajax({
                  type: "POST",
                  contentType: "application/json; charset=utf-8",
                  cache: false,
                  url: `${this.getUrl}/api/News`,
                  data: JSON.stringify(item),
                  success: async function (data) {
                    that.idOfCreatedNew = data.c_id;
                    if (previewImage.src != "") {
                      $.ajax({
                        url: `${urlMedia}/api/Image/${data.c_id}`,
                        data: createdImageFile,
                        processData: false,
                        contentType: false,
                        type: "PATCH",
                      });
                      $.ajax({
                        url: `${urlMedia}/api/Image/VideoAudio/${data.c_id}`,
                        data: createdMediaFile,
                        processData: false,
                        contentType: false,
                        type: "PATCH",
                      });
                    }
                  },
                  dataType: "json",
                });*/

                //new way - to avoid CORS errors

                _this16.$api.data.endpoint = _this16.endpointNews;
                _context14.next = 38;
                return _this16.$api.data.create2(item);

              case 38:
                NewsResult = _context14.sent;

                //console.log("NewsResult", NewsResult);
                NewsID = 0;

                try {
                  if (NewsResult.c_id > 0) {
                    NewsID = NewsResult.c_id;
                  }
                } catch (err) {}

                if (!(NewsID > 0)) {
                  _context14.next = 52;
                  break;
                }

                that.idOfCreatedNew = NewsID;

                if (!(previewImage.src != "")) {
                  _context14.next = 48;
                  break;
                }

                _this16.$api.data.endpoint = "Image";
                _context14.next = 47;
                return _this16.$api.data.uploadImageById(NewsResult.c_id, createdImageFile);

              case 47:
                ImageResult = _context14.sent;

              case 48:
                _this16.$api.data.endpoint = "Image/VideoAudio";
                _context14.next = 51;
                return _this16.$api.data.uploadImageById(NewsResult.c_id, createdMediaFile);

              case 51:
                VideoAudioResult = _context14.sent;

              case 52:
                if (!(NewsID > 0)) {
                  _context14.next = 62;
                  break;
                }

                //process base64 images after other media uploads
                _this16.$api.data.endpoint = "News/PostSaveProcessBase64";
                Payload = { NewsID: NewsID, UserID: _this16.getLoggedInUserID() };
                _context14.prev = 55;
                _context14.next = 58;
                return _this16.$api.data.update(Payload);

              case 58:
                _context14.next = 62;
                break;

              case 60:
                _context14.prev = 60;
                _context14.t3 = _context14["catch"](55);

              case 62:

                if (NewsID > 0) {
                  _this16.$bvToast.toast("Noticia criada e publicada com sucesso", {
                    autoHideDelay: 4000,
                    variant: "success"
                  });
                } else {
                  _this16.$bvToast.toast("Não foi possível criar ou publicar a notícia", {
                    autoHideDelay: 4000,
                    variant: "danger"
                  });
                }

              case 63:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee13, _this16, [[55, 60]]);
      }))();
    },
    copyCreateNew: function copyCreateNew(item) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var checkIdJournalist, d, mm, dd, yy, createdImageFile, createdMediaFile, previewImage, that, urlMedia, NewsResult, NewsID, ImageResult, VideoAudioResult, Payload;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                item.c_r_Source = _this17.sourceOfCreatedNew;
                item.c_u_NewsCreateByUser = _this17.getLoggedInUserID();
                item.c_u_Summary = item.c_u_Summary != "" ? item.c_u_Summary.replace(/<[^>]*>?/gm, "") : item.c_u_Summary;
                item.c_u_Content = _this17.contentOfCreatedNew;

                //console.log("item.c_r_Journalist before", item.c_r_Journalist);
                // check if we have the journalist in the list

                if (!(item.c_r_Journalist != null)) {
                  _context15.next = 17;
                  break;
                }

                if (!(typeof item.c_r_Journalist.name == "string")) {
                  _context15.next = 16;
                  break;
                }

                _this17.$api.data.endpoint = _this17.endpointJournalist;
                _context15.t0 = _;
                _context15.next = 10;
                return _this17.$api.data.find();

              case 10:
                _context15.t1 = _context15.sent;

                _context15.t2 = function (journalist) {
                  return journalist.c_u_Name == item.c_r_Journalist.name;
                };

                checkIdJournalist = _context15.t0.find.call(_context15.t0, _context15.t1, _context15.t2);

                item.c_r_Journalist = checkIdJournalist.c_id;
                _context15.next = 17;
                break;

              case 16:
                item.c_r_Journalist = item.c_r_Journalist;

              case 17:
                //console.log("item.c_r_Journalist after", item.c_r_Journalist);

                d = new Date();
                mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                yy = d.getFullYear();

                item.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
                item.c_u_NewsDateCreate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

                //news create date and time
                if (_this17._newsDate.trim().length > 0 && _this17._newsTime.trim().length > 0) {
                  item.c_u_NewsDateCreate = _this17._newsDate + "T" + _this17._newsTime + ":00.000";
                }

                if (!(item.c_u_Title == "" || item.c_u_Content == "" || item.c_u_Summary == "")) {
                  _context15.next = 28;
                  break;
                }

                _this17.$bvToast.toast("Para efetuar a publicação é necessario preencher o titulo, resumo e o Conteúdo", {
                  autoHideDelay: 4000,
                  variant: "danger"
                });
                _context15.next = 62;
                break;

              case 28:
                item.c_u_Status = 7;
                createdImageFile = _this17.postImageData;
                createdMediaFile = _this17.mediaPath;
                previewImage = document.getElementById("output");
                that = _this17;
                urlMedia = _this17.getUrl;

                //old way - CORS errors
                /*$.ajax({
                  type: "POST",
                  contentType: "application/json; charset=utf-8",
                  cache: false,
                  url: `${this.getUrl}/api/News`,
                  data: JSON.stringify(item),
                  success: async function (data) {
                    that.idOfCreatedNew = data.c_id;
                    if (previewImage.src != "") {
                      $.ajax({
                        url: `${urlMedia}/api/Image/${data.c_id}`,
                        data: createdImageFile,
                        processData: false,
                        contentType: false,
                        type: "PATCH",
                      });
                      $.ajax({
                        url: `${urlMedia}/api/Image/VideoAudio/${data.c_id}`,
                        data: createdMediaFile,
                        processData: false,
                        contentType: false,
                        type: "PATCH",
                      });
                    }
                  },
                  dataType: "json",
                });
                this.$bvToast.toast("Noticia criada e copiada com sucesso", {
                  autoHideDelay: 4000,
                  variant: "success",
                });*/

                //new way - to avoid CORS errors

                _this17.$api.data.endpoint = _this17.endpointNews;
                _context15.next = 37;
                return _this17.$api.data.create2(item);

              case 37:
                NewsResult = _context15.sent;

                //console.log("NewsResult", NewsResult);
                NewsID = 0;

                try {
                  if (NewsResult.c_id > 0) {
                    NewsID = NewsResult.c_id;
                  }
                } catch (err) {}

                if (!(NewsID > 0)) {
                  _context15.next = 51;
                  break;
                }

                that.idOfCreatedNew = NewsID;

                if (!(previewImage.src != "")) {
                  _context15.next = 47;
                  break;
                }

                _this17.$api.data.endpoint = "Image";
                _context15.next = 46;
                return _this17.$api.data.uploadImageById(NewsResult.c_id, createdImageFile);

              case 46:
                ImageResult = _context15.sent;

              case 47:
                _this17.$api.data.endpoint = "Image/VideoAudio";
                _context15.next = 50;
                return _this17.$api.data.uploadImageById(NewsResult.c_id, createdMediaFile);

              case 50:
                VideoAudioResult = _context15.sent;

              case 51:
                if (!(NewsID > 0)) {
                  _context15.next = 61;
                  break;
                }

                //process base64 images after other media uploads
                _this17.$api.data.endpoint = "News/PostSaveProcessBase64";
                Payload = { NewsID: NewsID, UserID: _this17.getLoggedInUserID() };
                _context15.prev = 54;
                _context15.next = 57;
                return _this17.$api.data.update(Payload);

              case 57:
                _context15.next = 61;
                break;

              case 59:
                _context15.prev = 59;
                _context15.t3 = _context15["catch"](54);

              case 61:

                if (NewsID > 0) {
                  _this17.$bvToast.toast("Noticia criada e copiada com sucesso", {
                    autoHideDelay: 4000,
                    variant: "success"
                  });
                } else {
                  _this17.$bvToast.toast("Não foi possível criar ou copiar a notícia", {
                    autoHideDelay: 4000,
                    variant: "danger"
                  });
                }

              case 62:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee14, _this17, [[54, 59]]);
      }))();
    },
    editNews: function editNews(newsid, news) {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var user, _user, _user2, audio, video, index, _index23, _index24, section, _index25, joinedTables, _index26, previewImage, patt, result;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this18.Vave = [];
                _this18.optionsAve = [];

                _this18.neededId = newsid;
                _this18.neededNews = news;

                try {
                  _this18.postImageData = null;
                } catch (err) {}
                try {
                  _this18.mediaPath = null;
                } catch (err) {}
                document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
                document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";
                document.getElementById("audioUploaded") != null ? document.getElementById("audioUploaded").remove() : "";
                document.getElementById("videoUploaded") != null ? document.getElementById("videoUploaded").remove() : "";
                document.getElementById("filesMedia1") != null ? document.getElementById("filesMedia1").value = "" : "";
                document.getElementById("filesMedia2") != null ? document.getElementById("filesMedia2").value = "" : "";
                document.getElementById("output") != null ? document.getElementById("output").src = "" : "";
                document.getElementById("files") != null ? document.getElementById("files").value = "" : "";

                _this18.isHidden = true;
                _this18.selectedThematics = [];
                _this18.$api.data.endpoint = _this18.endpointNews;

                _context16.next = 19;
                return _this18.$api.data.findOneById(news.c_id);

              case 19:
                _this18.newsArray = _context16.sent;

                if (!(_this18.newsArray.c_u_NewsEditByUser != null)) {
                  _context16.next = 28;
                  break;
                }

                _this18.$api.data.endpoint = _this18.endpointUsers;
                _context16.next = 24;
                return _this18.$api.data.findOneById(_this18.newsArray.c_u_NewsEditByUser);

              case 24:
                user = _context16.sent;

                _this18.getUserInfoEdit = user[0].User.DisplayName;
                _this18.getFormatedNewsEditedDate = new Date(_this18.newsArray.c_u_NewsDateEdit);

                _this18.getFormatedNewsEditedDate = (_this18.getFormatedNewsEditedDate.getDate() < 10 ? "0" + _this18.getFormatedNewsEditedDate.getDate() : _this18.getFormatedNewsEditedDate.getDate()) + "-" + (_this18.getFormatedNewsEditedDate.getMonth() + 1 < 10 ? "0" + (_this18.getFormatedNewsEditedDate.getMonth() + 1) : _this18.getFormatedNewsEditedDate.getMonth() + 1) + "-" + _this18.getFormatedNewsEditedDate.getFullYear() + " às " + (_this18.getFormatedNewsEditedDate.getHours() < 10 ? "0" + _this18.getFormatedNewsEditedDate.getHours() : _this18.getFormatedNewsEditedDate.getHours()) + ":" + (_this18.getFormatedNewsEditedDate.getMinutes() < 10 ? "0" + _this18.getFormatedNewsEditedDate.getMinutes() : _this18.getFormatedNewsEditedDate.getMinutes());

              case 28:
                if (!(_this18.newsArray.c_u_NewsPublishedByUser != null)) {
                  _context16.next = 37;
                  break;
                }

                if (!(_this18.newsArray.c_u_NewsPublishedByUser != 0)) {
                  _context16.next = 37;
                  break;
                }

                _this18.$api.data.endpoint = _this18.endpointUsers;
                _context16.next = 33;
                return _this18.$api.data.findOneById(_this18.newsArray.c_u_NewsPublishedByUser);

              case 33:
                _user = _context16.sent;

                _this18.getUserInfoPublish = _user[0].User.DisplayName;
                _this18.getFormatedNewsPublishedDate = new Date(_this18.newsArray.c_u_NewsDatePublished);

                _this18.getFormatedNewsPublishedDate = (_this18.getFormatedNewsPublishedDate.getDate() < 10 ? "0" + _this18.getFormatedNewsPublishedDate.getDate() : _this18.getFormatedNewsPublishedDate.getDate()) + "-" + (_this18.getFormatedNewsPublishedDate.getMonth() + 1 < 10 ? "0" + (_this18.getFormatedNewsPublishedDate.getMonth() + 1) : _this18.getFormatedNewsPublishedDate.getMonth() + 1) + "-" + _this18.getFormatedNewsPublishedDate.getFullYear() + " às " + (_this18.getFormatedNewsPublishedDate.getHours() < 10 ? "0" + _this18.getFormatedNewsPublishedDate.getHours() : _this18.getFormatedNewsPublishedDate.getHours()) + ":" + (_this18.getFormatedNewsPublishedDate.getMinutes() < 10 ? "0" + _this18.getFormatedNewsPublishedDate.getMinutes() : _this18.getFormatedNewsPublishedDate.getMinutes());

              case 37:
                if (!(_this18.newsArray.c_u_NewsCreateByUser != null)) {
                  _context16.next = 45;
                  break;
                }

                _this18.$api.data.endpoint = _this18.endpointUsers;
                _context16.next = 41;
                return _this18.$api.data.findOneById(_this18.newsArray.c_u_NewsCreateByUser);

              case 41:
                _user2 = _context16.sent;

                _this18.getUserInfoCreate = _user2[0].User.DisplayName;
                _this18.getFormatedNewsCreatedDate = new Date(_this18.newsArray.c_u_NewsDateCreate);

                _this18.getFormatedNewsCreatedDate = (_this18.getFormatedNewsCreatedDate.getDate() < 10 ? "0" + _this18.getFormatedNewsCreatedDate.getDate() : _this18.getFormatedNewsCreatedDate.getDate()) + "-" + (_this18.getFormatedNewsCreatedDate.getMonth() + 1 < 10 ? "0" + (_this18.getFormatedNewsCreatedDate.getMonth() + 1) : _this18.getFormatedNewsCreatedDate.getMonth() + 1) + "-" + _this18.getFormatedNewsCreatedDate.getFullYear() + " às " + (_this18.getFormatedNewsCreatedDate.getHours() < 10 ? "0" + _this18.getFormatedNewsCreatedDate.getHours() : _this18.getFormatedNewsCreatedDate.getHours()) + ":" + (_this18.getFormatedNewsCreatedDate.getMinutes() < 10 ? "0" + _this18.getFormatedNewsCreatedDate.getMinutes() : _this18.getFormatedNewsCreatedDate.getMinutes());

              case 45:

                //set newsDate and newsTime
                _this18.setInterfaceNewsDateTime(_this18.newsArray.c_u_NewsDateCreate);

                document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
                document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";

                if (_this18.newsArray.c_u_NewsFilePath != null) {
                  audio = document.createElement("audio");
                  video = document.createElement("video");

                  audio.src = "" + _this18.newsArray.c_u_NewsFilePath;
                  video.src = "" + _this18.newsArray.c_u_NewsFilePath;
                  video.style = "width:300px; height: 200px";
                  audio.id = "audioPreview";
                  video.id = "videoPreview";
                  audio.controls = "true";
                  video.controls = "true";
                  if (_this18.newsArray.c_u_NewsFilePath.match("ogg") || _this18.newsArray.c_u_NewsFilePath.match("mp3")) {
                    document.getElementById("fileVideoAudio2").appendChild(audio);
                  }
                  if (_this18.newsArray.c_u_NewsFilePath.match("mp4")) {
                    document.getElementById("fileVideoAudio2").appendChild(video);
                  }
                }
                //receive the list of journalists
                _this18.$api.data.endpoint = _this18.endpointJournalist;
                _context16.next = 52;
                return _this18.$api.data.find();

              case 52:
                _this18.journalists = _context16.sent;

                for (index = 0; index < _this18.journalists.length; index++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this18.optionsJournalists, index, {
                    id: _this18.journalists[index].c_id,
                    name: _this18.journalists[index].c_u_Name
                  });
                }

                //receive the list of AVES
                _this18.$api.data.endpoint = _this18.endpointAVE;
                _context16.next = 57;
                return _this18.$api.data.findOneById(_this18.newsArray.c_r_Source);

              case 57:
                _this18.Vave = _context16.sent;

                for (_index23 = 0; _index23 < _this18.Vave.length; _index23++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this18.optionsAve, _index23, {
                    id: _this18.Vave[_index23].id,
                    newAve: _this18.Vave[_index23].aveText
                  });
                }

                //receive the list of themes
                // this.$api.data.endpoint = this.endpointThemes;
                // let themes = await this.$api.data.find();
                for (_index24 = 0; _index24 < _this18.itemsThemeWords.length; _index24++) {
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this18.thematicItems, _index24, {
                    id: _this18.itemsThemeWords[_index24].c_u_ThemeId,
                    wordName: _this18.itemsThemeWords[_index24].wordName,
                    words: _this18.itemsThemeWords[_index24].c_u_Words
                  });
                }
                _this18.newThematicItems = _this18.thematicItems;
                section = document.getElementById("sectionThems") != undefined ? document.getElementById("sectionThems").childNodes : [];

                for (_index25 = 0; _index25 < section.length; _index25++) {
                  if (section[_index25].style.color == "black") {
                    section[_index25].style.color = null;
                    section[_index25].style.backgroundColor = null;
                    section[_index25].style.fontWeight = null;
                  }
                }

                //receive the list of join tables themes, themesWord, themesWordNews
                _this18.$api.data.endpoint = "ThemeWordsNews/Thematics/" + _this18.newsArray.c_id;
                _context16.next = 66;
                return _this18.$api.data.find();

              case 66:
                joinedTables = _context16.sent;

                for (_index26 = 0; _index26 < joinedTables.length; _index26++) {
                  if (joinedTables[_index26].themeNews == _this18.newsArray.c_id) {
                    _this18.selectedThematics.push({
                      id: joinedTables[_index26].themeWordId,
                      wordName: joinedTables[_index26].wordName,
                      c_id: joinedTables[_index26].c_id
                    });
                  }
                }

                previewImage = document.getElementById("output");
                //check if we have image from /uploads/ with regex

                patt = /media/;
                result = _this18.newsArray.c_u_Image.match(patt);

                if (result == null) {
                  previewImage.src = "";
                } else {
                  __WEBPACK_IMPORTED_MODULE_16_jquery___default()("#output").attr("src", "" + _this18.newsArray.c_u_Image);
                  //previewImage.src = `${this.endpointImages}${this.newsArray.c_u_Image}`;
                }
                document.getElementById("AVEdropDown").getElementsByTagName("ul")[0].style.width = "450px";
                document.getElementById("journalistDropDown").getElementsByTagName("ul")[0].style.width = "350px";

              case 74:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee15, _this18);
      }))();
    },
    postEditNew: function postEditNew(newsArray, data) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var d, mm, dd, yy, checkIdJournalist, _loop7, index, patt, previewImage, result, ImageResult, input, files, VideoAudioResult, Payload;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                // update the news
                if (newsArray.c_u_Status > 0 && newsArray.c_u_Status <= 6) {
                  newsArray.c_u_Status = 6;
                }
                newsArray.c_u_NewsEditByUser = _this19.getLoggedInUserID();
                d = new Date();
                mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                yy = d.getFullYear();

                newsArray.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
                newsArray.c_u_NewsDateEdit = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

                //news create date and time
                if (_this19._newsDate.trim().length > 0 && _this19._newsTime.trim().length > 0) {
                  newsArray.c_u_NewsDateCreate = _this19._newsDate + "T" + _this19._newsTime + ":00.000";
                }

                newsArray.c_u_Summary = newsArray.c_u_Summary != "" ? newsArray.c_u_Summary.replace(/<[^>]*>?/gm, "") : newsArray.c_u_Summary;
                //newsArray.c_u_Content = newsArray.c_u_Content != "" ? newsArray.c_u_Content.replace(/<[^>]*>?/gm, '') : newsArray.c_u_Content;

                // check if we have the journalist in the list

                if (!(newsArray.c_r_Journalist != null)) {
                  _context18.next = 23;
                  break;
                }

                if (!(typeof newsArray.c_r_Journalist.name == "string")) {
                  _context18.next = 22;
                  break;
                }

                _this19.$api.data.endpoint = _this19.endpointJournalist;
                _context18.t0 = _;
                _context18.next = 16;
                return _this19.$api.data.find();

              case 16:
                _context18.t1 = _context18.sent;

                _context18.t2 = function (journalist) {
                  return journalist.c_u_Name == newsArray.c_r_Journalist.name;
                };

                checkIdJournalist = _context18.t0.find.call(_context18.t0, _context18.t1, _context18.t2);

                newsArray.c_r_Journalist = checkIdJournalist.c_id;
                _context18.next = 23;
                break;

              case 22:
                newsArray.c_r_Journalist = newsArray.c_r_Journalist;

              case 23:
                _this19.$api.data.endpoint = _this19.endpointNews;
                _context18.prev = 24;
                _context18.next = 27;
                return _this19.$api.data.updatedById(newsArray.c_id, newsArray);

              case 27:
                _context18.next = 31;
                break;

              case 29:
                _context18.prev = 29;
                _context18.t3 = _context18["catch"](24);

              case 31:
                _loop7 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop7(index) {
                  var objectThemesWord, findOneByIdThemes, findThemeNews, objectThemes;
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop7$(_context17) {
                    while (1) {
                      switch (_context17.prev = _context17.next) {
                        case 0:
                          objectThemesWord = {
                            c_u_Words: _this19.selectedThematics[index].wordName,
                            c_u_ThemeId: _this19.selectedThematics[index].id
                          };

                          _this19.$api.data.endpoint = "ThemeWords";
                          _context17.t0 = _;
                          _context17.next = 5;
                          return _this19.$api.data.find();

                        case 5:
                          _context17.t1 = _context17.sent;

                          _context17.t2 = function (o) {
                            return o.c_u_ThemeId == objectThemesWord.c_u_ThemeId;
                          };

                          findOneByIdThemes = _context17.t0.find.call(_context17.t0, _context17.t1, _context17.t2);

                          _this19.$api.data.endpoint = "ThemeWordsNews/Thematics/" + newsArray.c_id;
                          _context17.t3 = _;
                          _context17.next = 12;
                          return _this19.$api.data.find();

                        case 12:
                          _context17.t4 = _context17.sent;

                          _context17.t5 = function (r) {
                            return r.themeNews == newsArray.c_id && r.themeWordId == findOneByIdThemes.c_u_ThemeId;
                          };

                          findThemeNews = _context17.t3.find.call(_context17.t3, _context17.t4, _context17.t5);

                          if (!(findThemeNews == undefined)) {
                            _context17.next = 20;
                            break;
                          }

                          _this19.$api.data.endpoint = "ThemeWordsNews";
                          objectThemes = {
                            c_u_MatchedWords: findOneByIdThemes.c_u_Words,
                            c_u_Type: 0,
                            c_u_Status: 1,
                            c_r_ThemeWords: findOneByIdThemes.c_id,
                            c_r_News: newsArray.c_id
                          };
                          _context17.next = 20;
                          return _this19.$api.data.create(objectThemes);

                        case 20:
                        case "end":
                          return _context17.stop();
                      }
                    }
                  }, _loop7, _this19);
                });
                index = 0;

              case 33:
                if (!(index < _this19.selectedThematics.length)) {
                  _context18.next = 38;
                  break;
                }

                return _context18.delegateYield(_loop7(index), "t4", 35);

              case 35:
                index++;
                _context18.next = 33;
                break;

              case 38:
                _this19.selectedThematics = [];
                // upload Image to the server;
                patt = /media/;
                previewImage = document.getElementById("output");
                result = previewImage.src.match(patt);

                if (!(previewImage.src != "" && result == null)) {
                  _context18.next = 47;
                  break;
                }

                //old way - CORS errors
                /*$.ajax({
                  url: `${this.getUrl}/api/Image/${newsArray.c_id}`,
                  data: this.postImageData,
                  processData: false,
                  contentType: false,
                  type: "PATCH",
                });*/
                //new way - to avoid CORS errors
                _this19.$api.data.endpoint = "Image";
                _context18.next = 46;
                return _this19.$api.data.uploadImageById(newsArray.c_id, _this19.postImageData);

              case 46:
                ImageResult = _context18.sent;

              case 47:
                input = document.getElementById("filesMedia2");
                files = input.files;
                //debugger;

                if (!(files.length > 0)) {
                  _context18.next = 54;
                  break;
                }

                //old way - CORS errors
                /*$.ajax({
                  url: `${this.getUrl}/api/Image/VideoAudio/${newsArray.c_id}`,
                  data: this.mediaPath,
                  processData: false,
                  contentType: false,
                  type: "PATCH",
                });*/
                //new way - to avoid CORS errors
                _this19.$api.data.endpoint = "Image/VideoAudio";
                _context18.next = 53;
                return _this19.$api.data.uploadImageById(newsArray.c_id, _this19.mediaPath);

              case 53:
                VideoAudioResult = _context18.sent;

              case 54:
                for (index = 0; index < _this19.filteredsNews.length; index++) {
                  if (_this19.filteredsNews[index].c_id == newsArray.c_id) {
                    _this19.filteredsNews[index].c_u_Status = 6;
                  }
                }

                if (!(newsArray.c_id > 0)) {
                  _context18.next = 65;
                  break;
                }

                //process base64 images after other media uploads
                _this19.$api.data.endpoint = "News/PostSaveProcessBase64";
                Payload = { NewsID: newsArray.c_id, UserID: _this19.getLoggedInUserID() };
                _context18.prev = 58;
                _context18.next = 61;
                return _this19.$api.data.update(Payload);

              case 61:
                _context18.next = 65;
                break;

              case 63:
                _context18.prev = 63;
                _context18.t5 = _context18["catch"](58);

              case 65:

                _this19.isHidden = false;
                // this.$forceUpdate();
                // this.clickedEvent();
                _this19.imagesUpload(newsArray);
                _this19.showData();

              case 68:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee16, _this19, [[24, 29], [58, 63]]);
      }))();
    },
    publishEditedNew: function publishEditedNew(newsArray) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var checkIdJournalist, _loop8, index, patt, previewImage, result, ImageResult, input, files, VideoAudioResult, Payload, predicate;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                //newsArray.c_u_NewsDatePublished = new Date();
                newsArray.c_u_NewsPublishedByUser = _this20.getLoggedInUserID();
                newsArray.c_u_Status = 8;
                newsArray.c_u_Summary = newsArray.c_u_Summary != "" ? newsArray.c_u_Summary.replace(/<[^>]*>?/gm, "") : newsArray.c_u_Summary;
                //newsArray.c_u_Content = newsArray.c_u_Content != "" ? newsArray.c_u_Content.replace(/<[^>]*>?/gm, '') : newsArray.c_u_Content;

                //news create date and time
                if (_this20._newsDate.trim().length > 0 && _this20._newsTime.trim().length > 0) {
                  newsArray.c_u_NewsDateCreate = _this20._newsDate + "T" + _this20._newsTime + ":00.000";
                }

                // check if we have the journalist in the list

                if (!(newsArray.c_r_Journalist != null)) {
                  _context20.next = 17;
                  break;
                }

                if (!(typeof newsArray.c_r_Journalist.name == "string")) {
                  _context20.next = 16;
                  break;
                }

                _this20.$api.data.endpoint = _this20.endpointJournalist;
                _context20.t0 = _;
                _context20.next = 10;
                return _this20.$api.data.find();

              case 10:
                _context20.t1 = _context20.sent;

                _context20.t2 = function (journalist) {
                  return journalist.c_u_Name == newsArray.c_r_Journalist.name;
                };

                checkIdJournalist = _context20.t0.find.call(_context20.t0, _context20.t1, _context20.t2);

                newsArray.c_r_Journalist = checkIdJournalist.c_id;
                _context20.next = 17;
                break;

              case 16:
                newsArray.c_r_Journalist = newsArray.c_r_Journalist;

              case 17:
                _this20.$api.data.endpoint = _this20.endpointNews;
                _context20.prev = 18;
                _context20.next = 21;
                return _this20.$api.data.updatedById(newsArray.c_id, newsArray);

              case 21:
                _context20.next = 25;
                break;

              case 23:
                _context20.prev = 23;
                _context20.t3 = _context20["catch"](18);

              case 25:
                _loop8 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop8(index) {
                  var objectThemesWord, findOneByIdThemes, findThemeNews, objectThemes;
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop8$(_context19) {
                    while (1) {
                      switch (_context19.prev = _context19.next) {
                        case 0:
                          objectThemesWord = {
                            c_u_Words: _this20.selectedThematics[index].wordName,
                            c_u_ThemeId: _this20.selectedThematics[index].id
                          };

                          _this20.$api.data.endpoint = "ThemeWords";
                          _context19.t0 = _;
                          _context19.next = 5;
                          return _this20.$api.data.find();

                        case 5:
                          _context19.t1 = _context19.sent;

                          _context19.t2 = function (o) {
                            return o.c_u_ThemeId == objectThemesWord.c_u_ThemeId;
                          };

                          findOneByIdThemes = _context19.t0.find.call(_context19.t0, _context19.t1, _context19.t2);

                          _this20.$api.data.endpoint = "ThemeWordsNews/Thematics/" + newsArray.c_id;
                          _context19.t3 = _;
                          _context19.next = 12;
                          return _this20.$api.data.find();

                        case 12:
                          _context19.t4 = _context19.sent;

                          _context19.t5 = function (r) {
                            return r.themeNews == newsArray.c_id && r.themeWordId == findOneByIdThemes.c_u_ThemeId;
                          };

                          findThemeNews = _context19.t3.find.call(_context19.t3, _context19.t4, _context19.t5);

                          if (!(findThemeNews == undefined)) {
                            _context19.next = 20;
                            break;
                          }

                          _this20.$api.data.endpoint = "ThemeWordsNews";
                          objectThemes = {
                            c_u_MatchedWords: findOneByIdThemes.c_u_Words,
                            c_u_Type: 0,
                            c_u_Status: 1,
                            c_r_ThemeWords: findOneByIdThemes.c_id,
                            c_r_News: newsArray.c_id
                          };
                          _context19.next = 20;
                          return _this20.$api.data.create(objectThemes);

                        case 20:
                        case "end":
                          return _context19.stop();
                      }
                    }
                  }, _loop8, _this20);
                });
                index = 0;

              case 27:
                if (!(index < _this20.selectedThematics.length)) {
                  _context20.next = 32;
                  break;
                }

                return _context20.delegateYield(_loop8(index), "t4", 29);

              case 29:
                index++;
                _context20.next = 27;
                break;

              case 32:
                _this20.selectedThematics = [];
                // upload Image to the server;
                patt = /media/;
                previewImage = document.getElementById("output");
                result = previewImage.src.match(patt);

                if (!(previewImage.src != "" && result == null)) {
                  _context20.next = 41;
                  break;
                }

                //old way - CORS errors
                /*$.ajax({
                  url: `${this.getUrl}/api/Image/${newsArray.c_id}`,
                  data: this.postImageData,
                  processData: false,
                  contentType: false,
                  type: "PATCH",
                });*/
                //new way - to avoid CORS errors
                _this20.$api.data.endpoint = "Image";
                _context20.next = 40;
                return _this20.$api.data.uploadImageById(newsArray.c_id, _this20.postImageData);

              case 40:
                ImageResult = _context20.sent;

              case 41:
                input = document.getElementById("filesMedia2");
                files = input.files;

                if (!(files.length > 0)) {
                  _context20.next = 48;
                  break;
                }

                //old way - CORS errors
                /*$.ajax({
                  url: `${this.getUrl}/api/Image/VideoAudio/${newsArray.c_id}`,
                  data: this.mediaPath,
                  processData: false,
                  contentType: false,
                  type: "PATCH",
                });*/
                //new way - to avoid CORS errors
                _this20.$api.data.endpoint = "Image/VideoAudio";
                _context20.next = 47;
                return _this20.$api.data.uploadImageById(newsArray.c_id, _this20.mediaPath);

              case 47:
                VideoAudioResult = _context20.sent;

              case 48:
                for (index = 0; index < _this20.filteredsNews.length; index++) {
                  if (_this20.filteredsNews[index].c_id == newsArray.c_id) {
                    _this20.filteredsNews[index].c_u_Status = 8;
                  }
                }

                if (!(newsArray.c_id > 0)) {
                  _context20.next = 59;
                  break;
                }

                //process base64 images after other media uploads
                _this20.$api.data.endpoint = "News/PostSaveProcessBase64";
                Payload = { NewsID: newsArray.c_id, UserID: _this20.getLoggedInUserID() };
                _context20.prev = 52;
                _context20.next = 55;
                return _this20.$api.data.update(Payload);

              case 55:
                _context20.next = 59;
                break;

              case 57:
                _context20.prev = 57;
                _context20.t5 = _context20["catch"](52);

              case 59:

                _this20.imagesUpload(newsArray);
                _this20.isHidden = false;
                if (_this20.validateNews == true) {
                  // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
                  //   return o.c_u_Status != 8;
                  // });
                  predicate = function predicate(start, end) {
                    return function (_ref7) {
                      var c_u_Status = _ref7.c_u_Status;
                      return c_u_Status != start && c_u_Status != end;
                    };
                  };

                  _this20.filteredsNews = _this20.filteredsNews.filter(predicate(8, 10));
                }

              case 62:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee17, _this20, [[18, 23], [52, 57]]);
      }))();
    },
    imagesUpload: function imagesUpload(newsArray) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var divInputs, formData, index, files, i;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                divInputs = __WEBPACK_IMPORTED_MODULE_16_jquery___default()("#imageUpload");
                formData = new FormData();

                if (!(divInputs[0].childNodes.length > 0)) {
                  _context21.next = 9;
                  break;
                }

                for (index = 0; index < divInputs[0].childNodes.length; index++) {
                  files = divInputs[0].childNodes[index].files;

                  for (i = 0; i < files.length; i++) {
                    formData.append("files", files[i]);
                  }
                }
                _this21.$api.data.endpoint = "Image/media";
                _context21.next = 7;
                return _this21.$api.data.uploadImageById(typeof newsArray == "number" ? newsArray : newsArray.c_id, formData);

              case 7:
                _context21.next = 13;
                break;

              case 9:
                //this is used for the base64 images, to be able to set as main image
                formData.append("files", []);
                _this21.$api.data.endpoint = "Image/media";
                _context21.next = 13;
                return _this21.$api.data.uploadImageById(typeof newsArray == "number" ? newsArray : newsArray.c_id, formData);

              case 13:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee18, _this21);
      }))();
    },
    uploadFiles: function uploadFiles(inputId) {
      var input = document.getElementById(inputId);
      var files = input.files;
      var reader = new FileReader();
      var formData = new FormData();

      for (var i = 0; i != files.length; i++) {
        formData.append("files", files[i]);
      }
      this.postImageData = formData;
      reader.onload = function (e) {
        __WEBPACK_IMPORTED_MODULE_16_jquery___default()("#output").attr("src", e.target.result);
      };

      reader.readAsDataURL(input.files[0]);
    },
    uploadFilesMedia: function uploadFilesMedia(inputId) {
      var InputNumber = inputId.replace("filesMedia", "");

      document.getElementById("audioPreview") != null ? document.getElementById("audioPreview").remove() : "";
      document.getElementById("videoPreview") != null ? document.getElementById("videoPreview").remove() : "";
      document.getElementById("audioUploaded") != null ? document.getElementById("audioUploaded").remove() : "";
      document.getElementById("videoUploaded") != null ? document.getElementById("videoUploaded").remove() : "";

      var input = document.getElementById(inputId);
      var files = input.files;
      var reader = new FileReader();
      var formData = new FormData();

      for (var i = 0; i != files.length; i++) {
        formData.append("files", files[i]);
      }
      // Create a blob that we can use as an src for our audio element
      var urlObj = URL.createObjectURL(files[0]);
      // Create an audio element
      var audio = document.createElement("audio");
      var video = document.createElement("video");

      audio.id = "audioUploaded";
      video.id = "videoUploaded";

      if (files[0].type.match("audio")) {
        // if (document.getElementById("audioPreview") != null || document.getElementById("videoPreview")) {
        //   document.getElementById("audioPreview").remove();
        //   document.getElementById("videoPreview").remove();
        // }
        // Clean up the URL Object after we are done with it
        audio.addEventListener("load", function () {
          URL.revokeObjectURL(urlObj);
        });
        document.getElementById("fileVideoAudio" + InputNumber).appendChild(audio);

        // Allow us to control the audio
        audio.controls = "true";

        // Set the src and start loading the audio from the file
        audio.src = urlObj;
      }
      if (files[0].type.match("video")) {
        // if (document.getElementById("videoPreview") != null) {
        //   document.getElementById("viewPreview").remove();
        // }
        video.addEventListener("load", function () {
          URL.revokeObjectURL(urlObj);
        });
        video.style.width = "300px";
        video.style.height = "200px";
        // Append the audio element

        document.getElementById("fileVideoAudio" + InputNumber).appendChild(video);

        video.controls = "true";
        video.src = urlObj;
      }

      this.mediaPath = formData;
    },
    openEnLargeImg: function openEnLargeImg() {
      // Get the modal
      var modal = document.getElementById("myModal");

      // Get the image and insert it inside the modal
      var img = document.getElementById("output");
      var modalImg = document.getElementById("img01");
      var captionText = document.getElementById("caption");
      modal.style.display = "block";
      modalImg.src = img.src;
      captionText.innerHTML = img.alt;

      // Get the <span> element that closes the modal
      var span = document.getElementsByClassName("close")[0];

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = "none";
      };
    },
    deleteImg: function deleteImg() {
      var img = document.getElementById("output");
      img.src = "";
    },
    createJournalist: function createJournalist(journalist) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var newJournalist, _newJournalist, _newJournalist2;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                debugger;

                if (!(journalist !== undefined)) {
                  _context22.next = 26;
                  break;
                }

                if (!(journalist != null)) {
                  _context22.next = 26;
                  break;
                }

                if (!(typeof journalist === 'string')) {
                  _context22.next = 11;
                  break;
                }

                if (!(journalist.trim().length > 0)) {
                  _context22.next = 9;
                  break;
                }

                _this22.$api.data.endpoint = _this22.endpointJournalist;
                newJournalist = { c_u_Name: journalist };
                _context22.next = 9;
                return _this22.$api.data.create(newJournalist);

              case 9:
                _context22.next = 26;
                break;

              case 11:
                if (!((typeof journalist === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(journalist)) === 'object')) {
                  _context22.next = 26;
                  break;
                }

                if (!journalist.hasOwnProperty("c_u_name")) {
                  _context22.next = 20;
                  break;
                }

                if (!(journalist.c_u_name.trim().length > 0)) {
                  _context22.next = 18;
                  break;
                }

                _this22.$api.data.endpoint = _this22.endpointJournalist;
                _newJournalist = { c_u_Name: journalist.c_u_name };
                _context22.next = 18;
                return _this22.$api.data.create(_newJournalist);

              case 18:
                _context22.next = 26;
                break;

              case 20:
                if (!journalist.hasOwnProperty("name")) {
                  _context22.next = 26;
                  break;
                }

                if (!(journalist.name.trim().length > 0)) {
                  _context22.next = 26;
                  break;
                }

                _this22.$api.data.endpoint = _this22.endpointJournalist;
                _newJournalist2 = { c_u_Name: journalist.name };
                _context22.next = 26;
                return _this22.$api.data.create(_newJournalist2);

              case 26:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee19, _this22);
      }))();
    },
    allowDrop: function allowDrop(ev) {
      ev.preventDefault();
    },
    drag: function drag(item) {
      // if (ev.dataTransfer != undefined) {
      //   ev.dataTransfer.setData("text", ev.target.id);
      // } else {
      var checkIfContains = _.find(this.selectedThematics, function (ck) {
        return ck.wordName == item.wordName;
      });
      if (checkIfContains == undefined) {
        this.selectedThematics.push(item);
      }
      // var item = ev.target;
      // var cloneItem = item.cloneNode(true);
      // let checkIfExist = true;
      // if ($("#divDragAndDrop")[0].childNodes.length > 0) {
      //   for (
      //     let index = 0;
      //     index < $("#divDragAndDrop")[0].childNodes.length;
      //     index++
      //   ) {
      //     if (ev.target.id == $("#divDragAndDrop")[0].childNodes[index].id) {
      //       checkIfExist = false;
      //     }
      //   }
      // }
      // if (checkIfExist == true) {
      //   $(cloneItem).appendTo("#divDragAndDrop");
      //   item.style.color = "Green";
      //   for (
      //     let index = 0;
      //     index < $("#divDragAndDrop")[0].childNodes.length;
      //     index++
      //   ) {
      //     $("#divDragAndDrop")[0].childNodes[index].classList.remove("col");
      //     $("#divDragAndDrop")[0].childNodes[index].classList.add("col-sm-4");
      //   }
      // }
      //}
    },
    drop: function drop(ev) {
      ev.preventDefault();
      var data = ev.dataTransfer.getData("text");
      ev.target.appendChild(document.getElementById(data));
    },
    deleteThematic: function deleteThematic(index, id) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var deleteThemes, findThemeNews, _section, _findSection, _section2, _findSection2, section, findSection;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                deleteThemes = _this23.selectedThematics[index];
                findThemeNews = deleteThemes.c_id == undefined ? undefined : deleteThemes;
                // this.$api.data.endpoint = "ThemeWords";
                // let findThemeWord = _.find(await this.$api.data.find(), function (f) {
                //   return f.c_u_ThemeId == deleteThemes.id;
                // });

                _this23.$api.data.endpoint = "ThemeWordsNews";
                // let findThemeNews = _.find(await this.$api.data.find(), function (r) {
                //   return r.c_r_News == id && r.c_r_ThemeWords == findThemeWord.c_id;
                // });

                if (!(findThemeNews != undefined)) {
                  _context23.next = 11;
                  break;
                }

                _context23.next = 6;
                return _this23.$api.data.destroyById(findThemeNews.c_id);

              case 6:
                _section = document.getElementById("sectionThems") != undefined ? document.getElementById("sectionThems").childNodes : [];
                _findSection = _.find(_section, function (o) {
                  return o.innerHTML == deleteThemes.wordName;
                });

                if (_findSection != undefined) {
                  _findSection.style.color = "";
                  _findSection.style.backgroundColor = "";
                  _findSection.style.fontWeight = "";
                }
                _context23.next = 14;
                break;

              case 11:
                _section2 = document.getElementById("sectionThems") != undefined ? document.getElementById("sectionThems").childNodes : [];
                _findSection2 = _.find(_section2, function (o) {
                  return o.innerHTML == deleteThemes.wordName;
                });

                if (_findSection2 != undefined) {
                  _findSection2.style.color = "";
                  _findSection2.style.backgroundColor = "";
                  _findSection2.style.fontWeight = "";
                }

              case 14:
                section = document.getElementById("sectionThems") != undefined ? document.getElementById("sectionThems").childNodes : [];
                findSection = _.find(section, function (o) {
                  return o.innerHTML == deleteThemes.wordName;
                });

                if (findSection.style.color == "") {
                  _this23.isThematicDelete = true;
                  _this23.isThematicDeleteId = deleteThemes.id;
                  _this23.selectedThematics.splice(index, 1);
                  _this23.$forceUpdate();
                }

              case 17:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee20, _this23);
      }))();
    },
    deleteEditNew: function deleteEditNew(newsArray) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var d, mm, dd, yy, sourceName, i, Payload;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (!(newsArray.c_u_Status == 8 || newsArray.c_u_Status == 10)) {
                  _context24.next = 4;
                  break;
                }

                _this24.$bvToast.toast("Não é possível eliminar uma notícia publicada", {
                  autoHideDelay: 4000,
                  variant: "warning"
                });
                _context24.next = 35;
                break;

              case 4:
                _this24.$api.data.endpoint = _this24.endpointNews;
                newsArray.c_u_NewsEditByUser = _this24.getLoggedInUserID();
                d = new Date();
                mm = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                yy = d.getFullYear();

                newsArray.c_u_ProcessedDate = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();
                newsArray.c_u_NewsDateEdit = yy + "-" + mm + "-" + dd + " " + d.toLocaleTimeString();

                newsArray.c_u_Status = -1;
                _context24.prev = 13;
                _context24.next = 16;
                return _this24.$api.data.updatedById(newsArray.c_id, newsArray);

              case 16:
                _context24.next = 20;
                break;

              case 18:
                _context24.prev = 18;
                _context24.t0 = _context24["catch"](13);

              case 20:
                _this24.newsArray = [];
                // remove selected source in the first section
                sourceName = document.getElementsByClassName("section1Name");

                for (i = 0; i < sourceName.length; i++) {
                  if (sourceName[i].style.color != "") {
                    sourceName[i].style.color = null;
                    sourceName[i].style.fontWeight = null;
                  }
                }

                if (!(newsArray.c_id > 0)) {
                  _context24.next = 33;
                  break;
                }

                //process base64 images after other media uploads
                _this24.$api.data.endpoint = "News/PostSaveProcessBase64";
                Payload = { NewsID: newsArray.c_id, UserID: _this24.getLoggedInUserID() };
                _context24.prev = 26;
                _context24.next = 29;
                return _this24.$api.data.update(Payload);

              case 29:
                _context24.next = 33;
                break;

              case 31:
                _context24.prev = 31;
                _context24.t1 = _context24["catch"](26);

              case 33:

                _this24.isHidden = false;
                if (_this24.isFilteredData == true) {
                  _this24.filterData();
                } else {
                  _this24.clickedEvent(_this24.clickedEventSourceId, _this24.clickedEventSourceName);
                }

              case 35:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee21, _this24, [[13, 18], [26, 31]]);
      }))();
    },
    copyEditedNew: function copyEditedNew(newsArray) {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var checkIdJournalist, _loop9, index, patt, previewImage, result, ImageResult, input, files, VideoAudioResult, sourceName, i, Payload;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                newsArray.c_u_Status = 7;
                newsArray.c_u_Summary = newsArray.c_u_Summary != "" ? newsArray.c_u_Summary.replace(/<[^>]*>?/gm, "") : newsArray.c_u_Summary;
                //newsArray.c_u_Content = newsArray.c_u_Content != "" ? newsArray.c_u_Content.replace(/<[^>]*>?/gm, '') : newsArray.c_u_Content;

                //news create date and time
                if (_this25._newsDate.trim().length > 0 && _this25._newsTime.trim().length > 0) {
                  newsArray.c_u_NewsDateCreate = _this25._newsDate + "T" + _this25._newsTime + ":00.000";
                }

                // check if we have the journalist in the list

                if (!(newsArray.c_r_Journalist != null)) {
                  _context26.next = 16;
                  break;
                }

                if (!(typeof newsArray.c_r_Journalist.name == "string")) {
                  _context26.next = 15;
                  break;
                }

                _this25.$api.data.endpoint = _this25.endpointJournalist;
                _context26.t0 = _;
                _context26.next = 9;
                return _this25.$api.data.find();

              case 9:
                _context26.t1 = _context26.sent;

                _context26.t2 = function (journalist) {
                  return journalist.c_u_Name == newsArray.c_r_Journalist.name;
                };

                checkIdJournalist = _context26.t0.find.call(_context26.t0, _context26.t1, _context26.t2);

                newsArray.c_r_Journalist = checkIdJournalist.c_id;
                _context26.next = 16;
                break;

              case 15:
                newsArray.c_r_Journalist = newsArray.c_r_Journalist;

              case 16:
                _this25.$api.data.endpoint = _this25.endpointNews;
                _context26.prev = 17;
                _context26.next = 20;
                return _this25.$api.data.updatedById(newsArray.c_id, newsArray);

              case 20:
                _context26.next = 24;
                break;

              case 22:
                _context26.prev = 22;
                _context26.t3 = _context26["catch"](17);

              case 24:
                _loop9 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop9(index) {
                  var objectThemesWord, findOneByIdThemes, findThemeNews, objectThemes;
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop9$(_context25) {
                    while (1) {
                      switch (_context25.prev = _context25.next) {
                        case 0:
                          objectThemesWord = {
                            c_u_Words: _this25.selectedThematics[index].wordName,
                            c_u_ThemeId: _this25.selectedThematics[index].id
                          };

                          _this25.$api.data.endpoint = "ThemeWords";
                          _context25.t0 = _;
                          _context25.next = 5;
                          return _this25.$api.data.find();

                        case 5:
                          _context25.t1 = _context25.sent;

                          _context25.t2 = function (o) {
                            return o.c_u_ThemeId == objectThemesWord.c_u_ThemeId;
                          };

                          findOneByIdThemes = _context25.t0.find.call(_context25.t0, _context25.t1, _context25.t2);

                          _this25.$api.data.endpoint = "ThemeWordsNews/Thematics/" + newsArray.c_id;
                          _context25.t3 = _;
                          _context25.next = 12;
                          return _this25.$api.data.find();

                        case 12:
                          _context25.t4 = _context25.sent;

                          _context25.t5 = function (r) {
                            return r.themeNews == newsArray.c_id && r.themeWordId == findOneByIdThemes.c_u_ThemeId;
                          };

                          findThemeNews = _context25.t3.find.call(_context25.t3, _context25.t4, _context25.t5);

                          if (!(findThemeNews == undefined)) {
                            _context25.next = 20;
                            break;
                          }

                          _this25.$api.data.endpoint = "ThemeWordsNews";
                          objectThemes = {
                            c_u_MatchedWords: findOneByIdThemes.c_u_Words,
                            c_u_Type: 0,
                            c_u_Status: 1,
                            c_r_ThemeWords: findOneByIdThemes.c_id,
                            c_r_News: newsArray.c_id
                          };
                          _context25.next = 20;
                          return _this25.$api.data.create(objectThemes);

                        case 20:
                        case "end":
                          return _context25.stop();
                      }
                    }
                  }, _loop9, _this25);
                });
                index = 0;

              case 26:
                if (!(index < _this25.selectedThematics.length)) {
                  _context26.next = 31;
                  break;
                }

                return _context26.delegateYield(_loop9(index), "t4", 28);

              case 28:
                index++;
                _context26.next = 26;
                break;

              case 31:
                _this25.selectedThematics = [];
                // upload Image to the server;
                patt = /media/;
                previewImage = document.getElementById("output");
                result = previewImage.src.match(patt);

                if (!(previewImage.src != "" && result == null)) {
                  _context26.next = 40;
                  break;
                }

                //old way - CORS errors
                /*$.ajax({
                  url: `${this.getUrl}/api/Image/${newsArray.c_id}`,
                  data: this.postImageData,
                  processData: false,
                  contentType: false,
                  type: "PATCH",
                });*/
                //new way - to avoid CORS errors
                _this25.$api.data.endpoint = "Image";
                _context26.next = 39;
                return _this25.$api.data.uploadImageById(newsArray.c_id, _this25.postImageData);

              case 39:
                ImageResult = _context26.sent;

              case 40:
                input = document.getElementById("filesMedia2");
                files = input.files;

                if (!(files.length > 0)) {
                  _context26.next = 47;
                  break;
                }

                //old way - CORS errors
                /*$.ajax({
                  url: `${this.getUrl}/api/Image/VideoAudio/${newsArray.c_id}`,
                  data: this.mediaPath,
                  processData: false,
                  contentType: false,
                  type: "PATCH",
                });*/
                //new way - to avoid CORS errors
                _this25.$api.data.endpoint = "Image/VideoAudio";
                _context26.next = 46;
                return _this25.$api.data.uploadImageById(newsArray.c_id, _this25.mediaPath);

              case 46:
                VideoAudioResult = _context26.sent;

              case 47:

                _this25.isHidden = false;
                _this25.newsArray = [];
                // remove selected source in the first section
                sourceName = document.getElementsByClassName("section1Name");

                for (i = 0; i < sourceName.length; i++) {
                  if (sourceName[i].style.color != "") {
                    sourceName[i].style.color = null;
                    sourceName[i].style.fontWeight = null;
                  }
                }

                if (!(newsArray.c_id > 0)) {
                  _context26.next = 61;
                  break;
                }

                //process base64 images after other media uploads
                _this25.$api.data.endpoint = "News/PostSaveProcessBase64";
                Payload = { NewsID: newsArray.c_id, UserID: _this25.getLoggedInUserID() };
                _context26.prev = 54;
                _context26.next = 57;
                return _this25.$api.data.update(Payload);

              case 57:
                _context26.next = 61;
                break;

              case 59:
                _context26.prev = 59;
                _context26.t5 = _context26["catch"](54);

              case 61:

                _this25.imagesUpload(newsArray);
                _this25.isHidden = false;
                if (_this25.isFilteredData == true) {
                  _this25.filterData();
                } else {
                  _this25.clickedEvent(_this25.clickedEventSourceId, _this25.clickedEventSourceName);
                }

              case 64:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee22, _this25, [[17, 22], [54, 59]]);
      }))();
    },
    selectAllNews: function selectAllNews() {
      //debugger;
      this.selectedNews = [];
      if (this.validateNews) {
        for (var index = 0; index < this.filteredsNews.length; index++) {
          if (this.selectedNews[index] == undefined) {
            this.selectedNews.push(this.filteredsNews[index].c_id);
          }
        }
      } else {
        for (var _index27 = 0; _index27 < this.optionsNews.length; _index27++) {
          if (this.selectedNews[_index27] == undefined) {
            this.selectedNews.push(this.optionsNews[_index27][0].item);
          }
        }
      }
    },
    deleteAllNews: function deleteAllNews() {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee23() {
        var Payload, _sourceName, i;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (!(_this26.selectedNews.length == 0)) {
                  _context27.next = 4;
                  break;
                }

                _this26.$bvToast.toast("Selecione notícias para eliminar", {
                  autoHideDelay: 4000,
                  variant: "danger"
                });
                _context27.next = 18;
                break;

              case 4:
                _this26.$api.data.endpoint = "News/SetStatusDeleted";
                Payload = { NewsIDs: _this26.selectedNews, UserID: _this26.getLoggedInUserID() };
                _context27.prev = 6;
                _context27.next = 9;
                return _this26.$api.data.update(Payload);

              case 9:
                _context27.next = 13;
                break;

              case 11:
                _context27.prev = 11;
                _context27.t0 = _context27["catch"](6);

              case 13:

                // remove selected source in the first section
                _sourceName = document.getElementsByClassName("section1Name");

                for (i = 0; i < _sourceName.length; i++) {
                  if (_sourceName[i].style.color != "") {
                    _sourceName[i].style.color = null;
                    _sourceName[i].style.fontWeight = null;
                  }
                }
                _this26.isHidden = false;
                _this26.selectedNews = [];

                if (_this26.isFilteredData == true) {
                  _this26.filterData();
                } else {
                  _this26.clickedEvent(_this26.clickedEventSourceId, _this26.clickedEventSourceName);
                }

              case 18:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee23, _this26, [[6, 11]]);
      }))();
    },
    publishAllNews: function publishAllNews() {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee24() {
        var Payload, _sourceName2, i;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                if (!(_this27.selectedNews.length == 0)) {
                  _context28.next = 4;
                  break;
                }

                _this27.$bvToast.toast("Selecione notícias para publicar", {
                  autoHideDelay: 4000,
                  variant: "danger"
                });
                _context28.next = 19;
                break;

              case 4:
                _this27.$api.data.endpoint = "News/SetStatusPublished";
                Payload = { NewsIDs: _this27.selectedNews, UserID: _this27.getLoggedInUserID() };
                _context28.prev = 6;
                _context28.next = 9;
                return _this27.$api.data.update(Payload);

              case 9:
                _context28.next = 13;
                break;

              case 11:
                _context28.prev = 11;
                _context28.t0 = _context28["catch"](6);

              case 13:

                // remove selected source in the first section
                _sourceName2 = document.getElementsByClassName("section1Name");

                for (i = 0; i < _sourceName2.length; i++) {
                  if (_sourceName2[i].style.color != "") {
                    _sourceName2[i].style.color = null;
                    _sourceName2[i].style.fontWeight = null;
                  }
                }
                _this27.isHidden = false;
                _this27.filteredsNews = [];
                _this27.selectedNews = [];
                //this.showData();

                if (_this27.isFilteredData == true) {
                  _this27.filterData();
                } else {
                  _this27.clickedEvent(_this27.clickedEventSourceId, _this27.clickedEventSourceName);
                }

              case 19:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee24, _this27, [[6, 11]]);
      }))();
    },
    clearFilters: function clearFilters() {
      this.isFilteredData = false;
      this.noNewsFromCheckbox = false;
      this.selectedFilterSource = [];
      this.selectedFilterStatus = "";
      this.selectedFilterUsers = [];
      this.selectedFilterType = [];
      this.selectedFilterTheme = [];
      this.filteredText = "";
      this.filtersDates = {
        startDate: "",
        endDate: ""
      };
      // remove selected source in the first section
      var sourceName = document.getElementsByClassName("section1Name");
      for (var i = 0; i < sourceName.length; i++) {
        if (sourceName[i].style.color != "") {
          sourceName[i].style.color = null;
          sourceName[i].style.fontWeight = null;
        }
      }
      this.isHidden = false;
      this.filteredsNews = [];
    },
    filterData: function filterData() {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee25() {
        var sourceName, i, todaysDate, urlEncoderSource, startDateFilter, endDateFilter, statusFilter, typeFilter, themeFilter, userFilter, textFilter, index, predicate;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                /*
                filterData() -> pesquisar notícias
                clickedScrolll() -> ver mais notícias
                clickedEvent() -> obter notícias carregando na fonte
                selectAllNews() -> função que seleciona todas as notícias listadas
                
                filteredsNews -> lista filtrada pela webapi (ao carregar no botão pesquisar)
                dataFromFilter -> lista filtrada pela webapi (ao carregar no botão pesquisar)
                neededArrayOfNews -> lista de notícias de uma fonte (ao carregar na fonte à esquerda)
                optionsNews -> lista que guarda as opções listadas
                selectedNews -> lista de notícias selecionadas
                    
                validateNews -> booleano que indica se as publicadas estão ocultas
                noNewsFromCheckbox -> boolenano, após filtrar para esconder as publicadas, indica se existem resultados
                */

                //debugger;
                if (!_this28.isNotCreatedNew) {
                  _this28.cancelCreationOfNew();
                }

                _this28.isFilteredData = true;
                _this28.isNotCreatedNew = true;
                // remove selected source in the first section
                sourceName = document.getElementsByClassName("section1Name");

                for (i = 0; i < sourceName.length; i++) {
                  if (sourceName[i].style.color != "") {
                    sourceName[i].style.color = null;
                    sourceName[i].style.fontWeight = null;
                  }
                }
                _this28.isHidden = false;

                // if (
                //   this.filtersDates.startDate != "" &&
                //   this.filtersDates.endDate == ""
                // ) {
                //   let todaysDate = new Date();
                //   todaysDate =
                //     todaysDate.getFullYear() +
                //     "-" +
                //     (todaysDate.getMonth() + 1 < 10
                //       ? "0" + (todaysDate.getMonth() + 1)
                //       : todaysDate.getMonth() + 1) +
                //     "-" +
                //     (todaysDate.getDate() < 10
                //       ? "0" + todaysDate.getDate()
                //       : todaysDate.getDate());
                //   this.filtersDates.endDate = todaysDate;
                // }
                // if (this.filteredData.length == 0) {
                //   if (this.selectedFilterSource.length > 0) {
                //     for (
                //       let index = 0;
                //       index < this.selectedFilterSource.length;
                //       index++
                //     ) {
                //       if (this.filteredNewsBySource[index] == undefined) {
                //         this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredNews}/${this.selectedFilterSource[index]}`;
                //         this.filteredNewsBySource.push(
                //           _.filter(await this.$api.data.find(), src => {
                //             return src.c_r_Source == this.selectedFilterSource[index];
                //           })
                //         );
                //       }
                //     }
                //   }
                //   for (let index = 0; index < this.filteredNewsBySource.length; index++) {
                //     for (let i = 0; i < this.filteredNewsBySource[index].length; i++) {
                //       this.eachNewBySource.push(this.filteredNewsBySource[index][i]);
                //     }
                //   }
                //   this.filteredData = _.xor(this.eachNewBySource);
                // }
                // // filter the dates
                // if (this.filteredData.length > 0) {
                //   if (
                //     this.filtersDates.startDate != "" &&
                //     this.filtersDates.endDate != ""
                //   ) {
                //     this.filteredData = _.filter(this.filteredData, strDate => {
                //       return (
                //         Date.parse(strDate.c_u_ProcessedDate.split("T")[0]) >=
                //           Date.parse(this.filtersDates.startDate) &&
                //         Date.parse(strDate.c_u_ProcessedDate.split("T")[0]) <=
                //           Date.parse(this.filtersDates.endDate)
                //       );
                //     });
                //   }
                // } else {
                //   if (
                //     this.filtersDates.startDate != "" &&
                //     this.filtersDates.endDate != ""
                //   ) {
                //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByDate}/${this.filtersDates.startDate}/${this.filtersDates.endDate}`;
                //     this.filteredData = await this.$api.data.find();
                //   }
                // }

                // //filtered the status
                // if (this.filteredData.length > 0) {
                //   if (typeof this.selectedFilterStatus == "number") {
                //     this.filteredData = _.filter(this.filteredData, status => {
                //       return status.c_u_Status == this.selectedFilterStatus;
                //     });
                //   }
                // } else {
                //   if (typeof this.selectedFilterStatus == "number") {
                //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByStatus}/${this.selectedFilterStatus}`;
                //     this.filteredData = await this.$api.data.find();
                //   }
                // }
                // //filtered the type
                // if (this.filteredData.length > 0) {
                //   if (typeof this.selectedFilterType == "number") {
                //     this.filteredData = _.filter(this.filteredData, status => {
                //       return status.c_u_Type == this.selectedFilterType;
                //     });
                //   }
                // } else {
                //   if (typeof this.selectedFilterType == "number") {
                //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByType}/${this.selectedFilterType}`;
                //     this.filteredData = await this.$api.data.find();
                //   }
                // }
                // //filtered the type
                // if (this.filteredData.length > 0) {
                //   if (typeof this.selectedFilterTheme == "number") {
                //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByTheme}/${this.selectedFilterTheme}`;
                //     let theme = await this.$api.data.find();
                //     let newFilteredData = [];
                //     for (let index = 0; index < this.filteredData.length; index++) {
                //       for (let i = 0; i < theme.length; i++) {
                //         if (theme[i].c_id == this.filteredData[index].c_id) {
                //           newFilteredData.push(this.filteredData[index]);
                //         }
                //       }
                //     }
                //     this.filteredData = newFilteredData;
                //     // this.filteredData = _.filter(this.filteredData, status => {
                //     //   return status.c_u_Type == this.selectedFilterTheme;
                //     // });
                //   }
                // } else {
                //   if (typeof this.selectedFilterTheme == "number") {
                //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByTheme}/${this.selectedFilterTheme}`;
                //     this.filteredData = await this.$api.data.find();
                //   }
                // }

                // //filtered the User
                // if (this.filteredData.length > 0) {
                //   if (typeof this.selectedFilterUsers == "number") {
                //     this.filteredData = _.filter(this.filteredData, status => {
                //       return (
                //         status.c_u_NewsEditByUser == this.selectedFilterUsers ||
                //         status.c_u_NewsPublishedByUser == this.selectedFilterUsers
                //       );
                //     });
                //   }
                // } else {
                //   if (typeof this.selectedFilterUsers == "number") {
                //     this.$api.data.endpoint = `${this.endpointNews}/${this.endpointFilteredByUser}/${this.selectedFilterUsers}`;
                //     this.filteredData = await this.$api.data.find();
                //   }
                // }

                // //filtered the Text
                // if (this.filteredData.length > 0) {
                //   if (this.filteredText != "") {
                //     this.filteredData = _.filter(this.filteredData, text => {
                //       return text.c_u_Content.match(this.filteredText);
                //     });
                //   }
                // } else {
                //   if (this.filteredText != "") {
                //     this.$api.data.endpoint = this.endpointNews;
                //     this.filteredData = _.filter(await this.$api.data.find(), text => {
                //       return text.c_u_Content.match(this.filteredText);
                //     });
                //   }
                // }
                // this.filteredsNews = this.filteredData.sort(
                //   (a, b) =>
                //     Date.parse(b.c_u_ProcessedDate) - Date.parse(a.c_u_ProcessedDate)
                // );
                // for (let index = 0; index < this.filteredsNews.length; index++) {
                //   this.optionsNews[index] = [];
                //   this.optionsNews[index].push({
                //     item: this.filteredsNews[index].c_id,
                //     name: ""
                //   });
                // }

                if (!(_this28.selectedFilterSource.length == 0 && _this28.filtersDates.startDate == "" && _this28.filtersDates.endDate == "" && typeof _this28.selectedFilterStatus != "number" && typeof _this28.selectedFilterType != "number" && typeof _this28.selectedFilterTheme != "number" && typeof _this28.selectedFilterUsers != "number" && _this28.filteredText == "")) {
                  _context29.next = 10;
                  break;
                }

                _this28.$bvToast.toast("Necessario preencher campos!", {
                  autoHideDelay: 4000,
                  variant: "danger"
                });
                _context29.next = 27;
                break;

              case 10:
                if (_this28.filtersDates.startDate != "" && _this28.filtersDates.endDate == "") {
                  todaysDate = new Date();

                  todaysDate = todaysDate.getFullYear() + "-" + (todaysDate.getMonth() + 1 < 10 ? "0" + (todaysDate.getMonth() + 1) : todaysDate.getMonth() + 1) + "-" + (todaysDate.getDate() < 10 ? "0" + todaysDate.getDate() : todaysDate.getDate());
                  _this28.filtersDates.endDate = todaysDate;
                }
                urlEncoderSource = _this28.selectedFilterSource.length != 0 ? encodeURIComponent(_this28.selectedFilterSource.toString()) : 0;
                startDateFilter = _this28.filtersDates.startDate == "" ? 0 : _this28.filtersDates.startDate;
                endDateFilter = _this28.filtersDates.endDate == "" ? 0 : _this28.filtersDates.endDate;
                statusFilter = typeof _this28.selectedFilterStatus != "number" ? 0 : _this28.selectedFilterStatus;
                typeFilter = typeof _this28.selectedFilterType != "number" ? 20 : _this28.selectedFilterType;
                themeFilter = typeof _this28.selectedFilterTheme != "number" ? 0 : _this28.selectedFilterTheme;
                userFilter = typeof _this28.selectedFilterUsers != "number" ? 0 : _this28.selectedFilterUsers;
                textFilter = _this28.filteredText == "" ? 0 : _this28.filteredText;

                //Call the endpoint of filter

                _this28.$api.data.endpoint = _this28.endpointNews + "/" + _this28.endpointFilteredSection + "/" + urlEncoderSource + "/" + typeFilter + "/" + themeFilter + "/" + startDateFilter + "/" + endDateFilter + "/" + statusFilter + "/" + userFilter + "/" + textFilter + "/0";
                _context29.next = 22;
                return _this28.$api.data.find();

              case 22:
                _this28.filteredData = _context29.sent;

                _this28.filteredsNews = _this28.filteredData;
                _this28.dataFromFilter = _this28.filteredsNews;
                //debugger;
                _this28.optionsNews = [[]];
                for (index = 0; index < _this28.filteredsNews.length; index++) {
                  _this28.optionsNews[index] = [];
                  _this28.optionsNews[index].push({
                    item: _this28.filteredsNews[index].c_id,
                    name: ""
                  });
                }

              case 27:

                if (_this28.validateNews == true) {
                  // this.filteredsNews = _.filter(this.filteredsNews, function (o) {
                  //   return o.c_u_Status != 8;
                  // });
                  predicate = function predicate(start, end) {
                    return function (_ref8) {
                      var c_u_Status = _ref8.c_u_Status;
                      return c_u_Status != start && c_u_Status != end;
                    };
                  };

                  _this28.filteredsNews = _this28.filteredsNews.filter(predicate(8, 10));
                } else {
                  _this28.filteredsNews = _this28.dataFromFilter;
                }

                _this28.filteredData = [];
                _this28.filteredNewsBySource = [];
                _this28.eachNewBySource = [];

              case 31:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee25, _this28);
      }))();
    },
    withPopper: function withPopper(dropdownList, component, _ref9) {
      var width = _ref9.width;

      dropdownList.style.width = "350px";
      var popper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__popperjs_core__["a" /* createPopper */])(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [{
          name: "offset",
          options: {
            offset: [0, -1]
          }
        }, {
          name: "toggleClass",
          enabled: true,
          phase: "write",
          fn: function fn(_ref10) {
            var state = _ref10.state;

            component.$el.classList.toggle("drop-up", state.placement === "top");
          }
        }]
      });

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return function () {
        return popper.destroy();
      };
    }
  },
  mounted: function mounted() {
    var _this29 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee26() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _this29.showData();
              _this29.onResize();
              _this29.filtersHeight = document.getElementById("filtersHeightSize").clientHeight;

            case 3:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee26, _this29);
    }))();
  }
});

/***/ }),

/***/ "LdBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUrl_vue__ = __webpack_require__("PaoK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c51058_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUrl_vue__ = __webpack_require__("Jaez");
function injectStyle (ssrContext) {
  __webpack_require__("1nRB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61c51058"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c51058_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LzW6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655dbc9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("pjCv");
function injectStyle (ssrContext) {
  __webpack_require__("TdBs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655dbc9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MJSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"fluid":""}},[_c('b-modal',{attrs:{"scrollable":"","id":"createConfigs1Xml","size":"xl","title":"Configuraçao XML1"},on:{"cancel":_vm.resetFields,"ok":_vm.createUrlSouce}},[(_vm.isSimple)?_c('div',{staticClass:"isSimple"},[_c('b-row',[_c('b-col',[_c('label',[_vm._v("URLS")])])],1),_vm._v(" "),_c('b-row',{staticClass:"borderStyler"},[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.clicked),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Url "+_vm._s(item)+":")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the url"},model:{value:(_vm.urlArray[item - 1].url),callback:function ($$v) {_vm.$set(_vm.urlArray[item - 1], "url", $$v)},expression:"urlArray[item - 1].url"}})],1),_vm._v(" "),_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"2"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeUrlDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Priority:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.urlArray[item - 1].priority),callback:function ($$v) {_vm.$set(_vm.urlArray[item - 1], "priority", $$v)},expression:"urlArray[item - 1].priority"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Novo url'),expression:"'Novo url'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addUrlDiv(_vm.clicked)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',[_vm._v("TO EXTRACT")])])],1),_vm._v(" "),_c('b-row',{staticClass:"borderStyler"}),_vm._v(" "),_vm._l((_vm.addDivPartialUrl),function(item){return _c('div',{key:item},[_c('b-row',[_c('b-col',[_c('label',[_vm._v("Item "+_vm._s(item))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("For:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox-group',{attrs:{"options":_vm.optionsForExtractUrl,"value-field":"item","text-field":"name"},model:{value:(_vm.selectedUrlForExtract[item - 1]),callback:function ($$v) {_vm.$set(_vm.selectedUrlForExtract, item - 1, $$v)},expression:"selectedUrlForExtract[item - 1]"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Eliminar Item'),expression:"'Eliminar Item'",modifiers:{"hover":true,"right":true}}],attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeItemfromUrl(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),(_vm.addDivNotFullUrl[item - 1])?_c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivToQuery[item - 1]),function(idQuery){return _c('div',{key:idQuery,staticClass:"queryBorder"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Query:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-textarea',{attrs:{"placeholder":"Enter the query...","rows":"1","id":"text-area"},model:{value:(
                        _vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                          .query
                      ),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                          , "query", $$v)},expression:"\n                        toReplaceOptions[item - 1].queryToReplace[idQuery - 1]\n                          .query\n                      "}})],1),_vm._v(" "),(idQuery > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeQueryOfUrl(item - 1, idQuery - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Parcial Url:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},on:{"change":function($event){_vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                          .isPartial == false
                          ? (_vm.toReplaceOptions[item - 1].queryToReplace[
                              idQuery - 1
                            ].isPartial = true)
                          : (_vm.toReplaceOptions[item - 1].queryToReplace[
                              idQuery - 1
                            ].isPartial = false);
                        _vm.$forceUpdate();}},model:{value:(_vm.isPartialQuery[item - 1][idQuery - 1]),callback:function ($$v) {_vm.$set(_vm.isPartialQuery[item - 1], idQuery - 1, $$v)},expression:"isPartialQuery[item - 1][idQuery - 1]"}})],1)],1),_vm._v(" "),(
                    _vm.toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                      .isPartial
                  )?_c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("To Replace:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(
                          _vm.toReplaceOptions[item - 1].queryToReplace[
                            idQuery - 1
                          ].toReplace
                        ),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1].queryToReplace[
                            idQuery - 1
                          ], "toReplace", $$v)},expression:"\n                          toReplaceOptions[item - 1].queryToReplace[\n                            idQuery - 1\n                          ].toReplace\n                        "}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Prepare QS:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox',{attrs:{"value":"true","unchecked-value":"false"},model:{value:(
                          _vm.toReplaceOptions[item - 1].queryToReplace[
                            idQuery - 1
                          ].prepateQs
                        ),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1].queryToReplace[
                            idQuery - 1
                          ], "prepateQs", $$v)},expression:"\n                          toReplaceOptions[item - 1].queryToReplace[\n                            idQuery - 1\n                          ].prepateQs\n                        "}})],1)],1)],1):_vm._e()],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addQueryForUrl(_vm.addDivToQuery[item - 1], item)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("URL:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(_vm.toReplaceOptions[item - 1].urlToReplace),callback:function ($$v) {_vm.$set(_vm.toReplaceOptions[item - 1], "urlToReplace", $$v)},expression:"toReplaceOptions[item - 1].urlToReplace"}})],1)],1)],1):_vm._e()],1)}),_vm._v(" "),(_vm.addDivNotFullUrl[0])?_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{attrs:{"sm":"11 text-right"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Novo item'),expression:"'Novo item'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addPartialUrlDiv(_vm.addDivPartialUrl)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',[_vm._v("TO REMOVE")])])],1),_vm._v(" "),_c('b-row',{staticClass:"borderStyler"}),_vm._v(" "),_vm._l((_vm.addDivToRemove),function(item){return _c('div',[_c('b-row',[_c('b-col',[_c('label',[_vm._v("Item "+_vm._s(item))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("For:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox-group',{attrs:{"options":_vm.optionsForRemoveUrl,"value-field":"item","text-field":"name"},model:{value:(_vm.selectedUrlForRemove[item - 1]),callback:function ($$v) {_vm.$set(_vm.selectedUrlForRemove, item - 1, $$v)},expression:"selectedUrlForRemove[item - 1]"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Eliminar Item'),expression:"'Eliminar Item'",modifiers:{"hover":true,"right":true}}],attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeItemOfRemove(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),(_vm.addDivToRemoveQueries[item - 1])?_c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivToQueryOfRemove[item - 1]),function(id){return _c('div',{key:id,staticClass:"queryBorder"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Query:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-textarea',{attrs:{"placeholder":"Enter the query...","rows":"1","id":"text-area"},model:{value:(
                        _vm.toRemoveOptions[item - 1].queryToRemove[id - 1].query
                      ),callback:function ($$v) {_vm.$set(_vm.toRemoveOptions[item - 1].queryToRemove[id - 1], "query", $$v)},expression:"\n                        toRemoveOptions[item - 1].queryToRemove[id - 1].query\n                      "}})],1),_vm._v(" "),(id > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeRemoveQueryUrl(item - 1, id - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("Parcial Url:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},on:{"change":function($event){_vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                          .isRemoved == false
                          ? (_vm.toRemoveOptions[item - 1].queryToRemove[
                              id - 1
                            ].isRemoved = true)
                          : (_vm.toRemoveOptions[item - 1].queryToRemove[
                              id - 1
                            ].isRemoved = false);
                        _vm.$forceUpdate();}},model:{value:(_vm.isPartialQueryRemove[item - 1][id - 1]),callback:function ($$v) {_vm.$set(_vm.isPartialQueryRemove[item - 1], id - 1, $$v)},expression:"isPartialQueryRemove[item - 1][id - 1]"}})],1)],1),_vm._v(" "),(
                    _vm.toRemoveOptions[item - 1].queryToRemove[id - 1].isRemoved
                  )?_c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("To Replace:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(
                          _vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                            .toReplace
                        ),callback:function ($$v) {_vm.$set(_vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                            , "toReplace", $$v)},expression:"\n                          toRemoveOptions[item - 1].queryToRemove[id - 1]\n                            .toReplace\n                        "}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("Prepare QS:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-checkbox',{attrs:{"value":"true","unchecked-value":"false"},model:{value:(
                          _vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                            .prepateQs
                        ),callback:function ($$v) {_vm.$set(_vm.toRemoveOptions[item - 1].queryToRemove[id - 1]
                            , "prepateQs", $$v)},expression:"\n                          toRemoveOptions[item - 1].queryToRemove[id - 1]\n                            .prepateQs\n                        "}})],1)],1)],1):_vm._e()],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addQueryForRemove(_vm.addDivToQueryOfRemove[item - 1], item)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("URL:")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(_vm.toRemoveOptions[item - 1].urlToRemove),callback:function ($$v) {_vm.$set(_vm.toRemoveOptions[item - 1], "urlToRemove", $$v)},expression:"toRemoveOptions[item - 1].urlToRemove"}})],1)],1)],1):_vm._e()],1)}),_vm._v(" "),(_vm.addDivToRemoveQueries[0])?_c('b-row',{staticStyle:{"margin-top":"5px"}},[_c('b-col',{attrs:{"sm":"11 text-right"}},[(_vm.isSimple)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Novo Item'),expression:"'Novo Item'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){_vm.addDivForItemToRemove(_vm.addDivToRemove);
              _vm.toRemoveAddQueries(_vm.addDivToRemove);
              _vm.$forceUpdate();}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isSimple == false)?_c('div',{staticClass:"isSimple"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',[_c('b-form-textarea',{attrs:{"id":"textarea-large","rows":"12","size":"sm"},model:{value:(_vm.advancedXML),callback:function ($$v) {_vm.advancedXML=$$v},expression:"advancedXML"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isNotSearchEngine)?_c('b-button',{staticClass:"advance",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.advancedMode(_vm.isSimple)}}},[_vm._v("Advanced Mode")]):_vm._e()],1),_vm._v(" "),_c('b-modal',{attrs:{"scrollable":"","id":"createXml2","size":"xl","title":"Configuraçao XML2"},on:{"cancel":_vm.resetFields,"ok":_vm.createXml2}},[(_vm.isSimple2)?_c('div',{staticClass:"isSimple2"},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Title")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivTitle),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.titleArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.titleArray[item - 1], "query", $$v)},expression:"titleArray[item - 1].query"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeTitleDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.titleArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.titleArray[item - 1], "confidenceLevel", $$v)},expression:"titleArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addTitleDiv(_vm.addDivTitle)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Resume")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivResume),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.resumeArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.resumeArray[item - 1], "query", $$v)},expression:"resumeArray[item - 1].query"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeResumeDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.resumeArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.resumeArray[item - 1], "confidenceLevel", $$v)},expression:"resumeArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addResumeDiv(_vm.addDivResume)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Image")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},[_vm._l((_vm.addDivImage),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.imageArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "query", $$v)},expression:"imageArray[item - 1].query"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeImageDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"options":_vm.priorityOptions},model:{value:(_vm.imageArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "confidenceLevel", $$v)},expression:"imageArray[item - 1].confidenceLevel"}})],1)],1),_vm._v(" "),(item > 1)?_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Partial Url:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},on:{"change":function($event){_vm.imageArray[item - 1].isPartial == '0'
                      ? (_vm.imageArray[item - 1].isPartial = '1')
                      : (_vm.imageArray[item - 1].isPartial = '0');
                    _vm.$forceUpdate();}},model:{value:(_vm.imageArray[item - 1].isPartial),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "isPartial", $$v)},expression:"imageArray[item - 1].isPartial"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.imageArray[item - 1].isPartial == '1')?_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("To Replace:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"To replace in url query"},model:{value:(_vm.imageArray[item - 1].toReplace),callback:function ($$v) {_vm.$set(_vm.imageArray[item - 1], "toReplace", $$v)},expression:"imageArray[item - 1].toReplace"}})],1)],1):_vm._e()],1)}),_vm._v(" "),_c('b-row',{staticStyle:{"margin-bottom":"10px"}},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Url:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"URL QUERY"},model:{value:(_vm.imageArrayUrl),callback:function ($$v) {_vm.imageArrayUrl=$$v},expression:"imageArrayUrl"}})],1)],1)],2),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addImageDiv(_vm.addDivImage)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Text")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivText),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.textArray[item - 1].query),callback:function ($$v) {_vm.$set(_vm.textArray[item - 1], "query", $$v)},expression:"textArray[item - 1].query"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeTextDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Confidence:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"options":_vm.confidenceOptions},model:{value:(_vm.textArray[item - 1].confidenceLevel),callback:function ($$v) {_vm.$set(_vm.textArray[item - 1], "confidenceLevel", $$v)},expression:"textArray[item - 1].confidenceLevel"}})],1)],1)],1)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addTextDiv(_vm.addDivText)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('label',[_vm._v("Remove")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"11"}},_vm._l((_vm.addDivRemove),function(item){return _c('div',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"input-small"}},[_vm._v("Reference :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-select',{attrs:{"options":_vm.removeOptions},model:{value:(_vm.removeArray[item - 1].reference),callback:function ($$v) {_vm.$set(_vm.removeArray[item - 1], "reference", $$v)},expression:"removeArray[item - 1].reference"}})],1),_vm._v(" "),(item > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeRemoveDiv(item - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.addQueryToRemove[item - 1]),function(idQuery){return _c('div',{key:idQuery},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("XPATH:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the query"},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.removeArray[item - 1].queries[idQuery - 1].query),callback:function ($$v) {_vm.$set(_vm.removeArray[item - 1].queries[idQuery - 1], "query", $$v)},expression:"removeArray[item - 1].queries[idQuery - 1].query"}})],1),_vm._v(" "),(idQuery > 1)?_c('b-col',{staticClass:"align-self-end",attrs:{"sm":"1"}},[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.removeRemoveQueries(item - 1, idQuery - 1)}}},[_c('fa',{attrs:{"icon":"minus","size":"sm"}})],1)],1):_vm._e()],1)],1)}),_vm._v(" "),_c('b-col',[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Nova Query'),expression:"'Nova Query'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addRemoveDivQuery(_vm.addQueryToRemove[item - 1], item)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],2)}),0),_vm._v(" "),_c('b-col',{attrs:{"sm":"1; align-self-center"}},[(_vm.isSimple2)?_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Novo Item'),expression:"'Novo Item'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.addRemoveDiv(_vm.addDivRemove)}}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isSimple2 == false)?_c('div',{staticClass:"isSimple2"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',[_c('b-form-textarea',{attrs:{"id":"textarea-large","rows":"12","size":"sm"},model:{value:(_vm.advancedXML2),callback:function ($$v) {_vm.advancedXML2=$$v},expression:"advancedXML2"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"advance2",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.advancedMode2(_vm.isSimple2)}}},[_vm._v("Advanced Mode")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_generator__ = __webpack_require__("qe0n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_lodash__ = __webpack_require__("dxK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fortawesome_free_brands_svg_icons__ = __webpack_require__("DfMW");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["a" /* faTrash */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["b" /* faEdit */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["c" /* faPlus */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["d" /* faMinus */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["e" /* faClipboardCheck */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["f" /* faUpload */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["g" /* faTimesCircle */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["h" /* faCheckCircle */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["i" /* faTimes */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["j" /* faSearchPlus */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["k" /* faSearchMinus */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_13__fortawesome_free_brands_svg_icons__["a" /* faAdn */]);
__WEBPACK_IMPORTED_MODULE_10__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_12__fortawesome_free_solid_svg_icons__["l" /* faExclamationTriangle */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_form_generator___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__helpers_lodash__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('fa', __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	router: __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]);
	}
}).$mount('#app');

/***/ }),

/***/ "P9l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ajax__ = __webpack_require__("ov6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_auth__ = __webpack_require__("+bwR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_data__ = __webpack_require__("1HPF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);











/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        Vue.prototype.$api = {

            auth: __WEBPACK_IMPORTED_MODULE_6__auth_auth__["a" /* default */],

            data: __WEBPACK_IMPORTED_MODULE_7__data_data__["a" /* default */],

            _get: function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(endpoint) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
                                        type: 'GET',
                                        contentType: "application/json; charset=utf-8",
                                        cache: false,
                                        url: '' + __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['api/fullUrl'] + endpoint,
                                        dataType: "json"
                                    });

                                case 2:
                                    return _context.abrupt('return', _context.sent);

                                case 3:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function _get(_x) {
                    return _ref.apply(this, arguments);
                }

                return _get;
            }(),

            _post: function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(endpoint, payload) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
                                        type: 'POST',
                                        contentType: "application/json; charset=utf-8",
                                        cache: false,
                                        url: '' + __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['api/fullUrl'] + endpoint,
                                        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
                                        dataType: "json"
                                    });

                                case 2:
                                    return _context2.abrupt('return', _context2.sent);

                                case 3:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));

                function _post(_x2, _x3) {
                    return _ref2.apply(this, arguments);
                }

                return _post;
            }(),

            _post2: function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(endpoint, payload) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
                                        type: 'POST',
                                        contentType: "application/json; charset=utf-8",
                                        cache: false,
                                        url: '' + __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['api/fullUrl'] + endpoint,
                                        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
                                    });

                                case 2:
                                    return _context3.abrupt('return', _context3.sent);

                                case 3:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function _post2(_x4, _x5) {
                    return _ref3.apply(this, arguments);
                }

                return _post2;
            }(),

            _patch: function () {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(endpoint, payload) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
                                        type: 'PATCH',
                                        contentType: "application/json; charset=utf-8",
                                        cache: false,
                                        url: '' + __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['api/fullUrl'] + endpoint,
                                        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
                                        dataType: "json"
                                    }));

                                case 1:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, this);
                }));

                function _patch(_x6, _x7) {
                    return _ref4.apply(this, arguments);
                }

                return _patch;
            }(),

            _delete: function () {
                var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(endpoint) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
                                        type: 'DELETE',
                                        contentType: "application/json; charset=utf-8",
                                        cache: false,
                                        url: '' + __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['api/fullUrl'] + endpoint,
                                        dataType: "json"
                                    });

                                case 1:
                                case 'end':
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, this);
                }));

                function _delete(_x8) {
                    return _ref5.apply(this, arguments);
                }

                return _delete;
            }(),

            uploadImage: function () {
                var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(endpoint, payload) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                        while (1) {
                            switch (_context6.prev = _context6.next) {
                                case 0:
                                    return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
                                        url: '' + __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['api/fullUrl'] + endpoint,
                                        data: payload,
                                        processData: false,
                                        contentType: false,
                                        type: "PATCH"
                                    }));

                                case 1:
                                case 'end':
                                    return _context6.stop();
                            }
                        }
                    }, _callee6, this);
                }));

                function uploadImage(_x9, _x10) {
                    return _ref6.apply(this, arguments);
                }

                return uploadImage;
            }(),

            login: function () {
                var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(credentials) {
                    var login;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                        while (1) {
                            switch (_context7.prev = _context7.next) {
                                case 0:
                                    _context7.next = 2;
                                    return this._post('Users', credentials);

                                case 2:
                                    login = _context7.sent;

                                case 3:
                                case 'end':
                                    return _context7.stop();
                            }
                        }
                    }, _callee7, this);
                }));

                function login(_x11) {
                    return _ref7.apply(this, arguments);
                }

                return login;
            }(),

            logout: function () {
                var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                        while (1) {
                            switch (_context8.prev = _context8.next) {
                                case 0:
                                    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('auth/logout');

                                case 1:
                                case 'end':
                                    return _context8.stop();
                            }
                        }
                    }, _callee8, this);
                }));

                function logout() {
                    return _ref8.apply(this, arguments);
                }

                return logout;
            }()

        };
    }
});

/***/ }),

/***/ "PaoK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EditUrl",

  data: function data() {
    return {
      clicked: 0,
      endpoint: "Sources",
      sourceToEdit: [],
      addDivTitle: 1,
      addDivResume: 1,
      addDivImage: 1,
      addDivText: 1,
      addDivRemove: 1,
      addDivPartialUrl: 1,
      addDivNotFullUrl: [false],
      addDivToRemoveQueries: [false],
      addDivToQueryOfRemove: [1],
      addQueryToRemove: [1],
      addDivToQuery: [1],
      addDivToRemove: 1,
      optionsForRemoveUrl: [],
      selectedUrlForRemove: [[]],
      optionsForUrl: [],
      selectedUrlForExtract: [],
      isSimple: true,
      isSimple2: true,
      disabled: true,
      editedConvertedXML1: [],
      editedConvertedXML2: [],
      lo: _,
      document: __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document),
      urlParameters1: "",
      advancedXML: "",
      advancedXML2: "",
      urlArray: [{
        url: "",
        priority: 0
      }],
      toReplaceOptions: [{
        toReplace: "",
        queryToReplace: [{
          query: "",
          toReplace: "",
          prepateQs: false,
          isPartial: false
        }],
        urlToReplace: ""
      }],
      toRemoveOptions: [{
        queryToRemove: [{
          query: "",
          toReplace: "",
          prepateQs: false,
          isRemoved: false
        }],
        urlToRemove: ""
      }],
      titleArray: [{
        query: "",
        confidenceLevel: 0
      }],
      resumeArray: [{
        query: "",
        confidenceLevel: 0
      }],
      imageArray: [{
        query: "",
        confidenceLevel: 0,
        isPartial: 0,
        toReplace: ""
      }],
      imageArrayUrl: "",
      textArray: [{
        query: "",
        confidenceLevel: 0
      }],
      removeArray: [{
        reference: 0,
        queries: [{ query: "" }]
      }],
      SourceUrl: {
        c_id: 0,
        c_u_Type: 1,
        c_u_Status: 0,
        c_u_Regularity: 0,
        c_u_ReferenceSource: "",
        c_u_Keywords: "",
        c_u_Parameters1: "",
        c_u_Parameters2: ""
      },
      priorityOptions: [{ value: "0", text: "Please select a priority" }, { value: "30", text: "High" }, { value: "20", text: "Medium" }, { value: "10", text: "Low" }],
      statusOptions: [{ value: "0", text: "Please select a status" }, { value: "1", text: "Enabled" }, { value: "2", text: "Disabled" }],
      confidenceOptions: [{ value: "0", text: "Please select a priority" }, { value: "30", text: "High" }, { value: "20", text: "Medium" }, { value: "10", text: "Low" }],
      regularityOptions: [{ value: "0", text: "Please select a regularity" }, { value: "10", text: "10 Minutos" }, { value: "20", text: "20 Minutos" }, { value: "30", text: "30 Minutos" }, { value: "40", text: "40 Minutos" }, { value: "50", text: "50 Minutos" }, { value: "60", text: "60 Minutos" }],
      removeOptions: [{ value: "0", text: "Please select a Reference" }, { value: "title", text: "Title" }, { value: "resume", text: "Resume" }, { value: "image", text: "Image" }, { value: "text", text: "Text" }]
    };
  },


  props: {
    idSource: Number
  },

  components: {},
  watch: {
    selectedUrlForExtract: function selectedUrlForExtract(newVal, oldVal) {
      if (newVal[0] != null) {
        if (this.addDivNotFullUrl[this.addDivPartialUrl - 1] == undefined) {
          this.addDivNotFullUrl[this.addDivPartialUrl - 1] = true;
        }
        if (this.addDivNotFullUrl[this.addDivPartialUrl - 1] != undefined) {
          this.addDivNotFullUrl[this.addDivPartialUrl - 1] = true;
        }
        if (newVal[this.addDivPartialUrl - 1].length == 0) {
          this.addDivNotFullUrl[this.addDivPartialUrl - 1] = false;
        }
      }
    },
    selectedUrlForRemove: function selectedUrlForRemove(newVal, oldVal) {
      if (newVal[0] != null) {
        if (this.addDivToRemoveQueries[this.addDivToRemove - 1] == undefined) {
          this.addDivToRemoveQueries[this.addDivToRemove - 1] = true;
        }
        if (this.addDivToRemoveQueries[this.addDivToRemove - 1] != undefined) {
          this.addDivToRemoveQueries[this.addDivToRemove - 1] = true;
        }
        if (newVal[this.addDivToRemove - 1].length == 0) {
          this.addDivToRemoveQueries[this.addDivToRemove - 1] = false;
          this.toRemoveOptions.splice(this.addDivToRemove - 1, 1);
          this.addDivToQueryOfRemove.splice(this.addDivToRemove - 1, 1);
          this.addDivToRemove = this.addDivToRemove - 1;
        }
      }
    }
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var parseString, xml1, convertedXml, xml2, convertedXml2, index, arrayOfStringToNumber, i, f, StringToNumberRemove, _i, _f, btn, _i2, k;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //clear the data in cache
                _this.addDivTitle = 1, _this.addDivResume = 1, _this.addDivImage = 1, _this.addDivText = 1, _this.addDivRemove = 1, _this.addQueryToRemove = [1], _this.titleArray = [{
                  query: "",
                  confidenceLevel: 0
                }], _this.resumeArray = [{
                  query: "",
                  confidenceLevel: 0
                }], _this.imageArray = [{
                  query: "",
                  confidenceLevel: 0,
                  isPartial: 0,
                  toReplace: ""
                }], _this.imageArrayUrl = "", _this.textArray = [{
                  query: "",
                  confidenceLevel: 0
                }], _this.removeArray = [{
                  reference: 0,
                  queries: [{ query: "" }]
                }];
                // parse xml to json
                _this.$api.data.endpoint = _this.endpoint;
                _context.next = 4;
                return _this.$api.data.findOneById(_this.idSource);

              case 4:
                _this.sourceToEdit = _context.sent;
                parseString = __webpack_require__("XWX1").parseString;
                xml1 = _this.sourceToEdit.c_u_Parameters1;

                if (xml1.trim().length == 0) {
                  xml1 = '<?xml version="1.0" encoding="UTF-8"?><Configuration For="List"><URLs><URL Id="1" Priority="30">https://www.exemplo.pt/</URL></URLs><ToExtract><Item ForURLsId="1"><Queries><Query Id="1" ConfidenceLevel="20" IsURL="true" IsFullURL="true" ToReplace="" PrepareTextForQS="false">//div[@class=\'exemplo\']/a/@href</Query></Queries><URL></URL></Item></ToExtract><ToRemove/></Configuration>';
                }
                convertedXml = [];

                parseString(xml1, function (err, result) {
                  convertedXml.push(result);
                });
                _this.editedConvertedXML1 = convertedXml;

                xml2 = _this.sourceToEdit.c_u_Parameters2;

                if (xml2.trim().length == 0) {
                  xml2 = '<?xml version="1.0" encoding="UTF-8"?><Configuration For="News"><URLs></URLs><ToExtract><Item ForURLsID="" Reference="title"><Queries><Query Id="1" ConfidenceLevel="20" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">//title</Query><Query Id="2" ConfidenceLevel="30" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">//meta[@property=\'og:title\']/@content</Query></Queries><URL></URL></Item><Item ForURLsID="" Reference="resume"><Queries><Query Id="1" ConfidenceLevel="30" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">//meta[@property=\'og:description\']/@content</Query></Queries><URL></URL></Item><Item ForURLsID="" Reference="image"><Queries><Query Id="1" ConfidenceLevel="30" IsURL="true" IsFullURL="true" ToReplace="" PrepareTextForQS="false">//meta[@property=\'og:image\']/@content</Query></Queries><URL></URL></Item><Item ForURLsID="" Reference="text"><Queries><Query Id="1" ConfidenceLevel="10" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">//div[@class=\'exemplo\']/*[self::p]</Query></Queries><URL></URL></Item></ToExtract><ToRemove><Item ForURLsId="" Reference="0"><Queries></Queries></Item></ToRemove></Configuration>';
                }
                convertedXml2 = [];

                parseString(xml2, function (err, result) {
                  convertedXml2.push(result);
                });
                _this.editedConvertedXML2 = convertedXml2;

                // this.SourceUrl.c_u_ReferenceSource = this.sourceToEdit.c_u_ReferenceSource;
                // this.SourceUrl.c_u_Status = this.sourceToEdit.c_u_Status;
                // this.SourceUrl.c_u_Keywords = this.sourceToEdit.c_u_Keywords;
                // this.SourceUrl.c_u_Regularity = this.sourceToEdit.c_u_Regularity;
                _this.SourceUrl.c_id = _this.sourceToEdit.c_id;
                if (_this.sourceToEdit.c_u_Type != 3) {
                  // parse XML parameters1 to json reference to url
                  for (index = 0; index < convertedXml[0].Configuration.URLs[0].URL.length; index++) {
                    if (_.findIndex(_this.optionsForUrl, function (o) {
                      return o.item == index;
                    }) === -1) {
                      _this.optionsForUrl.push({ item: index, name: "URL" + (index + 1) }); // creates the checkbox's options with url name
                      _this.optionsForRemoveUrl.push({
                        item: index,
                        name: "URL" + (index + 1)
                      }); //creates the objects for the options of ToRemove
                    }
                    if (_this.urlArray[index]) {
                      _this.urlArray[index].url = /\s/g.test(convertedXml[0].Configuration.URLs[0].URL[index]._) ? convertedXml[0].Configuration.URLs[0].URL[index]._.replace(/\s/g, "") : convertedXml[0].Configuration.URLs[0].URL[index]._;
                      _this.urlArray[index].priority = convertedXml[0].Configuration.URLs[0].URL[index].$.Priority;
                    }
                    if (!_this.urlArray[index]) {
                      _this.urlArray.push({
                        url: /\s/g.test(convertedXml[0].Configuration.URLs[0].URL[index]._) ? convertedXml[0].Configuration.URLs[0].URL[index]._.replace(/\s/g, "") : convertedXml[0].Configuration.URLs[0].URL[index]._,
                        priority: convertedXml[0].Configuration.URLs[0].URL[index].$.Priority
                      });
                    }
                  }
                  arrayOfStringToNumber = [];

                  _this.addDivPartialUrl = convertedXml[0].Configuration.ToExtract[0].Item.length;
                  // To open the block of TO EXTRACT
                  for (index = 0; index < convertedXml[0].Configuration.ToExtract[0].Item.length; index++) {
                    _this.addDivNotFullUrl[index] = true;
                    arrayOfStringToNumber.push(convertedXml[0].Configuration.ToExtract[0].Item[index].$.ForURLsId.split(","));
                  }

                  // 2º for to add information to the inputs and checkbox's
                  for (index = 0; index < arrayOfStringToNumber.length; index++) {
                    _this.toReplaceOptions[index] = {
                      toReplace: "",
                      queryToReplace: [],
                      urlToReplace: convertedXml[0].Configuration.ToExtract[0].Item[index].URL[0]
                    };
                    _this.selectedUrlForExtract[index] = [];
                    for (i = 0; i < arrayOfStringToNumber[index].length; i++) {
                      _this.selectedUrlForExtract[index].push(parseInt(arrayOfStringToNumber[index][i]) - 1);
                    }

                    _this.addDivToQuery[index] = convertedXml[0].Configuration.ToExtract[0].Item[index].Queries[0].Query.length;
                    for (f = 0; f < convertedXml[0].Configuration.ToExtract[0].Item[index].Queries[0].Query.length; f++) {
                      _this.toReplaceOptions[index].queryToReplace[f] = {
                        query: convertedXml[0].Configuration.ToExtract[0].Item[index].Queries[0].Query[f]._,
                        toReplace: convertedXml[0].Configuration.ToExtract[0].Item[index].Queries[0].Query[f].$.ToReplace,
                        prepateQs: convertedXml[0].Configuration.ToExtract[0].Item[index].Queries[0].Query[f].$.PrepareTextForQS,
                        isPartial: convertedXml[0].Configuration.ToExtract[0].Item[index].Queries[0].Query[f].$.ToReplace == "" ? false : true
                      };
                    }
                  }

                  try {
                    // items for the toRemove Divs's
                    convertedXml[0].Configuration.ToRemove[0] = /[^&crarr;]/.test(convertedXml[0].Configuration.ToRemove[0]) ? "" : convertedXml[0].Configuration.ToRemove[0];

                    if (convertedXml[0].Configuration.ToRemove[0] != "" || convertedXml[0].Configuration.ToRemove[0] != []) {
                      StringToNumberRemove = [];

                      _this.addDivToRemove = convertedXml[0].Configuration.ToRemove[0].Item.length;
                      for (index = 0; index < convertedXml[0].Configuration.ToRemove[0].Item.length; index++) {
                        _this.addDivToRemoveQueries[index] = true;
                        StringToNumberRemove.push(convertedXml[0].Configuration.ToRemove[0].Item[index].$.ForURLsId.split(","));
                      }
                      for (index = 0; index < StringToNumberRemove.length; index++) {
                        _this.toRemoveOptions[index] = {
                          toReplace: "",
                          queryToRemove: [],
                          urlToRemove: convertedXml[0].Configuration.ToRemove[0].Item[index].URL[0]
                        };
                        _this.selectedUrlForRemove[index] = [];
                        for (_i = 0; _i < StringToNumberRemove[index].length; _i++) {
                          _this.selectedUrlForRemove[index].push(parseInt(StringToNumberRemove[index][_i]) - 1);
                        }

                        _this.addDivToQueryOfRemove[index] = convertedXml[0].Configuration.ToRemove[0].Item[index].Queries[0].Query.length;
                        for (_f = 0; _f < convertedXml[0].Configuration.ToRemove[0].Item[index].Queries[0].Query.length; _f++) {
                          _this.toRemoveOptions[index].queryToRemove[_f] = {
                            query: convertedXml[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[_f]._,
                            toReplace: convertedXml[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[_f].$.ToReplace,
                            prepateQs: convertedXml[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[_f].$.prepateQs,
                            isRemoved: convertedXml[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[_f].$.ToReplace == "" ? false : true
                          };
                        }
                      }
                    }
                    _this.clicked = convertedXml[0].Configuration.URLs[0].URL.length;
                  } catch (err) {}
                } else {
                  btn = document.getElementById("advancedBtn");

                  if (btn != null) {
                    btn.remove();
                  }
                  _this.isSimple = false;
                  _this.advancedXML = _this.sourceToEdit.c_u_Parameters1;
                }
                // parse xml2 to json reference to title
                for (index = 0; index < convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query.length; index++) {
                  if (_this.titleArray[index]) {
                    _this.titleArray[index].query = /\s/g.test(convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index]._) ? convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index]._;
                    _this.titleArray[index].confidenceLevel = convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index].$.ConfidenceLevel;
                  }
                  if (!_this.titleArray[index]) {
                    _this.titleArray.push({
                      query: /\s/g.test(convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index]._) ? convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index]._,
                      confidenceLevel: convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index].$.ConfidenceLevel
                    });
                  }
                }
                _this.addDivTitle = convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query.length;

                // parse xml2 to json reference to resume
                for (index = 0; index < convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query.length; index++) {
                  if (_this.resumeArray[index]) {
                    _this.resumeArray[index].query = /\s/g.test(convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index]._) ? convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index]._;
                    _this.resumeArray[index].confidenceLevel = convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index].$.ConfidenceLevel;
                  }
                  if (!_this.resumeArray[index]) {
                    _this.resumeArray.push({
                      query: /\s/g.test(convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index]._) ? convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index]._,
                      confidenceLevel: convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index].$.ConfidenceLevel
                    });
                  }
                }
                _this.addDivResume = convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query.length;
                //parse xml2 to json reference to image
                for (index = 0; index < convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query.length; index++) {
                  if (_this.imageArray[index]) {
                    _this.imageArray[index].query = /\s/g.test(convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index]._) ? convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index]._;
                    _this.imageArray[index].confidenceLevel = convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index].$.ConfidenceLevel;
                  }
                  if (!_this.imageArray[index]) {
                    _this.imageArray.push({
                      toReplace: convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index].$.ToReplace != "" ? convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index].$.ToReplace : "",
                      isPartial: convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index].$.ToReplace != "" ? "1" : "0",
                      query: /\s/g.test(convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index]._) ? convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index]._,
                      confidenceLevel: convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[index].$.ConfidenceLevel
                    });
                  }
                }
                _this.imageArrayUrl = convertedXml2[0].Configuration.ToExtract[0].Item[2].URL[0];
                _this.addDivImage = convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query.length;

                //parse xml2 to json reference to text
                for (index = 0; index < convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query.length; index++) {
                  if (_this.textArray[index]) {
                    _this.textArray[index].query = /\s/g.test(convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index]._) ? convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index]._;
                    _this.textArray[index].confidenceLevel = convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index].$.ConfidenceLevel;
                  }
                  if (!_this.textArray[index]) {
                    _this.textArray.push({
                      query: /\s/g.test(convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index]._) ? convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index]._,
                      confidenceLevel: convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index].$.ConfidenceLevel
                    });
                  }
                }
                _this.addDivText = convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query.length;

                try {
                  // parse xml2 to json reference to Remove
                  if (convertedXml2[0].Configuration.ToRemove[0]) {
                    for (index = 0; index < convertedXml2[0].Configuration.ToRemove[0].Item.length; index++) {
                      if (_this.removeArray[index]) {
                        _this.removeArray[index].reference = convertedXml2[0].Configuration.ToRemove[0].Item[index].$.Reference;
                        for (_i2 = 0; _i2 < convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query.length; _i2++) {
                          _this.removeArray[index].queries.splice(_i2, 0, {
                            query: /\s/g.test(convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[_i2]._) ? convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[_i2]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[_i2]._
                          });
                          _.remove(_this.removeArray[index].queries, function (n) {
                            return n.query == "";
                          });
                          _this.addQueryToRemove[index] = convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query.length;
                        }
                      }
                      if (!_this.removeArray[index]) {
                        _this.removeArray.splice(index, 0, {
                          reference: convertedXml2[0].Configuration.ToRemove[0].Item[index].$.Reference
                        });
                        for (k = 0; k < convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query.length; k++) {
                          _this.removeArray[index].queries.splice(k, 0, {
                            query: /\s/g.test(convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[k]._) ? convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[k]._.replace(/\s/g, " ") : convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query[k]._
                          });
                          _.remove(_this.removeArray[index].queries, function (n) {
                            return n.query == "";
                          });
                          _this.addQueryToRemove[index] = convertedXml2[0].Configuration.ToRemove[0].Item[index].Queries[0].Query.length;
                        }
                      }
                    }
                  }
                  _this.addDivRemove = convertedXml2[0].Configuration.ToRemove[0].Item.length;
                } catch (err) {}

                _this.$forceUpdate();

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    semicolonKey: function semicolonKey(event) {
      if (event.key != undefined) {
        if (event.keyCode == 32) {
          this.SourceUrl.c_u_Keywords = this.SourceUrl.c_u_Keywords.replace(/\s/g, "") + ";";
        }
      }
    },
    resetFields: function resetFields() {
      this.clicked = 0;
      this.sourceToEdit = [], this.addDivTitle = 1, this.addDivResume = 1, this.addDivImage = 1, this.addDivText = 1, this.addDivRemove = 1, this.addDivPartialUrl = 1, this.addDivNotFullUrl = [false], this.addDivToRemoveQueries = [false], this.addDivToQueryOfRemove = [1], this.addDivToQuery = [1], this.addDivToRemove = 1, this.optionsForRemoveUrl = [], this.selectedUrlForRemove = [[]], this.addQueryToRemove = [1];
      this.optionsForUrl = [], this.selectedUrlForExtract = [], this.isSimple = true, this.isSimple2 = true, this.advancedXML = "", this.advancedXML2 = "", this.urlArray = [{
        url: "",
        priority: 0
      }], this.toReplaceOptions = [{
        toReplace: "",
        queryToReplace: [{
          query: "",
          toReplace: "",
          prepateQs: false,
          isPartial: false
        }],
        urlToReplace: ""
      }], this.toRemoveOptions = [{
        queryToRemove: [{
          query: "",
          toReplace: "",
          prepateQs: false,
          isRemoved: false
        }],
        urlToRemove: ""
      }];
      this.titleArray = [{
        query: "",
        confidenceLevel: 0
      }], this.resumeArray = [{
        query: "",
        confidenceLevel: 0
      }], this.imageArray = [{
        query: "",
        confidenceLevel: 0,
        isPartial: 0,
        toReplace: ""
      }], this.imageArrayUrl = "", this.textArray = [{
        query: "",
        confidenceLevel: 0
      }], this.removeArray = [{
        reference: 0,
        queries: [{ query: "" }]
      }];
      this.$forceUpdate();
    },
    createXml2: function createXml2(evt) {
      if (this.isSimple2) {
        var xml = __webpack_require__("K7uN");
        var xml2 = [{
          Configuration: [{ _attr: { For: "News" } }, { URLs: "" }, {
            ToExtract: [{
              Item: [{ _attr: { ForURLsID: "", Reference: "title" } }, { Queries: [] }, { URL: [] }]
            }, {
              Item: [{ _attr: { ForURLsID: "", Reference: "resume" } }, { Queries: [] }, { URL: [] }]
            }, {
              Item: [{ _attr: { ForURLsID: "", Reference: "image" } }, { Queries: [] }, { URL: [] }]
            }, {
              Item: [{ _attr: { ForURLsID: "", Reference: "text" } }, { Queries: [] }, { URL: [] }]
            }]
          }, { ToRemove: [] }]
        }];

        //for loop to create the queries of title in the xml
        for (var index = 0; index < this.titleArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[0].Item[1].Queries.push({
            Query: [{
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.titleArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index] != undefined ? this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[index].$.ToReplace : "",
                PrepareTextForQS: "false"
              }
            }, this.titleArray[index].query]
          });
        }

        xml2[0].Configuration[2].ToExtract[0].Item[2].URL = this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[0].URL;
        //for loop to create the queries of resume in the xml
        for (var index = 0; index < this.resumeArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[1].Item[1].Queries.push({
            Query: [{
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.resumeArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index] != undefined ? this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[index].$.ToReplace : "",
                PrepareTextForQS: "false"
              }
            }, this.resumeArray[index].query]
          });
        }
        xml2[0].Configuration[2].ToExtract[1].Item[2].URL = this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[1].URL;

        //for loop to create the queries of image in the xml
        for (var index = 0; index < this.imageArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[2].Item[1].Queries.push({
            Query: [{
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.imageArray[index].confidenceLevel,
                IsURL: "true",
                IsFullURL: this.imageArray[index].isPartial == "1" ? "false" : "true",
                ToReplace: this.imageArray[index].isPartial == "1" ? this.imageArray[index].toReplace : "",
                PrepareTextForQS: "false"
              }
            }, this.imageArray[index].query]
          });
          if (this.imageArray[index].isPartial == "1") {
            xml2[0].Configuration[2].ToExtract[2].Item[2].URL = this.imageArrayUrl;
          } else {
            xml2[0].Configuration[2].ToExtract[2].Item[2].URL = "";
          }
        }

        //for loop to create the queries of text in the xml
        for (var index = 0; index < this.textArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[3].Item[1].Queries.push({
            Query: [{
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.textArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index] != undefined ? this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[index].$.ToReplace : "",
                PrepareTextForQS: "false"
              }
            }, this.textArray[index].query]
          });
        }
        xml2[0].Configuration[2].ToExtract[3].Item[2].URL = this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[3].URL;
        // for loop to create the queries of remove in the xml
        for (var index = 0; index < this.removeArray.length; index++) {
          xml2[0].Configuration[3].ToRemove.push({
            Item: [{
              _attr: {
                ForURLsId: "",
                Reference: this.removeArray[index].reference
              }
            }, {
              Queries: []
            }]
          });
          for (var i = 0; i < this.removeArray[index].queries.length; i++) {
            xml2[0].Configuration[3].ToRemove[index].Item[1].Queries.push({
              Query: [{
                _attr: {
                  Id: i + 1,
                  ConfidenceLevel: 0,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace: "",
                  PrepareTextForQS: "false"
                }
              }, this.removeArray[index].queries[i].query]
            });
          }
          // remove if query its equal to ""
          _.remove(xml2[0].Configuration[3].ToRemove[index].Item[1].Queries, function (n) {
            return n.Query[1] == "";
          });
        }
        if (evt == undefined) {
          this.SourceUrl.c_u_Parameters2 = xml(xml2, {
            declaration: { version: "1.0", encoding: "UTF-8" },
            indent: true
          });
        } else {
          this.SourceUrl.c_u_Parameters2 = xml(xml2, {
            declaration: { version: "1.0", encoding: "UTF-8" }
          });
        }
      } else {
        this.SourceUrl.c_u_Parameters2 = this.advancedXML2;
      }
      this.$emit("ok", this.SourceUrl.c_u_Parameters1, this.SourceUrl.c_u_Parameters2);
    },
    createUrlSouce: function createUrlSouce(evt) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var xml, indexUrls, queryIndex, xml1, newArrayOfToExtract, stringOfUrls, index, i, u, arrayToRemoveItems, stringOfUrlsToRemove, _i3, _u;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.isSimple) {
                  // create the xml for the source
                  xml = __webpack_require__("K7uN");
                  indexUrls = [];
                  queryIndex = 1;
                  xml1 = [{
                    Configuration: [{ _attr: { For: "List" } }, { URLs: [] }, { ToExtract: [] }, { ToRemove: [] }]
                  }];
                  newArrayOfToExtract = [];
                  stringOfUrls = "";

                  for (index = 0; index < _this2.selectedUrlForExtract.length; index++) {
                    for (i = 0; i < _this2.selectedUrlForExtract[index].length; i++) {
                      _this2.selectedUrlForExtract[index][i] = _this2.selectedUrlForExtract[index][i] + 1;
                    }
                    _this2.selectedUrlForExtract[index].sort();
                    stringOfUrls = _this2.selectedUrlForExtract[index].join(",");
                    newArrayOfToExtract.push({
                      stringForUrlsId: stringOfUrls,
                      url: _this2.toReplaceOptions[index].urlToReplace,
                      query: _this2.toReplaceOptions[index].queryToReplace
                    });
                  }
                  for (index = 0; index < _this2.urlArray.length; index++) {
                    xml1[0].Configuration[1].URLs.push({
                      URL: [{
                        _attr: {
                          Id: index + 1,
                          Priority: _this2.urlArray[index].priority
                        }
                      }, _this2.urlArray[index].url]
                    });
                    indexUrls[index] = index + 1;
                  }
                  //For to create the items part of xml in toExtract
                  for (index = 0; index < newArrayOfToExtract.length; index++) {
                    xml1[0].Configuration[2].ToExtract.push({
                      Item: [{
                        _attr: {
                          ForURLsId: newArrayOfToExtract[index].stringForUrlsId
                        }
                      }, {
                        Queries: []
                      }, {
                        URL: newArrayOfToExtract[index].url
                      }]
                    });
                    //for to create the queries inside the items parts of xml in ToExtract
                    for (u = 0; u < newArrayOfToExtract[index].query.length; u++) {
                      xml1[0].Configuration[2].ToExtract[index].Item[1].Queries.push({
                        Query: [{
                          _attr: {
                            Id: u + 1,
                            ConfidenceLevel: "0",
                            IsURL: "true",
                            IsFullURL: newArrayOfToExtract[index].query[u].isPartial == true ? "false" : "true",
                            ToReplace: newArrayOfToExtract[index].query[u].toReplace != "" ? newArrayOfToExtract[index].query[u].toReplace.includes("#") ? newArrayOfToExtract[index].query[u].toReplace : "#" + newArrayOfToExtract[index].query[u].toReplace + "#" : "",
                            PrepareTextForQS: newArrayOfToExtract[index].query[u].prepateQs
                          }
                        }, _this2.sourceToEdit.c_u_Type != 2 ? newArrayOfToExtract[index].query[u].query.includes("/@href") ? newArrayOfToExtract[index].query[u].query : newArrayOfToExtract[index].query[u].query + "/@href" : newArrayOfToExtract[index].query[u].query]
                      });
                    }
                  }
                  // Block for the ToRemove
                  arrayToRemoveItems = [];
                  stringOfUrlsToRemove = "";
                  // to create the toRemove Items with queries

                  for (index = 0; index < _this2.selectedUrlForRemove.length; index++) {
                    if (_this2.selectedUrlForRemove[index].length >= 1) {
                      for (_i3 = 0; _i3 < _this2.selectedUrlForRemove[index].length; _i3++) {
                        _this2.selectedUrlForRemove[index][_i3] = _this2.selectedUrlForRemove[index][_i3] + 1;
                      }
                      _this2.selectedUrlForRemove[index].sort();
                      stringOfUrlsToRemove = _this2.selectedUrlForRemove[index].join(",");
                      arrayToRemoveItems.push({
                        stringForUrlsId: stringOfUrlsToRemove,
                        url: _this2.toRemoveOptions[index].urlToRemove,
                        query: _this2.toRemoveOptions[index].queryToRemove
                      });
                    }
                  }

                  if (arrayToRemoveItems != []) {
                    for (index = 0; index < arrayToRemoveItems.length; index++) {
                      xml1[0].Configuration[3].ToRemove.push({
                        Item: [{
                          _attr: {
                            ForURLsId: arrayToRemoveItems[index].stringForUrlsId
                          }
                        }, {
                          Queries: []
                        }, {
                          URL: arrayToRemoveItems[index].url
                        }]
                      });

                      for (_u = 0; _u < arrayToRemoveItems[index].query.length; _u++) {
                        xml1[0].Configuration[3].ToRemove[index].Item[1].Queries.push({
                          Query: [{
                            _attr: {
                              Id: _u + 1,
                              ConfidenceLevel: "0",
                              IsURL: "true",
                              IsFullURL: arrayToRemoveItems[index].query[_u].isRemoved == true ? "false" : "true",
                              ToReplace: arrayToRemoveItems[index].query[_u].toReplace != "" ? arrayToRemoveItems[index].query[_u].toReplace.includes("#") ? arrayToRemoveItems[index].query[_u].toReplace : "#" + arrayToRemoveItems[index].query[_u].toReplace + "#" : "",
                              PrepareTextForQS: arrayToRemoveItems[index].query[_u].prepateQs
                            }
                          }, _this2.sourceToEdit.c_u_Type != 2 ? arrayToRemoveItems[index].query[_u].query.includes("/@href") ? arrayToRemoveItems[index].query[_u].query : arrayToRemoveItems[index].query[_u].query + "/@href" : arrayToRemoveItems[index].query[_u].query]
                        });
                      }
                    }
                  }

                  if (evt == undefined) {
                    _this2.SourceUrl.c_u_Parameters1 = xml(xml1, {
                      declaration: { version: "1.0", encoding: "UTF-8" },
                      indent: true
                    });
                  } else {
                    _this2.SourceUrl.c_u_Parameters1 = xml(xml1, {
                      declaration: { version: "1.0", encoding: "UTF-8" }
                    });
                  }
                } else {
                  _this2.SourceUrl.c_u_Parameters1 = _this2.advancedXML;
                }
                // call the api
                // if(evt != undefined){
                //   await this.$api.data.updatedById(this.sourceToEdit.c_id, this.SourceUrl);
                _this2.$emit("ok", _this2.SourceUrl.c_u_Parameters1, _this2.SourceUrl.c_u_Parameters2);

                //}

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    addPartialUrlDiv: function addPartialUrlDiv(evt) {
      this.addDivPartialUrl++;
      if (this.toReplaceOptions[this.addDivPartialUrl - 1] == undefined) {
        this.toReplaceOptions[this.addDivPartialUrl - 1] = {
          toReplace: "",
          queryToReplace: [],
          urlToReplace: ""
        };
        this.toReplaceOptions[this.addDivPartialUrl - 1].queryToReplace[0] = {
          query: "",
          toReplace: "",
          prepateQs: false,
          isPartial: false
        };
        this.addDivToQuery[this.addDivPartialUrl - 1] = 1;
      }
      this.$forceUpdate();
    },
    addQueryForUrl: function addQueryForUrl(evt, item) {
      this.addDivToQuery[item - 1]++;
      this.toReplaceOptions[item - 1].queryToReplace[this.addDivToQuery[item - 1] - 1] = { query: "", toReplace: "", prepateQs: false, isPartial: false };
      this.$forceUpdate();
    },
    addQueryForRemove: function addQueryForRemove(evt, item) {
      this.addDivToQueryOfRemove[item - 1]++;
      this.toRemoveOptions[item - 1].queryToRemove[this.addDivToQueryOfRemove[item - 1] - 1] = { query: "", toReplace: "", prepateQs: false, isRemoved: false };
      this.$forceUpdate();
    },
    toRemoveAddQueries: function toRemoveAddQueries(item) {
      if (this.addDivToRemoveQueries[item - 1] == undefined) {
        this.addDivToRemoveQueries[item - 1] = false;
        this.addDivToQueryOfRemove[item - 1] = 1;
      }
      this.$forceUpdate();
    },
    addDivForItemToRemove: function addDivForItemToRemove() {
      this.addDivToRemove++;
      if (this.toRemoveOptions[this.addDivToRemove - 1] == undefined) {
        this.toRemoveOptions[this.addDivToRemove - 1] = {
          toReplace: "",
          queryToRemove: [],
          urlToReplace: ""
        };
        this.toRemoveOptions[this.addDivToRemove - 1].queryToRemove[0] = {
          query: "",
          toReplace: "",
          prepateQs: false,
          isRemoved: false
        };
        this.$forceUpdate();
      }
    },
    addTitleDiv: function addTitleDiv(evt) {
      this.addDivTitle++;
      this.titleArray[this.addDivTitle - 1] = { query: "", confidenceLevel: 0 };
    },
    addResumeDiv: function addResumeDiv(evt) {
      this.addDivResume++;
      this.resumeArray[this.addDivResume - 1] = {
        query: "",
        confidenceLevel: 0
      };
    },
    addImageDiv: function addImageDiv(evt) {
      this.addDivImage++;
      this.imageArray[this.addDivImage - 1] = {
        query: "",
        confidenceLevel: 0,
        isPartial: 0,
        toReplace: ""
      };
    },
    addTextDiv: function addTextDiv(evt) {
      this.addDivText++;
      this.textArray[this.addDivText - 1] = { query: "", confidenceLevel: 0 };
    },
    addUrlDiv: function addUrlDiv(evt) {
      this.clicked++;
      this.optionsForUrl.push({
        item: this.clicked - 1,
        name: "URL" + this.clicked
      });
      this.urlArray[this.clicked - 1] = { url: "", priority: 0 };
      this.$forceUpdate();
    },
    removeUrlDiv: function removeUrlDiv(evt) {
      this.urlArray.splice(evt, 1);
      this.optionsForUrl.splice(evt, 1);
      // for to remove the url if its already selected
      for (var index = 0; index < this.selectedUrlForExtract.length; index++) {
        _.remove(this.selectedUrlForExtract[index], function (id) {
          return id == evt;
        });
      }
      this.clicked--;
    },
    removeTitleDiv: function removeTitleDiv(evt) {
      this.titleArray.splice(evt, 1);
      this.addDivTitle--;
    },
    removeResumeDiv: function removeResumeDiv(evt) {
      this.resumeArray.splice(evt, 1);
      this.addDivResume--;
    },
    removeImageDiv: function removeImageDiv(evt) {
      if (this.imageArray[evt].isPartial == "1") {
        this.imageArrayUrl = "";
      }
      this.imageArray.splice(evt, 1);
      this.addDivImage--;
    },
    removeTextDiv: function removeTextDiv(evt) {
      this.textArray.splice(evt, 1);
      this.addDivText--;
    },
    removeItemfromUrl: function removeItemfromUrl(item) {
      this.addDivPartialUrl--;
      this.selectedUrlForExtract.splice(item, 1);
      this.toReplaceOptions.splice(item, 1);
      this.addDivToQuery.splice(item, 1);
      this.addDivNotFullUrl.splice(item, 1);
      this.$forceUpdate();
    },
    removeItemOfRemove: function removeItemOfRemove(item) {
      this.addDivToRemove--;
      this.addDivToRemoveQueries.splice(item, 1);
      this.selectedUrlForRemove.splice(item, 1);
      this.toRemoveOptions.splice(item, 1);
      this.$forceUpdate();
    },
    removeRemoveQueryUrl: function removeRemoveQueryUrl(item, query) {
      this.toRemoveOptions[item].queryToRemove.splice(query, 1);
      this.addDivToQueryOfRemove[item]--;
      this.$forceUpdate();
    },
    removeQueryOfUrl: function removeQueryOfUrl(item, query) {
      this.toReplaceOptions[item].queryToReplace.splice(query, 1);
      this.addDivToQuery[item]--;
      this.$forceUpdate();
    },
    removeRemoveQueries: function removeRemoveQueries(item, query) {
      this.removeArray[item].queries.splice(query, 1);
      this.addQueryToRemove[item]--;
      this.$forceUpdate();
    },
    removeRemoveDiv: function removeRemoveDiv(evt) {
      this.removeArray.splice(evt, 1);
      this.addDivRemove--;
    },
    addRemoveDiv: function addRemoveDiv(evt) {
      this.addDivRemove++;
      this.removeArray[this.addDivRemove - 1] = {
        reference: 0,
        queries: [{ query: "" }]
      };
      this.addQueryToRemove[this.addDivRemove - 1] = 1;
    },
    addRemoveDivQuery: function addRemoveDivQuery(evt, item) {
      this.addQueryToRemove[item - 1]++;
      this.removeArray[item - 1].queries[this.addQueryToRemove[item - 1] - 1] = { query: "" };
      this.$forceUpdate();
    },
    advancedMode: function advancedMode(evt) {
      if (this.isSimple == true) {
        this.createUrlSouce();
        this.advancedXML = this.SourceUrl.c_u_Parameters1;
        document.getElementsByClassName("advance")[0].innerText = "Simple Mode";
        this.isSimple = false;
      } else {
        document.getElementsByClassName("advance")[0].innerText = "Advanced Mode";
        this.isSimple = true;
      }
    },
    advancedMode2: function advancedMode2(evt) {
      if (this.isSimple2 == true) {
        this.createXml2();
        this.advancedXML2 = this.SourceUrl.c_u_Parameters2;

        document.getElementsByClassName("advance2")[0].innerText = "Simple Mode";
        this.isSimple2 = false;
      } else {
        document.getElementsByClassName("advance2")[0].innerText = "Advanced Mode";
        this.isSimple2 = true;
      }
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "PmxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainWrapper"},[_c('div',{staticClass:"sourceMain"},[_c('b-row',{staticClass:"sourceMainSections"},[_c('b-col',{staticClass:"sectionsFilters",attrs:{"sm":"2"}},[_c('b-col',{staticClass:"filters"},[_c('p',[_vm._v("Filtros")])]),_vm._v(" "),_c('b-col',{staticClass:"section1"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Fonte")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{model:{value:(_vm.filterSourceName),callback:function ($$v) {_vm.filterSourceName=$$v},expression:"filterSourceName"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Tipo")])]),_vm._v(" "),_c('b-col',[_c('v-select',{staticClass:"filtersSelect",attrs:{"options":_vm.optionsOfTypeSource,"label":"type","reduce":function (type) { return type.code; }},model:{value:(_vm.selectedSource),callback:function ($$v) {_vm.selectedSource=$$v},expression:"selectedSource"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"checkBox"},[_c('b-form-checkbox',{staticClass:"filtersCheckBox",attrs:{"value":"2","unchecked-value":"-1"},model:{value:(_vm.automaticPublish),callback:function ($$v) {_vm.automaticPublish=$$v},expression:"automaticPublish"}},[_vm._v("Publicaçao Automática")])],1),_vm._v(" "),_c('b-col',{staticClass:"checkBox"},[_c('b-form-checkbox',{staticClass:"filtersCheckBox",attrs:{"value":"1","unchecked-value":"-1"},model:{value:(_vm.automaticImport),callback:function ($$v) {_vm.automaticImport=$$v},expression:"automaticImport"}},[_vm._v("Importaçao Automática")])],1),_vm._v(" "),_c('b-col',{staticClass:"filterButton"},[_c('b-button',{staticClass:"btnFilter",on:{"click":function($event){return _vm.filterSources()}}},[_vm._v("Pesquisar")])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section1Sources",attrs:{"sm":"4"}},[_c('b-col',{staticClass:"section1Title"},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left"}},[_vm._v("Fontes")]),_vm._v(" "),_c('b-col',{staticClass:"createDiv"},[_c('b-button',{staticClass:"createBtn",on:{"click":function($event){_vm.isCreateSource = true;
                  _vm.section3 = false;}}},[_vm._v("Criar Fonte")])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section2"},_vm._l((_vm.filteredSources),function(source,index){return _c('b-col',{key:source.c_id,staticClass:"section2Source",on:{"click":function($event){return _vm.openSection3(source.c_id)}}},[_c('b-row',{staticClass:"section2Reference"},[_c('b-col',{attrs:{"sm":"10"}},[_c('h6',[_vm._v(_vm._s(source.c_u_ReferenceSource))])]),_vm._v(" "),_c('b-col',{staticClass:"icons",attrs:{"sm":"2"}},[(source.c_u_Status == -1)?_c('fa',{staticStyle:{"color":"red"},attrs:{"icon":['fas', 'times-circle'],"size":"lg","title":"Inativo"}}):_vm._e(),_vm._v(" "),(source.c_u_Status == 1)?_c('fa',{staticStyle:{"color":"green"},attrs:{"icon":['fas', 'check-circle'],"size":"lg","title":"Ativo"}}):_vm._e(),_vm._v(" "),(source.c_u_Status == 1 && source.c_u_PublishType == 2)?_c('fa',{staticStyle:{"color":"rgb(24, 65, 77)","margin-left":"4px"},attrs:{"icon":['fab', 'adn'],"size":"lg","title":"Publicação automática"}}):_vm._e(),_vm._v(" "),(source.c_u_Status == 2)?_c('fa',{staticStyle:{"color":"lightblue"},attrs:{"icon":['fas', 'check-circle'],"size":"lg","title":"Básico"}}):_vm._e()],1)],1)],1)}),1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[(_vm.isCreateSource)?_c('b-col',[_c('b-col',{staticClass:"section3Reference"},[_c('p',[_vm._v("Criaçao de Fonte")])]),_vm._v(" "),_c('b-col',[_c('b-col',{staticClass:"section3Title"},[_c('h4',[_vm._v("Fonte")])]),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",attrs:{"sm":"2"}},[_c('label',[_vm._v("Nome")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.sourcesView,"label":"source"},model:{value:(_vm.selectedSourceView),callback:function ($$v) {_vm.selectedSourceView=$$v},expression:"selectedSourceView"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",attrs:{"sm":"2"}},[_c('label',[_vm._v("Tipo")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('b-form-select',{attrs:{"options":_vm.typeOptions},on:{"change":function($event){_vm.sourceObject.c_u_Type == 3
                        ? (_vm.isNotSearchEngine = false)
                        : (_vm.isNotSearchEngine = true);
                      _vm.$forceUpdate();}},model:{value:(_vm.sourceObject.c_u_Type),callback:function ($$v) {_vm.$set(_vm.sourceObject, "c_u_Type", $$v)},expression:"sourceObject.c_u_Type"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",staticStyle:{"padding":"0px 5px"},attrs:{"sm":"2"}},[_c('label',[_vm._v("Regularidade")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('b-form-select',{attrs:{"options":_vm.regularityOptions},model:{value:(_vm.sourceObject.c_u_Regularity),callback:function ($$v) {_vm.$set(_vm.sourceObject, "c_u_Regularity", $$v)},expression:"sourceObject.c_u_Regularity"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"d-none"},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",attrs:{"sm":"2"}},[_c('label',[_vm._v("Keywords")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm"},on:{"keyup":_vm.semicolonKey},model:{value:(_vm.sourceObject.c_u_Keywords),callback:function ($$v) {_vm.$set(_vm.sourceObject, "c_u_Keywords", $$v)},expression:"sourceObject.c_u_Keywords"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",attrs:{"sm":"2"}},[_c('label',[_vm._v("Estado")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('b-form-radio-group',[_c('b-form-radio',{attrs:{"id":"sourceStatus_1","name":"sourceStatus","value":"-1"},model:{value:(_vm.sourceObject.c_u_Status),callback:function ($$v) {_vm.$set(_vm.sourceObject, "c_u_Status", $$v)},expression:"sourceObject.c_u_Status"}},[_vm._v("Inativo")]),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"sourceStatus_2","name":"sourceStatus","value":"1"},model:{value:(_vm.sourceObject.c_u_Status),callback:function ($$v) {_vm.$set(_vm.sourceObject, "c_u_Status", $$v)},expression:"sourceObject.c_u_Status"}},[_vm._v("Ativo")]),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"sourceStatus_3","name":"sourceStatus","value":"2"},model:{value:(_vm.sourceObject.c_u_Status),callback:function ($$v) {_vm.$set(_vm.sourceObject, "c_u_Status", $$v)},expression:"sourceObject.c_u_Status"}},[_vm._v("Básico")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-col',{staticClass:"section3Title"},[_c('h4',[_vm._v("Importação das Noticias")])]),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",staticStyle:{"padding":"0px 5px"},attrs:{"sm":"2"}},[_c('label',[_vm._v("Configuração")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsPublishType,"label":"type","reduce":function (type) { return type.code; }},model:{value:(_vm.sourceObject.c_u_PublishType),callback:function ($$v) {_vm.$set(_vm.sourceObject, "c_u_PublishType", $$v)},expression:"sourceObject.c_u_PublishType"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"createXML"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.createConfigs1Xml",modifiers:{"createConfigs1Xml":true}}],attrs:{"size":"sm"}},[_vm._v("Configuração XML 1")])],1),_vm._v(" "),_c('b-col',{staticClass:"createXML"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.createXml2",modifiers:{"createXml2":true}}],attrs:{"size":"sm"}},[_vm._v("Configuração XML 2")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section3Footer"},[_c('b-button',{on:{"click":function($event){return _vm.createSource()}}},[_vm._v("Criar")])],1)],1):_vm._e(),_vm._v(" "),(_vm.section3)?_c('b-col',[_c('b-col',{staticClass:"section3Reference"},[_c('p',[_vm._v(_vm._s(_vm.clickedSource.c_u_ReferenceSource))])]),_vm._v(" "),_c('b-col',[_c('b-col',{staticClass:"section3Title"},[_c('h4',[_vm._v("Fonte")])]),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",attrs:{"sm":"2"}},[_c('label',[_vm._v("Nome")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v(_vm._s(_vm.clickedSource.c_u_ReferenceSource))])],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",attrs:{"sm":"2"}},[_c('label',[_vm._v("Tipo")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('b-form-select',{attrs:{"options":_vm.typeOptions},on:{"change":function($event){_vm.clickedSource.c_u_Type == 3
                        ? (_vm.isNotSearchEngine = false)
                        : (_vm.isNotSearchEngine = true);
                      _vm.$forceUpdate();}},model:{value:(_vm.clickedSource.c_u_Type),callback:function ($$v) {_vm.$set(_vm.clickedSource, "c_u_Type", $$v)},expression:"clickedSource.c_u_Type"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",staticStyle:{"padding":"0px 5px"},attrs:{"sm":"2"}},[_c('label',[_vm._v("Regularidade")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('b-form-select',{attrs:{"options":_vm.regularityOptions},model:{value:(_vm.clickedSource.c_u_Regularity),callback:function ($$v) {_vm.$set(_vm.clickedSource, "c_u_Regularity", $$v)},expression:"clickedSource.c_u_Regularity"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource d-none",attrs:{"sm":"2"}},[_c('label',[_vm._v("Keywords")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName d-none",attrs:{"sm":"10"}},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Enter the Keywords"},on:{"keyup":_vm.semicolonKey},model:{value:(_vm.clickedSource.c_u_Keywords),callback:function ($$v) {_vm.$set(_vm.clickedSource, "c_u_Keywords", $$v)},expression:"clickedSource.c_u_Keywords"}})],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",attrs:{"sm":"2"}},[_c('label',[_vm._v("Estado")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('b-form-radio-group',[_c('b-form-radio',{attrs:{"id":"sourceStatus_1","name":"sourceStatus","value":"-1"},model:{value:(_vm.clickedSource.c_u_Status),callback:function ($$v) {_vm.$set(_vm.clickedSource, "c_u_Status", $$v)},expression:"clickedSource.c_u_Status"}},[_vm._v("Inativo")]),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"sourceStatus_2","name":"sourceStatus","value":"1"},model:{value:(_vm.clickedSource.c_u_Status),callback:function ($$v) {_vm.$set(_vm.clickedSource, "c_u_Status", $$v)},expression:"clickedSource.c_u_Status"}},[_vm._v("Ativo")]),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"sourceStatus_3","name":"sourceStatus","value":"2"},model:{value:(_vm.clickedSource.c_u_Status),callback:function ($$v) {_vm.$set(_vm.clickedSource, "c_u_Status", $$v)},expression:"clickedSource.c_u_Status"}},[_vm._v("Básico")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-col',{staticClass:"section3Title"},[_c('h4',[_vm._v("Importação das Noticias")])]),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",staticStyle:{"padding":"0px 5px"},attrs:{"sm":"2"}},[_c('label',[_vm._v("Configuração")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('v-select',{staticStyle:{"background-color":"white"},attrs:{"options":_vm.optionsPublishType,"label":"type","reduce":function (type) { return type.code; }},model:{value:(_vm.clickedSource.c_u_PublishType),callback:function ($$v) {_vm.$set(_vm.clickedSource, "c_u_PublishType", $$v)},expression:"clickedSource.c_u_PublishType"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Não foram obtidos resultados")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"display":"none"}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelSource",attrs:{"sm":"2"}},[_c('label',[_vm._v("Horas")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-datepicker',{staticClass:"mb-2",attrs:{"placeholder":"Data de inicio"},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('b-form-timepicker',{staticClass:"mb-2",attrs:{"size":"sm","local":"en","placeholder":"Hora de inicio"},model:{value:(_vm.startHour),callback:function ($$v) {_vm.startHour=$$v},expression:"startHour"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-datepicker',{staticClass:"mb-2",attrs:{"placeholder":"Data de Fim"},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('b-form-timepicker',{staticClass:"mb-2",attrs:{"size":"sm","local":"en","placeholder":"Hora de fim"},model:{value:(_vm.endHour),callback:function ($$v) {_vm.endHour=$$v},expression:"endHour"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"editXML"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.editUrlSource",modifiers:{"editUrlSource":true}}],attrs:{"size":"sm"},on:{"click":function($event){return _vm.editUrl(_vm.clickedSource)}}},[_vm._v("Configuração XML 1")])],1),_vm._v(" "),_c('b-col',{staticClass:"editXML"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.editSource2",modifiers:{"editSource2":true}}],attrs:{"size":"sm"},on:{"click":function($event){return _vm.editUrl(_vm.clickedSource)}}},[_vm._v("Configuração XML 2")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section3Footer"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.deleteUrlSource",modifiers:{"deleteUrlSource":true}}],staticStyle:{"background-color":"rgb(162, 91, 113)"},on:{"click":function($event){return _vm.deleteUrl(_vm.clickedSource)}}},[_vm._v("Apagar")]),_vm._v(" "),_c('b-button',{on:{"click":function($event){return _vm.editedSource()}}},[_vm._v("Guardar")])],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('createUrl',{attrs:{"isNotSearchEngine":_vm.isNotSearchEngine,"sourceObject":_vm.sourceObject},on:{"ok":_vm.createXmls}}),_vm._v(" "),_c('deleteUrl',{attrs:{"sourceUrl":_vm.sourceUrl},on:{"ok":_vm.deletedSource}}),_vm._v(" "),_c('editUrl',{attrs:{"idSource":_vm.idSource},on:{"ok":_vm.updateParamters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QZQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sources_CreateUrl__ = __webpack_require__("mL2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sources_rss_CreateRss__ = __webpack_require__("8MIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sources_DeleteUrl__ = __webpack_require__("Z8lc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sources_EditUrl__ = __webpack_require__("LdBt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select_dist_vue_select_css__ = __webpack_require__("R870");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SourceMain",

  data: function data() {
    return {
      sources: [],
      filteredSources: [],
      sourceObject: {
        c_id: 0,
        c_u_Type: 0,
        c_u_Status: 1,
        c_u_PublishType: 0,
        c_u_Regularity: 0,
        c_u_ReferenceSource: "",
        c_u_Keywords: "",
        c_u_Parameters1: "",
        c_u_Parameters2: ""
      },
      endpoint: "Sources",
      endpointTime: "TimeSchedules",
      isCreateSource: false,
      sourceUrl: null,
      timeSchedule: {
        c_u_TimeStart: "",
        c_u_TimeEnd: "",
        c_u_Status: 2,
        c_r_Source: 0
      },
      section3: false,
      isNotSearchEngine: true,
      idSource: null,
      automaticPublish: 0,
      automaticImport: 0,
      clickedSource: [],
      filterSourceName: "",
      selectedSource: [],
      sourcesView: [],
      selectedSourceView: [],
      startDate: "",
      endDate: "",
      startHour: "",
      endHour: "",
      optionsOfTypeSource: [{ type: "URL", code: 1 }, { type: "RSS", code: 2 }, { type: "Search Engine", code: 3 }],
      optionsPublishType: [{ code: 0, type: "Publicação Manual" }, { code: 1, type: "Descarregamento Automático" }, { code: 2, type: "Publicação Automática" }],
      optionsForSource: [{ value: 1, text: "URL" }, { value: 2, text: "RSS" }, { value: 3, text: "Search Engine" }],
      typeOptions: [{ value: "0", text: "Selecione uma das opções" }, { value: 1, text: "URL" }, { value: 2, text: "RSS Feed" }, { value: 3, text: "Search Engine" }],
      regularityOptions: [{ value: "0", text: "Selecione uma das opções" }, { value: "10", text: "10 Minutos" }, { value: "20", text: "20 Minutos" }, { value: "30", text: "30 Minutos" }, { value: "40", text: "40 Minutos" }, { value: "50", text: "50 Minutos" }, { value: "60", text: "60 Minutos" }, { value: "720", text: "12 Horas" }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])({
    isSaved: "api/isSaved"
  })),
  watch: {
    filterSourceName: function filterSourceName(to, from) {
      this.filterSources();
    },
    selectedSource: function selectedSource(to, from) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.filterSources();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    automaticPublish: function automaticPublish(to, form) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.filterSources();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    automaticImport: function automaticImport(to, from) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.filterSources();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },
  components: {
    createUrl: __WEBPACK_IMPORTED_MODULE_3__Sources_CreateUrl__["a" /* default */],
    createRss: __WEBPACK_IMPORTED_MODULE_4__Sources_rss_CreateRss__["a" /* default */],
    deleteUrl: __WEBPACK_IMPORTED_MODULE_5__Sources_DeleteUrl__["a" /* default */],
    editUrl: __WEBPACK_IMPORTED_MODULE_6__Sources_EditUrl__["a" /* default */],
    vSelect: __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a
  },
  methods: {
    getSources: function getSources() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index, viewSources, _index;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$api.data.endpoint = _this4.endpoint;
                _context4.next = 3;
                return _this4.$api.data.find();

              case 3:
                _this4.sources = _context4.sent;

                _this4.totalItems = _this4.sources.length;
                //receive the sources by the principal table using views
                for (index = 0; index < _this4.sources.length; index++) {
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(_this4.filteredSources, index, _this4.sources[index]);
                }
                _this4.$api.data.endpoint = "Vsources/SourcesNotImported";
                _context4.next = 9;
                return _this4.$api.data.find();

              case 9:
                viewSources = _context4.sent;

                for (_index = 0; _index < viewSources.length; _index++) {
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(_this4.sourcesView, _index, {
                    id: viewSources[_index].id,
                    source: viewSources[_index].sourceName
                  });
                }
                _this4.$forceUpdate();

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    filterSources: function filterSources() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var filteringSources, SourceType;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                //console.log(this.filterSourceName);
                //console.log(this.selectedSource);
                //console.log(this.automaticPublish);
                //console.log(this.automaticImport);
                //console.log("this.sources", this.sources);

                filteringSources = _.filter(_this5.sources, function (src) {
                  return true;
                });


                if (_this5.filterSourceName.trim().length > 0) {
                  filteringSources = _.filter(filteringSources, function (src) {
                    return src.c_u_ReferenceSource.toLowerCase().indexOf(_this5.filterSourceName.toLowerCase()) > -1;
                  });
                }
                if (_this5.selectedSource != null) {
                  try {
                    SourceType = parseInt(_this5.selectedSource, 10);

                    if (!isNaN(SourceType)) {
                      filteringSources = _.filter(filteringSources, function (src) {
                        return src.c_u_Type == SourceType;
                      });
                    }
                  } catch (err) {}
                }
                if (_this5.automaticPublish == 2) {
                  filteringSources = _.filter(filteringSources, function (src) {
                    return src.c_u_PublishType == _this5.automaticPublish;
                  });
                }
                if (_this5.automaticImport == 1) {
                  filteringSources = _.filter(filteringSources, function (src) {
                    return src.c_u_PublishType == _this5.automaticImport;
                  });
                }

                _this5.filteredSources = filteringSources;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    openSection3: function openSection3(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.isCreateSource = false;
                _this6.section3 = true;
                _this6.$api.data.endpoint = _this6.endpoint;
                _context6.next = 5;
                return _this6.$api.data.findOneById(id);

              case 5:
                _this6.clickedSource = _context6.sent;

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    createSource: function createSource() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!((_this7.sourceObject.c_u_Status == -1 || _this7.sourceObject.c_u_Status == 1) && (_this7.sourceObject.c_u_Parameters1 == "" || _this7.sourceObject.c_u_Parameters2 == ""))) {
                  _context7.next = 4;
                  break;
                }

                _this7.$bvToast.toast("Para efetuar a criação da fonte é necessario preencher o XML1 e o XML2", {
                  autoHideDelay: 4000,
                  variant: "danger"
                });
                _context7.next = 14;
                break;

              case 4:
                _this7.$api.data.endpoint = _this7.endpoint;
                _this7.sourceObject.c_u_Status = parseInt(_this7.sourceObject.c_u_Status);
                _this7.sourceObject.c_id = _this7.selectedSourceView.id;
                _this7.sourceObject.c_u_ReferenceSource = _this7.selectedSourceView.source;
                _context7.next = 10;
                return _this7.$api.data.create(_this7.sourceObject);

              case 10:
                _this7.getSources();
                _this7.isCreateSource = false;
                _this7.sourceObject = {
                  c_id: 0,
                  c_u_Type: 0,
                  c_u_Status: -1,
                  c_u_PublishType: 0,
                  c_u_Regularity: 0,
                  c_u_ReferenceSource: "",
                  c_u_Keywords: "",
                  c_u_Parameters1: "",
                  c_u_Parameters2: ""
                };
                _this7.selectedSourceView = [];

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },

    //function to receive the data from modal XML1 and modal XML2
    createXmls: function createXmls(configs1, configs2) {
      this.sourceObject.c_u_Parameters1 = configs1;
      this.sourceObject.c_u_Parameters2 = configs2;
    },
    editedSource: function editedSource() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var updatedSources;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.clickedSource.c_u_Status = parseInt(_this8.clickedSource.c_u_Status);

                if (!(_this8.startDate != "" && _this8.startHour != "" && _this8.endDate != "" && _this8.endHour != "")) {
                  _context8.next = 8;
                  break;
                }

                _this8.timeSchedule.c_u_TimeStart = _this8.startDate + " " + _this8.startHour;
                _this8.timeSchedule.c_u_TimeEnd = _this8.endDate + " " + _this8.endHour;
                _this8.timeSchedule.c_r_Source = _this8.clickedSource.c_id;
                _this8.$api.data.endpoint = _this8.endpointTime;
                _context8.next = 8;
                return _this8.$api.data.create(_this8.timeSchedule);

              case 8:
                /*if (this.clickedSource.c_u_Parameters1 == "") {
                  let source = await this.$api.data.findOneById(this.clickedSource.c_id);
                  source.c_u_Parameters2 = this.clickedSource.c_u_Parameters2;
                  this.$api.data.endpoint = this.endpoint;
                  await this.$api.data.updatedById(this.clickedSource.c_id, source);
                } else {*/
                _this8.$api.data.endpoint = _this8.endpoint;
                _context8.next = 11;
                return _this8.$api.data.updatedById(_this8.clickedSource.c_id, _this8.clickedSource);

              case 11:
                _context8.next = 13;
                return _this8.$api.data.find();

              case 13:
                updatedSources = _context8.sent;

                _this8.filteredSources = updatedSources;
                _this8.sources = updatedSources;
                _this8.timeSchedule.c_u_TimeStart = "";
                _this8.timeSchedule.c_u_TimeEnd = "";
                _this8.timeSchedule.c_r_Source = 0;
                _this8.startHour = "";
                _this8.endHour = "";
                _this8.endDate = "";
                _this8.$forceUpdate();

              case 23:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    deleteUrl: function deleteUrl(item) {
      this.sourceUrl = item.c_id;
    },

    // function to update the data from section1
    deletedSource: function deletedSource() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var updatedSources, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this9.filteredSources = [];
                _this9.$api.data.endpoint = _this9.endpoint;
                _context9.next = 4;
                return _this9.$api.data.find();

              case 4:
                updatedSources = _context9.sent;

                for (index = 0; index < updatedSources.length; index++) {
                  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(_this9.filteredSources, index, updatedSources[index]);
                }
                _this9.$forceUpdate();
                _this9.section3 = false;

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    editUrl: function editUrl(item) {
      console.log("item.c_u_Parameters1", item.c_u_Parameters1);
      console.log("item.c_u_Parameters2", item.c_u_Parameters2);
      this.idSource = item.c_id;
    },

    semicolonKey: function semicolonKey(event) {
      if (event.key != undefined) {
        if (event.keyCode == 32) {
          this.clickedSource.c_u_Keywords = this.clickedSource.c_u_Keywords.replace(/\s/g, "") + ";";
        }
      }
    },
    updateParamters: function updateParamters(configs1, configs2) {
      if (configs1 == "") {
        configs1 = this.clickedSource.c_u_Parameters1;
      }
      if (configs2 == "") {
        configs2 = this.clickedSource.c_u_Parameters2;
      }

      this.clickedSource.c_u_Parameters1 = configs1;
      this.clickedSource.c_u_Parameters2 = configs2;
    }
  },

  mounted: function mounted() {
    this.getSources();
  }
});

/***/ }),

/***/ "R870":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SHpU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"mx-auto",staticStyle:{"width":"400px"}},[_c('b-card',{attrs:{"header-tag":"header"}},[_c('h6',{staticClass:"mb-0",attrs:{"slot":"header"},slot:"header"},[_c('img',{staticStyle:{"width":"75px","height":"40px"},attrs:{"src":__webpack_require__("7Otq")}})]),_vm._v("\n      "+_vm._s(_vm.info)+"\n      "),_c('div',{staticStyle:{"color":"#333","text-align":"center","padding":"10px 15px"},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)},_vm.keymonitor]}},[(this.caps == true)?_c('p',{staticStyle:{"font-weight":"bold"},attrs:{"id":"text"}},[_vm._v("\n          Caps lock is ON.\n        ")]):_vm._e(),_vm._v(" "),_c('vue-form-generator',{attrs:{"schema":_vm.schema,"model":_vm.credentials,"options":_vm.formOptions}}),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary btn-block","size":"sm"},on:{"click":_vm.login}},[_vm._v("Login")])],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "THEh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationLog_vue__ = __webpack_require__("UQNj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2150375a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationLog_vue__ = __webpack_require__("uVR5");
function injectStyle (ssrContext) {
  __webpack_require__("/MEH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2150375a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2150375a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TdBs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UQNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select_dist_vue_select_css__ = __webpack_require__("R870");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      logs: [],
      endpoint: "OperationLogs",
      endpointExecution: "Executions",
      totalItems: 0,
      currentPage: 1,
      filteredLogs: [],
      clickedLogs: [],
      section3: false,
      lo: _,
      optionsType: [{ id: 0, type: "undefined" }, { id: 1, type: "Get news from a source for a manual scheduling" }, { id: 2, type: "Get selected news for a manual scheduling" }, { id: 3, type: "Get news from sources for an automatic scheduling" }, { id: 4, type: "Get news with no previous response" }, { id: 5, type: "Extract information from news" }],
      optionsSeverity: [{ id: 2, type: "Information" }, { id: 3, type: "Warning" }, { id: 4, type: "Error" }, { id: 5, type: "Critical" }],
      optionStatus: [{ code: -1, status: "Erro" }, { code: 1, status: "Sucesso" }],
      optionExecution: [{ id: 1, type: "Get Execution" }, { id: 2, type: "Extract Execution" }],
      selectedStatus: [],
      selectedSeverity: [],
      selectedExecution: [],
      optionsSource: [],
      executionType: [],
      sourceId: [],
      startDateOfLog: "",
      endDateLog: "",
      sourcesArray: [],
      fields: [{
        key: "c_u_Status",
        label: "Status",
        formatter: function formatter(value, key, item) {
          if (value == 1) {
            item["_rowVariant"] = "success";
            return value = "Success";
          }
          if (value == -1) {
            item["_rowVariant"] = "danger";
            return value = "Error";
          }
        }
      }, {
        key: "c_u_Date",
        label: "Date"
      }, {
        key: "c_u_Source",
        label: "Source",
        formatter: function formatter(value, key, item) {
          return item.sources.c_u_ReferenceSource;
        }
      }, {
        key: "c_u_Description",
        label: "Description"
      }, {
        key: "c_u_Result",
        label: "Result"
      }]
    };
  },

  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a
  },

  methods: {
    getLogs: function getLogs() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$api.data.endpoint = "Sources";
                _context.next = 3;
                return _this.$api.data.find();

              case 3:
                _this.sourcesArray = _context.sent;


                _this.$api.data.endpoint = _this.endpoint;
                _context.next = 7;
                return _this.$api.data.find();

              case 7:
                _this.logs = _context.sent;

                _this.filteredLogs = _.orderBy(_this.logs, ["c_u_Date"], ["desc"]);

                for (index = 0; index < _this.sourcesArray.length; index++) {
                  __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(_this.optionsSource, index, {
                    id: _this.sourcesArray[index].c_id,
                    source: _this.sourcesArray[index].c_u_ReferenceSource
                  });
                }
                _this.totalItems = _this.logs.length;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openSection3: function openSection3(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.data.endpoint = _this2.endpoint;
                _context2.next = 3;
                return _this2.$api.data.findOneById(id);

              case 3:
                _this2.clickedLogs = _context2.sent;

                _this2.$api.data.endpoint = _this2.endpointExecution;
                _context2.next = 7;
                return _this2.$api.data.findOneById(_this2.clickedLogs.c_r_Execution);

              case 7:
                _this2.executionType = _context2.sent;


                _this2.section3 = true;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    filterLogInfo: function filterLogInfo() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var filter;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                filter = [];

                _this3.sourceId = _this3.sourceId > 0 ? _this3.sourceId : 0;
                _this3.selectedStatus = typeof _this3.selectedStatus == "number" ? _this3.selectedStatus : 0;
                _this3.startDateOfLog = _this3.startDateOfLog != "" ? _this3.startDateOfLog : "0";
                _this3.endDateLog = _this3.endDateLog != "" ? _this3.endDateLog : "0";
                _this3.selectedExecution = typeof _this3.selectedExecution == "number" ? _this3.selectedExecution : 0;
                _this3.selectedSeverity = typeof _this3.selectedSeverity == "number" ? _this3.selectedSeverity : "";

                if (!(_this3.sourceId != 0 || _this3.selectedStatus != 0 || _this3.startDateOfLog != "0" || _this3.endDateLog != "0" || _this3.selectedExecution != 0 || _this3.selectedSeverity != "")) {
                  _context3.next = 15;
                  break;
                }

                _this3.$api.data.endpoint = "OperationLogs/scrollByFilter/0/" + _this3.sourceId + "/" + _this3.selectedStatus + "/" + (_this3.selectedSeverity != "" ? _this3.selectedSeverity : -2) + "/" + _this3.selectedExecution + "/" + _this3.startDateOfLog + "/" + _this3.endDateLog;
                _context3.next = 11;
                return _this3.$api.data.find();

              case 11:
                filter = _context3.sent;

                _this3.filteredLogs = _.orderBy(filter, ["c_u_Date"], ["desc"]);
                _context3.next = 16;
                break;

              case 15:
                _this3.getLogs();

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    clearFilters: function clearFilters() {
      this.selectedStatus = [], this.selectedSeverity = [], this.selectedExecution = [], this.optionsSource = [], this.sourceId = [], this.startDateOfLog = "", this.endDateLog = "", this.getLogs();
    },
    handleScrolll: function handleScrolll() {
      if (!this.$api.data.endpoint.match("scrollByFilter")) {
        var itsFinal = 0;
        var that = this;
        var newDataOfLogs = [];
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()("#section2").on("scroll", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
          var scrollPosition, divTotalHeight, index;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  scrollPosition = Math.round(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).scrollTop() + __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).innerHeight(), 10);
                  divTotalHeight = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this)[0].scrollHeight + parseInt(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).css("padding-top"), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).css("padding-bottom"), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).css("border-top-width"), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).css("border-bottom-width"), 10);

                  if (!(scrollPosition >= divTotalHeight && itsFinal == 0)) {
                    _context4.next = 9;
                    break;
                  }

                  that.$api.data.endpoint = "OperationLogs/scrollDown/" + that.filteredLogs.length;
                  _context4.next = 6;
                  return that.$api.data.find();

                case 6:
                  newDataOfLogs = _context4.sent;

                  for (index = 0; index < newDataOfLogs.length; index++) {
                    if (that.filteredLogs.indexOf(newDataOfLogs[index]) == -1) {
                      that.filteredLogs.push(newDataOfLogs[index]);
                    }
                  }
                  that.filteredLogs = _.uniq(that.filteredLogs);

                case 9:
                  itsFinal++;

                case 10:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        })));
      }
      if (this.$api.data.endpoint.match("scrollByFilter")) {
        var _itsFinal = 0;
        var _that = this;
        var _newDataOfLogs = [];
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()("#section2").on("scroll", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
          var scrollPosition, divTotalHeight, index;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  scrollPosition = Math.round(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).scrollTop() + __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).innerHeight(), 10);
                  divTotalHeight = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this)[0].scrollHeight + parseInt(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).css("padding-top"), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).css("padding-bottom"), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).css("border-top-width"), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).css("border-bottom-width"), 10);

                  if (!(scrollPosition >= divTotalHeight && _itsFinal == 0)) {
                    _context5.next = 9;
                    break;
                  }

                  _that.$api.data.endpoint = "OperationLogs/scrollByFilter/" + _that.filteredLogs.length + "/" + _that.sourceId + "/" + _that.selectedStatus + "/" + (typeof _that.selectedSeverity == "number" ? _that.selectedSeverity : -2) + "/" + (typeof _that.selectedExecution == "number" ? _that.selectedExecution : 0) + "/" + _that.startDateOfLog + "/" + _that.endDateLog;
                  _context5.next = 6;
                  return _that.$api.data.find();

                case 6:
                  _newDataOfLogs = _context5.sent;

                  for (index = 0; index < _newDataOfLogs.length; index++) {
                    if (_that.filteredLogs.indexOf(_newDataOfLogs[index]) == -1) {
                      _that.filteredLogs.push(_newDataOfLogs[index]);
                    }
                  }
                  _that.filteredLogs = _.uniq(_that.filteredLogs);

                case 9:
                  _itsFinal++;

                case 10:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        })));
      }
    }
  },
  computed: {},

  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this4.getLogs();

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this4);
    }))();
  }
});

/***/ }),

/***/ "Usg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "UtyK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export everyHourChartData */
var everyHourChartData = {
  type: 'line',
  data: {
    labels: [],
    datasets: [{ // another line graph
      label: 'Noticias extraidas a cada hora nas ultimas 24 horas',
      data: [],
      backgroundColor: ['rgba(134,192,255)'],
      borderColor: ['#007bff'],
      borderWidth: 3
    }]
  },
  options: {
    responsive: true,
    lineTension: 1,
    annotation: {
      annotations: [{
        drawTime: "afterDatasetsDraw",
        type: "line",
        mode: "vertical",
        scaleID: "x-axis-0",
        value: function () {
          var DateTime = new Date();
          DateTime.setHours(DateTime.getHours() - 1);
          return DateTime.getHours() + DateTime.getMinutes() / 60;
        }(),
        borderWidth: 1,
        borderColor: "#007bff",
        label: {
          content: "Último",
          enabled: false,
          position: "top"
        }
      }]
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          padding: 25
        }
      }]
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (everyHourChartData);

/***/ }),

/***/ "Vyhx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_OperationLog_OperationLog__ = __webpack_require__("THEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Sources_SourceMain__ = __webpack_require__("GQMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_News_NewsMain__ = __webpack_require__("fw+e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_NewsEdition__ = __webpack_require__("wSLg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ThemeWords__ = __webpack_require__("q7A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__("olkN");











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var vueRouter = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: {
      path: '/login'
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
  }, {
    path: '/Home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/NewsEdition',
    name: 'NewsEdition',
    component: __WEBPACK_IMPORTED_MODULE_7__components_NewsEdition__["a" /* default */]
  }, {
    path: '/Sources',
    name: 'SourceMain',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Sources_SourceMain__["a" /* default */]
  }, {
    path: '/Logs',
    name: 'OperationLog',
    component: __WEBPACK_IMPORTED_MODULE_4__components_OperationLog_OperationLog__["a" /* default */]
  }, {
    path: '/News',
    name: 'NewsMain',
    component: __WEBPACK_IMPORTED_MODULE_6__components_News_NewsMain__["a" /* default */]
  }, {
    path: '/ThemeWords',
    name: 'ThemeWords',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ThemeWords__["a" /* default */]
  }]
});

vueRouter.beforeEach(function (to, from, next) {
  if (to.name != 'Login' && !__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['auth/isLoggedIn']) {
    return next('/login');
  }

  if (to.name == 'Login' && __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['auth/isLoggedIn']) {

    return next('/Home');
  }

  if (to.name == 'Login' && !__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters['auth/isLoggedIn']) {

    return next();
  }

  return next();
});

/* harmony default export */ __webpack_exports__["a"] = (vueRouter);

/***/ }),

/***/ "Z8lc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteUrl_vue__ = __webpack_require__("JWrW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7885611c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteUrl_vue__ = __webpack_require__("lbrL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7885611c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zj8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Delete New",

  data: function data() {
    return {
      endpoint: "News"
    };
  },


  props: {
    newsExtracted: Number
  },

  components: {},

  methods: {
    DeleteNews: function DeleteNews() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$api.data.endpoint = _this.endpoint;
                _context.next = 3;
                return _this.$api.data.destroyById(_this.newsExtracted);

              case 3:
                _this.$emit("ok");

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "dxK+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



/* harmony default export */ __webpack_exports__["a"] = ({

	install: function install(Vue) {

		Vue.prototype.$_ = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a;
	}
});

/***/ }),

/***/ "eyip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fw+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsMain_vue__ = __webpack_require__("r4sH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7f9b86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsMain_vue__ = __webpack_require__("var0");
function injectStyle (ssrContext) {
  __webpack_require__("lDhp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f7f9b86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7f9b86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lDhp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55757900_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("ENlu");
function injectStyle (ssrContext) {
  __webpack_require__("Vyhx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55757900"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55757900_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lbrL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"fluid":""}},[_c('b-modal',{attrs:{"id":"deleteUrlSource","title":"Apagar Fonte"},on:{"ok":_vm.DeleteUrlSouce}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("Tem a certeza que pretende eliminar esta fonte ?")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mL2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUrl_vue__ = __webpack_require__("Hobc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e3163c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUrl_vue__ = __webpack_require__("MJSO");
function injectStyle (ssrContext) {
  __webpack_require__("pPQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59e3163c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e3163c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "miIm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"fluid":""}},[(_vm.newEditArray)?_c('b-modal',{attrs:{"scrollable":"","id":"editNews","size":"xl","title":"Edit News"},on:{"shown":_vm.loadData,"ok":_vm.editedNew}},[_c('b-col',[_c('b-row',[_c('b-col',[_c('h6',[_vm._v("Title")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea","rows":"3","max-rows":"6"},model:{value:(_vm.newEditArray.c_u_Title),callback:function ($$v) {_vm.$set(_vm.newEditArray, "c_u_Title", $$v)},expression:"newEditArray.c_u_Title"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',[_c('b-col',[_c('h6',[_vm._v("Resume")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea","rows":"3","max-rows":"6"},model:{value:(_vm.newEditArray.c_u_Resume),callback:function ($$v) {_vm.$set(_vm.newEditArray, "c_u_Resume", $$v)},expression:"newEditArray.c_u_Resume"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',[_c('b-col',[_c('h6',[_vm._v("Image")]),_vm._v(" "),_c('b-container',{staticClass:"border",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('img',{staticStyle:{"padding":"5px"},attrs:{"src":("" + (_vm.newEditArray.c_u_Image)),"width":"200"}})]),_vm._v(" "),_c('b-row',[_c('b-button',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.right",value:('Add other url'),expression:"'Add other url'",modifiers:{"hover":true,"right":true}}],attrs:{"variant":"outline-primary","size":"sm"}},[_c('fa',{attrs:{"icon":"plus","size":"sm"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',[_c('b-col',[_c('h6',[_vm._v("Content")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea","rows":"3","max-rows":"6"},model:{value:(_vm.newEditArray.c_u_Content),callback:function ($$v) {_vm.$set(_vm.newEditArray, "c_u_Content", $$v)},expression:"newEditArray.c_u_Content"}})],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "login",

  data: function data() {
    return {
      info: null,
      caps: false,
      credentials: {
        username: "",
        password: ""
      },

      schema: {
        fields: [{
          type: "input",
          inputType: "text",
          label: "Username",
          id: "username",
          model: "username",
          required: true,
          validator: "string",
          attributes: {
            autofocus: true
          }
        }, {
          type: "input",
          inputType: "password",
          label: "Password",
          id: "password",
          model: "password",
          required: true,
          validator: "string"
        }]
      },
      formOptions: {
        validateAfterChanged: true,
        validateAsync: true
      }
    };
  },

  methods: {
    keymonitor: function keymonitor(event) {
      if (event.key != undefined) {
        if (event.getModifierState("CapsLock")) {
          this.caps = true;
        } else {
          this.caps = false;
        }
      }
    },

    login: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.credentials.username && this.credentials.password)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.$api.auth.login(this.credentials);

              case 3:
                res = _context.sent;

                try {
                  //console.log("res: ", res);
                  document.getElementById("ithUserID").value = res.id;
                } catch (err) {}

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function login() {
        return _ref.apply(this, arguments);
      }

      return login;
    }()
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist_dist_umd__ = __webpack_require__("414s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist_dist_umd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persist_dist_umd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_config_loader__ = __webpack_require__("Apz4");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var api = {
    namespaced: true,

    // state: {
    //     protocol: 'https',
    //     host: 'localhost',
    //     port: 44338,
    //     isLoading: false
    // },
    //servidor de qualidade expedita
    state: {
        protocol: __WEBPACK_IMPORTED_MODULE_4__src_config_loader__["a" /* default */].getMetaValue('VUE_APP_BASE_PROTOCOL'),
        host: __WEBPACK_IMPORTED_MODULE_4__src_config_loader__["a" /* default */].getMetaValue('VUE_APP_BASE_URL'),
        port: parseInt(__WEBPACK_IMPORTED_MODULE_4__src_config_loader__["a" /* default */].getMetaValue('VUE_APP_BASE_PORT')),
        isLoading: false
    },
    //servidor de produçao presspower
    // state: {
    //     protocol: 'https',
    //     host: 'webapi.presspower.pt',
    //     isLoading: false
    // },

    getters: {
        fullUrl: function fullUrl(state) {
            return state.port != 0 ? state.protocol + '://' + state.host + ':' + state.port + '/api/' : state.protocol + '://' + state.host + '/api/';
        },
        // fullUrl : state => {
        //     return `${state.protocol}://${state.host}/api/`;
        // },
        isLoading: function isLoading(state) {
            return state.isLoading;
        },
        getUrl: function getUrl(state) {
            return state.port != 0 ? state.protocol + '://' + state.host + ':' + state.port : state.protocol + '://' + state.host;
        }
    },
    mutations: {
        isLoadingOn: function isLoadingOn(state, data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'isLoading', true);
        },
        isLoadingOff: function isLoadingOff(state, data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'isLoading', false);
        }
    }
};

var auth = {
    namespaced: true,

    state: {
        user: null
    },
    getters: {
        isLoggedIn: function isLoggedIn(state) {
            return state.userID ? true : false;
        },

        getUsername: function getUsername(state) {
            if (state.user != null) {
                return '' + state.user;
            }
        },

        getUserId: function getUserId(state) {
            return state.userID;
        }
    },
    mutations: {
        login: function login(state, data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'user', data.info[0].User.DisplayName);
            //Vue.set(state, 'token', data.token)
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'userID', data.id);
            __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].push({ path: '/Home' });
        },
        logout: function logout(state, data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'user', null);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'userID', null);
            //Vue.set(state, 'token', null)
            __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].push({ path: '/login' });
        }
    }

};
var vuexLocal = new __WEBPACK_IMPORTED_MODULE_2_vuex_persist_dist_umd___default.a({
    key: 'auth',
    storage: window.sessionStorage,
    modules: ['auth']

});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    modules: {
        api: api,
        auth: auth
    },
    plugins: [vuexLocal.plugin]

}));

/***/ }),

/***/ "ov6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__("Usg1");





var response_interceptor = function response_interceptor(event, xhr, settings) {
	// send the data from login to the store
	if (settings.url.includes('/Users') && settings.type.includes('POST')) {
		__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('auth/login', xhr.responseJSON);
	}

	return xhr.responseJSON;
};

var response_error_interceptor = function response_error_interceptor(event, jqxhr, exception, thrownError) {
	if (jqxhr.status == 200) {
		__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('api_success', '' + jqxhr.responseText);
	} else {
		if (jqxhr.responseText != "") {
			__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('api_error', jqxhr.status ? '' + jqxhr.responseText : 'Unknow error');
			if (!jqxhr.status) {
				__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('auth/logout');
			}
		} else {
			__WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('api_error', jqxhr.status ? jqxhr.statusText + ' - ' + jqxhr.status : 'Unknow error');
		}
	}
};
// triggred the request for the loading
__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).bind("ajaxStart", function () {
	__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('api/isLoadingOn');
}).bind("ajaxStop", function () {
	__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('api/isLoadingOff');
});
__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).ajaxError(response_error_interceptor);
__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).ajaxSuccess(response_interceptor);

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a);

/***/ }),

/***/ "pPQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pjCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"active":this.isLoading,"is-full-page":_vm.fullPage,"color":"rgb(0, 128,255)"},on:{"update:active":function($event){return _vm.$set(this, "isLoading", $event)}}}),_vm._v(" "),(_vm.isLoggedIn)?_c('b-col',[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"align-self":"end"}},[_vm._v("\n        "+_vm._s(_vm.getUsername)+"\n        "),_c('input',{attrs:{"type":"hidden","id":"ithUserID","value":"0"}}),_vm._v(" "),_c('b-button',{staticClass:"logOutBtn",attrs:{"size":"sm"},on:{"click":_vm.logout}},[_vm._v("Sair")])],1)],1),_vm._v(" "),(_vm.isNotInConfig())?_c('b-row',{staticClass:"navBar"},[_c('b-col',[_c('img',{staticStyle:{"height":"50px"},attrs:{"src":__webpack_require__("7Otq")}})]),_vm._v(" "),_c('b-col',{staticClass:"text-center navbar1",on:{"click":function($event){return _vm.$router.push({ name: 'Home' })}}},[_c('a',[_vm._v("Dashboard")])]),_vm._v(" "),_c('b-col',{staticClass:"navbar2",on:{"click":function($event){return _vm.$router.push({ name: 'NewsEdition' })}}},[_c('a',[_vm._v("Noticias")])]),_vm._v(" "),_c('b-col',{staticClass:"navbar3"},[_c('div',{staticClass:"dropdown"},[_c('span',[_vm._v("Configurações")]),_vm._v(" "),_c('div',{staticClass:"dropdown-content"},[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'SourceMain' })}}},[_vm._v("Fonte")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'ThemeWords' })}}},[_vm._v("Theme Words")])])])]),_vm._v(" "),_c('b-col',{staticClass:"navbar4",on:{"click":function($event){return _vm.$router.push({ name: 'OperationLog' })}}},[_c('a',[_vm._v("Relatorio Logs/Erros")])])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q7A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeWords_vue__ = __webpack_require__("s8eg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b4fa25d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThemeWords_vue__ = __webpack_require__("CKGB");
function injectStyle (ssrContext) {
  __webpack_require__("Jusl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b4fa25d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeWords_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b4fa25d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThemeWords_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qiya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Edit News",

  data: function data() {
    return {
      endpoint: "News",
      newEditArray: []
    };
  },


  props: {
    newsEditId: Number
  },

  components: {},
  watch: {},
  methods: {
    loadData: function loadData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // parse xml to json
                _this.$api.data.endpoint = _this.endpoint;
                _context.next = 3;
                return _this.$api.data.findOneById(_this.newsEditId);

              case 3:
                _this.newEditArray = _context.sent;


                _this.$forceUpdate();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    editedNew: function editedNew(evt) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.data.endpoint = _this2.endpoint;
                _context2.next = 3;
                return _this2.$api.data.updatedById(_this2.newsEditId, _this2.newEditArray);

              case 3:
                _this2.$emit("ok");

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "r4sH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__("+qPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__News_NewsDelete__ = __webpack_require__("sf5t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__News_NewsEdit__ = __webpack_require__("0Z+i");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newsData: [],
      endpoint: "News",
      totalItems: 0,
      newsExtracted: null,
      newsEditId: null,
      currentPage: 1,
      fields: [{
        key: "c_u_IdentificationMethod",
        label: "Extration from"
      }, {
        key: "c_u_Status",
        label: "Status",
        formatter: function formatter(value, key, item) {
          if (value == 1) {
            return value = "News saved but not extracted";
          }
          if (value == 2) {
            return value = "News saved and extracted";
          }
          if (value == 3) {
            return value = "News extraction failure";
          }
        }
      }, {
        key: "c_u_ProcessedDate",
        label: "Processed"
      }, {
        key: "c_u_Source",
        label: "Source",
        formatter: function formatter(value, key, item) {
          return item.sources.c_u_ReferenceSource;
        }
      }, {
        key: "c_u_Title",
        label: "Title"
      }, {
        key: "actions",
        label: "Actions"
      }]
    };
  },

  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["a" /* VueEditor */],
    deleteNews: __WEBPACK_IMPORTED_MODULE_5__News_NewsDelete__["a" /* default */],
    editNews: __WEBPACK_IMPORTED_MODULE_6__News_NewsEdit__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    isLoading: "api/isLoading"
  })),

  methods: {
    getNews: function getNews() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$api.data.endpoint = _this.endpoint;
                _context.next = 3;
                return _this.$api.data.find();

              case 3:
                _this.newsData = _context.sent;

                _this.totalItems = _this.newsData.length;
                _this.$forceUpdate();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    deleteNews: function deleteNews(item) {
      this.newsExtracted = item.c_id;
      this.$forceUpdate();
    },
    editNews: function editNews(item) {
      this.newsEditId = item.c_id;
      this.$forceUpdate();
    },
    toggleDetails: function toggleDetails(data) {
      this.$set(data, "_showDetails", data._showDetails ? false : true);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.getNews();
              _this2.$forceUpdate();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ "s8eg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_chart_js__ = __webpack_require__("ikxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chart_data_js__ = __webpack_require__("UtyK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chart_operation_logs_js__ = __webpack_require__("vMnq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("7+uW");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ThemeWords",

  data: function data() {
    return {
      itemsThemeWords: [],
      endpoint: "ThemeWords",
      endpointVThemes: "VThemes",
      VThemes: [],
      currentPage: 1,
      totalItems: 0,
      optionsThemesView: [],
      optionsThemesFilter: [],
      stringOfThemesFilter: "",
      selectedThemeViewFilter: [],
      selectedThemeView: [],
      stringOfThemes: "",
      stringOfProhibitedThemes: "",
      stringOfProhibitedThemesFilter: "",
      filteredData: [],
      lo: _,
      fieldsThemeWords: [{
        key: "wordName",
        label: "Temática",
        formatter: function formatter(value, key, item) {
          return value;
        }
      }, {
        key: "c_u_Words",
        label: "Palavras"
      }, {
        key: "c_u_ProhibitedWords",
        label: "Palavras Proibida"
      }]
    };
  },


  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_9_vue_select___default.a
  },

  watch: {
    selectedThemeViewFilter: function selectedThemeViewFilter(to, from) {
      if (to != null) {
        this.filteredData = _.filter(this.itemsThemeWords, function (id) {
          return id.c_u_ThemeId == to;
        });
      } else {
        this.filteredData = _.orderBy(this.itemsThemeWords, ["wordName"], ["asc"]);
      }
      this.totalItems = this.filteredData.length;
    },
    stringOfThemesFilter: function stringOfThemesFilter(to, from) {
      if (to != "") {
        this.filteredData = _.filter(this.itemsThemeWords, function (theme) {
          return theme.c_u_Words != "" ? theme.c_u_Words.toLowerCase().indexOf(to.toLowerCase()) > -1 : false;
        });
      } else {
        this.filteredData = _.orderBy(this.itemsThemeWords, ["wordName"], ["asc"]);
      }
      this.totalItems = this.filteredData.length;
    },
    stringOfProhibitedThemesFilter: function stringOfProhibitedThemesFilter(to, from) {
      if (to != "") {
        this.filteredData = _.filter(this.itemsThemeWords, function (theme) {
          return theme.c_u_ProhibitedWords != "" ? theme.c_u_ProhibitedWords.toLowerCase().indexOf(to.toLowerCase()) > -1 : false;
        });
      } else {
        this.filteredData = _.orderBy(this.itemsThemeWords, ["wordName"], ["asc"]);
      }
      this.totalItems = this.filteredData.length;
    }
  },

  methods: {
    autoReloadData: function autoReloadData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showData: function showData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newArrayOfThemes, index, _loop, _index, _loop2, _index2, _index3;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.data.endpoint = _this2.endpoint;
                _context2.next = 3;
                return _this2.$api.data.find();

              case 3:
                _this2.itemsThemeWords = _context2.sent;

                _this2.totalItems = _this2.itemsThemeWords.length;
                _this2.$api.data.endpoint = _this2.endpointVThemes;
                _context2.next = 8;
                return _this2.$api.data.find();

              case 8:
                _this2.VThemes = _context2.sent;
                newArrayOfThemes = _this2.VThemes;
                //For to themes in filter

                _this2.optionsThemesFilter = [];
                for (index = 0; index < _this2.VThemes.length; index++) {
                  __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(_this2.optionsThemesFilter, index, {
                    item: _this2.VThemes[index].wordName,
                    code: _this2.VThemes[index].id
                  });
                }

                _loop = function _loop(_index) {
                  var id = _this2.itemsThemeWords[_index].c_u_ThemeId;
                  var thm = _.find(_this2.VThemes, function (o) {
                    return o.id == id;
                  });
                  _this2.itemsThemeWords[_index] = {
                    c_id: _this2.itemsThemeWords[_index].c_id,
                    c_u_ThemeId: _this2.itemsThemeWords[_index].c_u_ThemeId,
                    c_u_Words: _this2.itemsThemeWords[_index].c_u_Words,
                    c_u_ProhibitedWords: _this2.itemsThemeWords[_index].c_u_ProhibitedWords,
                    wordName: thm == undefined ? thm : thm.wordName
                  };
                };

                for (_index = 0; _index < _this2.itemsThemeWords.length; _index++) {
                  _loop(_index);
                }
                _.remove(_this2.itemsThemeWords, function (n) {
                  return n.wordName == undefined;
                });
                _this2.filteredData = _this2.itemsThemeWords;
                // for to have items in dropdown of create theme

                _loop2 = function _loop2(_index2) {
                  var id = _this2.itemsThemeWords[_index2].c_u_ThemeId;
                  _.remove(newArrayOfThemes, function (n) {
                    return n.id == id;
                  });
                };

                for (_index2 = 0; _index2 < _this2.itemsThemeWords.length; _index2++) {
                  _loop2(_index2);
                }
                if (newArrayOfThemes.length > 0) {
                  for (_index3 = 0; _index3 < newArrayOfThemes.length; _index3++) {
                    __WEBPACK_IMPORTED_MODULE_10_vue__["default"].set(_this2.optionsThemesView, _index3, {
                      item: newArrayOfThemes[_index3].wordName,
                      code: newArrayOfThemes[_index3].id
                    });
                  }
                }

                _this2.filteredData = _.orderBy(_this2.filteredData, ["wordName"], ["asc"]);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    toggleDetails: function toggleDetails(data) {
      this.$set(data, "_showDetails", data._showDetails ? false : true);
    },
    editThemWords: function editThemWords(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var editedTheme;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                editedTheme = {
                  c_id: item.c_id,
                  c_u_ThemeId: item.c_u_ThemeId,
                  c_u_Words: item.c_u_Words,
                  c_u_ProhibitedWords: item.c_u_ProhibitedWords
                };

                _this3.$api.data.endpoint = _this3.endpoint;
                _context3.next = 4;
                return _this3.$api.data.updatedById(item.c_id, editedTheme);

              case 4:
                item._showDetails = false;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    createNewTheme: function createNewTheme(theme, string, stringProhibited) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var newObjectTheme, result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!((typeof theme === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(theme)) != "object")) {
                  _context4.next = 9;
                  break;
                }

                newObjectTheme = { c_u_ThemeId: theme, c_u_Words: string, c_u_ProhibitedWords: stringProhibited };

                _this4.$api.data.endpoint = _this4.endpoint;
                _context4.next = 5;
                return _this4.$api.data.create2(newObjectTheme);

              case 5:
                result = _context4.sent;

                if (result == "Theme Word criada com sucesso") {
                  _this4.$bvToast.toast("Temática adicionada com sucesso", {
                    autoHideDelay: 4000,
                    variant: "success"
                  });
                  //this.showData();//does not refresh the select
                  setTimeout(function () {
                    window.location.reload();
                  }, 1000);
                }
                _context4.next = 10;
                break;

              case 9:
                _this4.$bvToast.toast("Necessario preencher campos!", {
                  autoHideDelay: 4000,
                  variant: "danger"
                });

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({})),

  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this5.showData();

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ "sf5t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsDelete_vue__ = __webpack_require__("Zj8k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8e34436_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsDelete_vue__ = __webpack_require__("/FOX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8e34436_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uVR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sourceMain"},[_c('b-row',{staticClass:"sourceMainSections"},[_c('b-col',{staticClass:"sectionsFilters",attrs:{"sm":"2"}},[_c('b-col',{staticClass:"filters"},[_c('p',[_vm._v("Filtros")])]),_vm._v(" "),_c('b-col',{staticClass:"section1"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Fonte")])]),_vm._v(" "),_c('b-col',[_c('v-select',{staticClass:"filtersSelect",attrs:{"options":_vm.optionsSource,"label":"source","reduce":function (source) { return source.id; }},model:{value:(_vm.sourceId),callback:function ($$v) {_vm.sourceId=$$v},expression:"sourceId"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Estado")])]),_vm._v(" "),_c('b-col',[_c('v-select',{staticClass:"filtersSelect",attrs:{"options":_vm.optionStatus,"label":"status","reduce":function (status) { return status.code; }},model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Severidade")])]),_vm._v(" "),_c('b-col',[_c('v-select',{staticClass:"filtersSelect",attrs:{"options":_vm.optionsSeverity,"label":"type","reduce":function (type) { return type.id; }},model:{value:(_vm.selectedSeverity),callback:function ($$v) {_vm.selectedSeverity=$$v},expression:"selectedSeverity"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Execução")])]),_vm._v(" "),_c('b-col',[_c('v-select',{staticClass:"filtersSelect",attrs:{"options":_vm.optionExecution,"label":"type","reduce":function (type) { return type.id; }},model:{value:(_vm.selectedExecution),callback:function ($$v) {_vm.selectedExecution=$$v},expression:"selectedExecution"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Data de Inicio")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"date","size":"sm"},model:{value:(_vm.startDateOfLog),callback:function ($$v) {_vm.startDateOfLog=$$v},expression:"startDateOfLog"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"filtersTitle"},[_vm._v("Data de Fim")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"date","size":"sm"},model:{value:(_vm.endDateLog),callback:function ($$v) {_vm.endDateLog=$$v},expression:"endDateLog"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"filterButton"},[_c('b-button',{staticClass:"btnFilterClear",on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("Limpar")])],1),_vm._v(" "),_c('b-col',{staticClass:"filterButton"},[_c('b-button',{staticClass:"btnFilter",on:{"click":function($event){return _vm.filterLogInfo()}}},[_vm._v("Pesquisar")])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"sectionOperation",attrs:{"sm":"5"}},[_c('b-col',{staticClass:"section1Title"},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left"}},[_vm._v("Operation Logs")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"section2",attrs:{"id":"section2"},on:{"&scroll":function($event){return _vm.handleScrolll($event)}}},_vm._l((_vm.filteredLogs),function(log){return _c('b-col',{key:log.c_id,staticClass:"section2Source",on:{"click":function($event){return _vm.openSection3(log.c_id)}}},[(log.c_u_Status == 1)?_c('b-row',{staticClass:"section2Log"},[_c('b-col',{staticClass:"section2LogText"},[_c('h6',[_vm._v("\n                    "+_vm._s(new Date(log.c_u_Date).getDate())+"/"+_vm._s(new Date(log.c_u_Date).getMonth() + 1)+"/"+_vm._s(new Date(log.c_u_Date).getFullYear())+" às\n                    "+_vm._s(new Date(log.c_u_Date).getHours() < 10
                        ? "0" + new Date(log.c_u_Date).getHours()
                        : new Date(log.c_u_Date).getHours())+":"+_vm._s(new Date(log.c_u_Date).getMinutes() < 10
                        ? "0" + new Date(log.c_u_Date).getMinutes()
                        : new Date(log.c_u_Date).getMinutes())+"\n                    "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Resultado:")]),_vm._v("\n                    "+_vm._s(log.c_u_Result)+"\n                  ")])])],1):_vm._e(),_vm._v(" "),(log.c_u_Status == -1)?_c('b-row',{staticClass:"section2Error"},[_c('b-col',{staticClass:"section2LogText"},[_c('h6',[_vm._v("\n                    "+_vm._s(new Date(log.c_u_Date).getDate())+"/"+_vm._s(new Date(log.c_u_Date).getMonth() + 1)+"/"+_vm._s(new Date(log.c_u_Date).getFullYear())+" às\n                    "+_vm._s(new Date(log.c_u_Date).getHours() < 10
                        ? "0" + new Date(log.c_u_Date).getHours()
                        : new Date(log.c_u_Date).getHours())+":"+_vm._s(new Date(log.c_u_Date).getMinutes() < 10
                        ? "0" + new Date(log.c_u_Date).getMinutes()
                        : new Date(log.c_u_Date).getMinutes())+"\n                    "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Resultado:")]),_vm._v("\n                    "+_vm._s(log.c_u_Result)+"\n                  ")])])],1):_vm._e()],1)}),1)],1),_vm._v(" "),(_vm.section3)?_c('b-col',{staticClass:"section3",attrs:{"sm":"5"}},[_c('b-col',{staticClass:"section3Reference"},[_c('p',[_vm._v("Detalhes")])]),_vm._v(" "),_c('b-col',[(_vm.clickedLogs.c_r_Source != null)?_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelLog",attrs:{"sm":"2"}},[_c('label',[_vm._v("Ref Fonte")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v(_vm._s(_vm.lo.find(this.sourcesArray, function (src) {
                  return src.c_id == _vm.clickedLogs.c_r_Source;
                }).c_u_ReferenceSource))])],1):_vm._e()],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelLog",attrs:{"sm":"2"}},[_c('label',[_vm._v("Severidade")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v(_vm._s(_vm.lo.filter(_vm.optionsSeverity, function (log) {
                  return log.id == _vm.clickedLogs.c_u_Severity;
                })[0].type))])],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelLog",attrs:{"sm":"2"}},[_c('label',[_vm._v("Execução")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v(_vm._s(_vm.executionType != []
                  ? _vm.executionType.c_u_Type == 1
                    ? "Get Execution"
                    : "Extract Execution"
                  : "-"))])],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelLog",attrs:{"sm":"2"}},[_c('label',[_vm._v("Estado")])]),_vm._v(" "),(_vm.clickedLogs.c_u_Status == 1)?_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v("Sucesso")]):_vm._e(),_vm._v(" "),(_vm.clickedLogs.c_u_Status == -1)?_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v("Erro")]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelLog",attrs:{"sm":"2"}},[_c('label',[_vm._v("Tipo ID")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v(_vm._s(_vm.clickedLogs.c_u_EventTypeID))])],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelLog",attrs:{"sm":"2"}},[_c('label',[_vm._v("Data")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v(_vm._s(new Date(_vm.clickedLogs.c_u_Date).getFullYear())+"/"+_vm._s(new Date(_vm.clickedLogs.c_u_Date).getMonth())+"/"+_vm._s(new Date(_vm.clickedLogs.c_u_Date).getDate())+"\n                "+_vm._s(new Date(_vm.clickedLogs.c_u_Date).getHours())+":"+_vm._s(new Date(_vm.clickedLogs.c_u_Date).getMinutes())+":"+_vm._s(new Date(_vm.clickedLogs.c_u_Date).getSeconds()))])],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticClass:"labelLog",attrs:{"sm":"2"}},[_c('label',[_vm._v("Descriçao")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v(_vm._s(_vm.clickedLogs.c_u_Description))])],1)],1),_vm._v(" "),_c('b-col',[_c('b-row',[_c('b-col',{staticClass:"labelLog",attrs:{"sm":"2"}},[_c('label',[_vm._v("Resultado")])]),_vm._v(" "),_c('b-col',{staticClass:"referenceName",attrs:{"sm":"10"}},[_vm._v(_vm._s(_vm.clickedLogs.c_u_Result))])],1)],1)],1):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vMnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export operationLogsChart */
var operationLogsChart = {
  type: 'line',
  data: {
    labels: [],
    datasets: [{ // another line graph
      label: 'Total de logs nos ultimos 7 dias',
      data: [],
      borderColor: 'rgba(50, 115, 220, 0.5)',
      backgroundColor: 'rgba(50, 115, 220, 0.1)',
      borderWidth: 3
    }, { // another line graph
      label: 'Total de erros nos ultimos 7 dias',
      data: [],
      borderColor: 'rgba(255, 56, 96, 0.5)',
      backgroundColor: 'rgba(255, 56, 96, 0.1)',
      borderWidth: 3
    }]
  },
  options: {
    responsive: true,
    lineTension: 1,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          padding: 25
        }
      }]
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (operationLogsChart);

/***/ }),

/***/ "var0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid",staticStyle:{"margin-top":"20px"}},[_c('b-table',{attrs:{"striped":"","hover":"","busy":_vm.isLoading,"items":_vm.newsData,"fields":_vm.fields,"small":"","fixed":"","caption-top":"","outlined":"","per-page":5,"current-page":_vm.currentPage},on:{"row-dblclicked":_vm.toggleDetails},scopedSlots:_vm._u([{key:"cell(actions)",fn:function(data){return [_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.editNews",modifiers:{"editNews":true}}],attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){return _vm.editNews(data.item)}}},[_c('fa',{attrs:{"icon":"edit","size":"sm"}}),_vm._v("Edit\n        ")],1),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.deleteNews",modifiers:{"deleteNews":true}}],attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){return _vm.deleteNews(data.item)}}},[_c('fa',{attrs:{"icon":"trash","size":"sm"}})],1)]}},{key:"row-details",fn:function(){return [_c('p',[_vm._v("restantes dados")])]},proxy:true}])})],1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-pagination',{attrs:{"total-rows":_vm.totalItems,"per-page":5,"align":"center"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('deleteNews',{attrs:{"newsExtracted":_vm.newsExtracted},on:{"ok":function($event){return _vm.getNews()}}}),_vm._v(" "),_c('editNews',{attrs:{"newsEditId":_vm.newsEditId},on:{"ok":function($event){return _vm.getNews()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wSLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsEdition_vue__ = __webpack_require__("L+B5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320c51d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsEdition_vue__ = __webpack_require__("3qhe");
function injectStyle (ssrContext) {
  __webpack_require__("zgG3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-320c51d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsEdition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320c51d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsEdition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__("Usg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      fullPage: true
    };
  },


  methods: {
    logout: function logout() {
      this.$api.logout();
    },
    isNotInConfig: function isNotInConfig() {
      if (this.$router.history.current["path"] != "/NewsEdition") {
        document.body.style = "overflow-y:scroll";
        return true;
      } else {
        document.body.style = "overflow-y: hidden";
        return false;
      }
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    getUsername: "auth/getUsername",
    isLoggedIn: "auth/isLoggedIn",
    isLoading: "api/isLoading",
    getUserId: "auth/getUserId"
  })),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* EventBus */].$on("api_error", function (err) {
                _this.$bvToast.toast("" + err, {
                  autoHideDelay: 4000,
                  variant: "danger"
                });
              });
              __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* EventBus */].$on("api_success", function (res) {
                _this.$bvToast.toast("" + res, {
                  autoHideDelay: 4000,
                  variant: "success"
                });
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de875562_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("SHpU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de875562_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yexb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CreateRss",

  data: function data() {
    return {
      clicked: 1,
      addDivTitle: 2,
      addDivResume: 1,
      addDivImage: 1,
      addDivText: 1,
      addDivRemove: 1,
      isSimple: true,
      isSimple2: true,
      disabled: true,
      document: __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document),
      urlParameters1: "",
      advancedXML: "",
      advancedXML2: "",
      urlArray: [{
        url: "",
        priority: 0
      }],
      titleArray: [{
        query: "//meta[@property='og:title']/@content",
        confidenceLevel: 30
      }, {
        query: "//title",
        confidenceLevel: 20
      }],
      resumeArray: [{
        query: "//meta[@property='og:description']/@content",
        confidenceLevel: 30
      }],
      imageArray: [{
        query: "//meta[@property='og:image']/@content",
        confidenceLevel: 30
      }],
      textArray: [{
        query: "",
        confidenceLevel: 0
      }],
      removeArray: [{
        reference: 0,
        query: ""
      }],
      SourceRss: {
        c_u_Type: 1,
        c_u_Status: 0,
        c_u_Regularity: 0,
        c_u_ReferenceSource: "",
        c_u_Parameters1: "",
        c_u_Parameters2: ""
      },
      priorityOptions: [{ value: "0", text: "Please select a priority" }, { value: "30", text: "High" }, { value: "20", text: "Medium" }, { value: "10", text: "Low" }],
      statusOptions: [{ value: "0", text: "Please select a status" }, { value: "1", text: "Enabled" }, { value: "2", text: "Disabled" }],
      regularityOptions: [{ value: "0", text: "Please select a regularity" }, { value: "10", text: "10 Minutos" }, { value: "20", text: "20 Minutos" }, { value: "30", text: "30 Minutos" }, { value: "40", text: "40 Minutos" }, { value: "50", text: "50 Minutos" }, { value: "60", text: "60 Minutos" }],
      confidenceOptions: [{ value: "0", text: "Please select a priority" }, { value: "30", text: "High" }, { value: "20", text: "Medium" }, { value: "10", text: "Low" }],
      removeOptions: [{ value: "0", text: "Please select a Reference" }, { value: "title", text: "Title" }, { value: "resume", text: "Resume" }, { value: "image", text: "Image" }, { value: "text", text: "Text" }]
    };
  },


  components: {},

  methods: {
    resetFields: function resetFields() {
      this.referenceSource = "";
      this.urlArray = [{
        url: "",
        priority: 0
      }];
      this.clicked = 1;
      this.isSimple = true;
      this.urlParameters1 = "";
    },
    createXml2: function createXml2(evt) {
      var xml = __webpack_require__("K7uN");
      // structur of the xml for the parameters2
      var xml2 = [{
        Configuration: [{ _attr: { for: "News" } }, { URLs: "" }, {
          ToExtract: [{
            Item: [{ _attr: { ForURLsID: "", Reference: "title" } }, { Queries: [] }, { URL: [] }]
          }, {
            Item: [{ _attr: { ForURLsID: "", Reference: "resume" } }, { Queries: [] }, { URL: [] }]
          }, {
            Item: [{ _attr: { ForURLsID: "", Reference: "image" } }, { Queries: [] }, { URL: [] }]
          }, {
            Item: [{ _attr: { ForURLsID: "", Reference: "text" } }, { Queries: [] }, { URL: [] }]
          }]
        }, { ToRemove: [] }]
      }];

      //for loop to create the queries of title in the xml
      for (var index = 0; index < this.titleArray.length; index++) {
        xml2[0].Configuration[2].ToExtract[0].Item[1].Queries.push({
          Query: [{
            _attr: {
              Id: index + 1,
              ConfidenceLevel: this.titleArray[index].confidenceLevel,
              IsURL: "false",
              IsFullURL: "false",
              ToReplace: "",
              PrepareTextForQS: "false"
            }
          }, this.titleArray[index].query]
        });
      }

      //for loop to create the queries of resume in the xml
      for (var index = 0; index < this.resumeArray.length; index++) {
        xml2[0].Configuration[2].ToExtract[1].Item[1].Queries.push({
          Query: [{
            _attr: {
              Id: index + 1,
              ConfidenceLevel: this.resumeArray[index].confidenceLevel,
              IsURL: "false",
              IsFullURL: "false",
              ToReplace: "",
              PrepareTextForQS: "false"
            }
          }, this.resumeArray[index].query]
        });
      }

      //for loop to create the queries of image in the xml
      for (var index = 0; index < this.imageArray.length; index++) {
        xml2[0].Configuration[2].ToExtract[2].Item[1].Queries.push({
          Query: [{
            _attr: {
              Id: index + 1,
              ConfidenceLevel: this.imageArray[index].confidenceLevel,
              IsURL: "true",
              IsFullURL: "true",
              ToReplace: "",
              PrepareTextForQS: "false"
            }
          }, this.imageArray[index].query]
        });
      }

      //for loop to create the queries of text in the xml
      for (var index = 0; index < this.textArray.length; index++) {
        xml2[0].Configuration[2].ToExtract[3].Item[1].Queries.push({
          Query: [{
            _attr: {
              Id: index + 1,
              ConfidenceLevel: this.textArray[index].confidenceLevel,
              IsURL: "false",
              IsFullURL: "false",
              ToReplace: "",
              PrepareTextForQS: "false"
            }
          }, this.textArray[index].query]
        });
      }
      // for loop to create the queries of remove in the xml
      for (var index = 0; index < this.removeArray.length; index++) {
        xml2[0].Configuration[3].ToRemove.push({
          Item: [{
            _attr: {
              ForURLsId: "",
              Reference: this.removeArray[index].reference
            }
          }, {
            Queries: [{
              Query: [{
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: 0,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace: "",
                  PrepareTextForQS: "false"
                }
              }, this.removeArray[index].query]
            }]
          }]
        });
      }

      this.SourceRss.c_u_Parameters2 = xml(xml2, {
        declaration: { version: "1.0", encoding: "UTF-8", standalone: "no" }
      });
    },
    createUrlSouce: function createUrlSouce(evt) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var xml, indexUrls, queryIndex, xml1, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.isSimple) {
                  // create the xml for the source
                  xml = __webpack_require__("K7uN");
                  indexUrls = [];
                  queryIndex = 1;
                  //structure for the parameters1 xml

                  xml1 = [{
                    Configuration: [{ _attr: { for: "List" } }, { URLs: [] }, { ToExtract: [] }, { ToRemove: "" }]
                  }];
                  // for loop to create the url queries in the xml

                  for (index = 0; index < _this.urlArray.length; index++) {
                    xml1[0].Configuration[1].URLs.push({
                      URL: [{
                        _attr: {
                          Id: index + 1,
                          Priority: _this.urlArray[index].priority
                        }
                      }, _this.urlArray[index].url]
                    });
                    indexUrls[index] = index + 1;
                  }
                  xml1[0].Configuration[2].ToExtract.push({
                    Item: [{ _attr: { ForURLsID: indexUrls.join(",") } }, {
                      Queries: [{
                        Query: [{
                          _attr: {
                            Id: queryIndex,
                            ConfidenceLevel: "0",
                            IsURL: "true",
                            IsFullURL: "true",
                            ToReplace: "",
                            PrepareTextForQS: "false"
                          }
                        }, _this.urlParameters1 + "/@href"]
                      }, {
                        URL: ""
                      }]
                    }]
                  });

                  _this.SourceRss.c_u_Parameters1 = xml(xml1, {
                    declaration: { version: "1.0", encoding: "UTF-8", standalone: "no" }
                  });
                } else {
                  _this.SourceRss.c_u_Parameters1 = _this.advancedXML;
                }

                _context.next = 3;
                return _this.$api.data.create(_this.SourceRss);

              case 3:

                _this.$emit("ok");

                //remove the values from the modal
                _this.referenceSource = "";

                _this.urlArray = [{
                  url: "",
                  priority: 0
                }];
                _this.clicked = 1;
                _this.isSimple = true;
                _this.urlParameters1 = "";

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addTitleDiv: function addTitleDiv(evt) {
      this.addDivTitle++;
      this.titleArray[this.addDivTitle - 1] = { query: "", confidenceLevel: 0 };
    },
    addResumeDiv: function addResumeDiv(evt) {
      this.addDivResume++;
      this.resumeArray[this.addDivResume - 1] = {
        query: "",
        confidenceLevel: 0
      };
    },
    addImageDiv: function addImageDiv(evt) {
      this.addDivImage++;
      this.imageArray[this.addDivImage - 1] = { query: "", confidenceLevel: 0 };
    },
    addTextDiv: function addTextDiv(evt) {
      this.addDivText++;
      this.textArray[this.addDivText - 1] = { query: "", confidenceLevel: 0 };
    },
    addUrlDiv: function addUrlDiv(evt) {
      this.clicked++;
      this.urlArray[this.clicked - 1] = { url: "", priority: 0 };
    },
    addRemoveDiv: function addRemoveDiv(evt) {
      this.addDivRemove++;
      this.removeArray[this.addDivRemove - 1] = { reference: 0, query: "" };
    },
    advancedMode: function advancedMode(evt) {
      if (this.isSimple == true) {
        this.advancedXML = '<?xml version="1.0" encoding="utf-8" standalone="no"?>' + "\n";
        document.getElementsByClassName("advance")[0].innerText = "Simple Mode";
        this.isSimple = false;
      } else {
        document.getElementsByClassName("advance")[0].innerText = "Advanced Mode";
        this.isSimple = true;
      }
    },
    advancedMode2: function advancedMode2(evt) {
      if (this.isSimple2 == true) {
        this.advancedXML2 = '<?xml version="1.0" encoding="utf-8" standalone="no"?>' + "\n";
        document.getElementsByClassName("advance2")[0].innerText = "Simple Mode";
        this.isSimple2 = false;
      } else {
        document.getElementsByClassName("advance2")[0].innerText = "Advanced Mode";
        this.isSimple2 = true;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "zgG3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c81ad0a2c6375886ecf3.js